// Code generated by models2ts. DO NOT EDIT.
// no touchy por favor
/* eslint-disable @typescript-eslint/no-deprecated */

// go/v2/addresses.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface Address {
    id?: string;
    fullName?: string;
    organization?: string;
    addressLine1?: string;
    addressLine2?: string;
    city?: string;
    stateID?: StateID;
    postalCode?: string;
    countryID?: CountryID;
    phoneNumberID?: string;
    emailAddressID?: string;
    createdByUserID?: string;
    created?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
    phoneNumber?: PhoneNumber;
    emailAddress?: EmailAddress;
    country?: Country;
    state?: State;
    createdBy?: User;
    rowCreatedBy?: User;
}

// go/v2/adminroles.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface AdminRole {
    id?: AdminRoleID;
    name?: string;
    permissions?: string[];
    active?: boolean;
    created?: string;
    updated?: string;
}
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const AdminRoleID = {
    ADMIN_ROLES_ARTIST: 1,
    ADMIN_ROLES_SALES: 2,
    ADMIN_ROLES_FACTORY: 3,
    ADMIN_ROLES_IAP: 4,
    ADMIN_ROLES_MANAGER: 5,
    ADMIN_ROLES_DEVELOPER: 6,
    ADMIN_ROLES_MARKETING: 9,
    ADMIN_ROLES_ART_DIRECTOR: 13,
    ADMIN_ROLES_COMMISSIONED: 17,
    ADMIN_ROLES_SMG_FACTORY: 21,
    ADMIN_ROLES_QUOTE_BIDDER: 23,
    ADMIN_ROLES_FACTORY_COMMUNICATIONS: 24,
    ADMIN_ROLES_ARTIST_STAT_VIEWER: 25,
    ADMIN_ROLES_SMG_PACKING_AND_SHIPPING: 27,
    ADMIN_ROLES_FACTORY_MANAGER: 28,
    ADMIN_ROLES_OUTSIDE_MARKETING: 29,
    ADMIN_ROLES_ZAPIER: 30,
    ADMIN_ROLES_QUOTE_REQUEST_DL: 31,
    ADMIN_ROLES_SALES_DIRECTOR: 32,
    ADMIN_ROLES_AI_AGENT: 33,
    ADMIN_ROLES_AI_OPERATOR: 34,
    ADMIN_ROLES_ACCOUNTING: 35,
    ADMIN_ROLES_FACTORY_LABEL_PRINTING: 36,
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type AdminRoleID = typeof AdminRoleID[keyof typeof AdminRoleID];

// go/v2/artistrewards.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface ArtistReward {
    id?: string;
    userID?: string;
    orderLineItemID?: string;
    points?: string;
    salesOverride?: boolean;
    noTasks?: boolean;
    orderID?: string;
    orderPending?: boolean;
    orderPendingUpdated?: string;
    updatedByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    user?: User;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface OrderArtistRewardsMod {
    salesOverride: boolean;
    noTasks: boolean;
    artists: OrderArtistRewardShare[];
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface OrderArtistRewardShare {
    userID: string;
    share: string;
}

// go/v2/artistrewardtransfers.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface ArtistRewardTransfer {
    id?: string;
    batchID?: string;
    orderID?: string;
    userID?: string;
    total: string;
    memo?: string;
    createdByUserID?: string;
    created?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
}

// go/v2/artwork.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface Artwork {
    id?: string;
    artworkGroupID?: string;
    name?: string;
    description?: string;
    hdPath?: string;
    originalPath?: string;
    originalHDPath?: string;
    path?: string;
    thumbPath?: string;
    sortOrder?: number;
    size?: number;
    width?: number;
    height?: number;
    tags?: string[];
    lineItemData?: unknown;
    created?: string;
    updated?: string;
}

// go/v2/artworkgorups.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface ArtworkGroup {
    artworkGroupID?: string;
    companyID?: string;
    name?: string;
    description?: string;
    tags?: string[];
    width?: number;
    height?: number;
    backgroundColor?: string;
    svgReColor?: string;
    quality?: number;
    webPQuality?: number;
    av1Quality?: number;
    open?: boolean;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    company?: Realm;
    createdBy?: User;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface LegacyArtworkGroup {
    id?: string;
    companyID?: string;
    name?: string;
    description?: string;
    active?: number;
    gallery?: number;
    width?: number;
    height?: number;
    compression?: number;
    backgroundColor?: string;
    created?: string;
}

// go/v2/artworkgroupimages.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface ArtworkGroupImage {
    id?: string;
    artworkGroupID?: string;
    imageID?: string;
    name?: string;
    description?: string;
    url?: string;
    tags?: string[];
    groupTags?: string[];
    width?: number;
    height?: number;
    backgroundColor?: string;
    svgReColor?: string;
    quality?: number;
    webPQuality?: number;
    av1Quality?: number;
    format?: string;
    lineItemData?: {
        lineItemID?: string;
        lineItemTypeID?: string;
        lineItemTypeSizeID?: string;
        childLineItemData?: {
            childLineItemID?: string;
            childLineItemOptionID?: string;
        };
    };
    sortOrder?: number;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    artworkGroup?: ArtworkGroup;
    image?: Image;
    createdBy?: User;
}

// go/v2/assistant.go
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const AssistantVerbosity = {
    ASSISTANT_VERBOSITY_LOW: 'low',
    ASSISTANT_VERBOSITY_MEDIUM: 'medium',
    ASSISTANT_VERBOSITY_HIGH: 'high',
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type AssistantVerbosity = typeof AssistantVerbosity[keyof typeof AssistantVerbosity];
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const AssistantReasoning = {
    ASSISTANT_REASONING_NONE: 'none',
    ASSISTANT_REASONING_MINIMAL: 'minimal',
    ASSISTANT_REASONING_LOW: 'low',
    ASSISTANT_REASONING_MEDIUM: 'medium',
    ASSISTANT_REASONING_HIGH: 'high',
    ASSISTANT_REASONING_X_HIGH: 'xhigh',
    ASSISTANT_REASONING_MAX: 'max',
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type AssistantReasoning = typeof AssistantReasoning[keyof typeof AssistantReasoning];
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const AssistantImageAspectRatio = {
    ASSISTANT_IMAGE_ASPECT_RATIO_AUTO: '',
    ASSISTANT_IMAGE_ASPECT_RATIO_1_X_1: '1:1',
    ASSISTANT_IMAGE_ASPECT_RATIO_3_X_2: '3:2',
    ASSISTANT_IMAGE_ASPECT_RATIO_2_X_3: '2:3',
    ASSISTANT_IMAGE_ASPECT_RATIO_3_X_4: '3:4',
    ASSISTANT_IMAGE_ASPECT_RATIO_4_X_3: '4:3',
    ASSISTANT_IMAGE_ASPECT_RATIO_4_X_5: '4:5',
    ASSISTANT_IMAGE_ASPECT_RATIO_5_X_4: '5:4',
    ASSISTANT_IMAGE_ASPECT_RATIO_9_X_16: '9:16',
    ASSISTANT_IMAGE_ASPECT_RATIO_16_X_9: '16:9',
    ASSISTANT_IMAGE_ASPECT_RATIO_21_X_9: '21:9',
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type AssistantImageAspectRatio = typeof AssistantImageAspectRatio[keyof typeof AssistantImageAspectRatio];
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const AssistantImageSize = {
    ASSISTANT_IMAGE_SIZE_AUTO: '',
    ASSISTANT_IMAGE_SIZE_1_K: '1K',
    ASSISTANT_IMAGE_SIZE_2_K: '2K',
    ASSISTANT_IMAGE_SIZE_4_K: '4K',
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type AssistantImageSize = typeof AssistantImageSize[keyof typeof AssistantImageSize];
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const AssistantImageQuality = {
    ASSISTANT_IMAGE_QUALITY_AUTO: '',
    ASSISTANT_IMAGE_QUALITY_LOW: 'low',
    ASSISTANT_IMAGE_QUALITY_MEDIUM: 'medium',
    ASSISTANT_IMAGE_QUALITY_HIGH: 'high',
    ASSISTANT_IMAGE_QUALITY_X_HIGH: 'xhigh',
    ASSISTANT_IMAGE_QUALITY_MAX: 'max',
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type AssistantImageQuality = typeof AssistantImageQuality[keyof typeof AssistantImageQuality];
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const AssistantImageBackground = {
    ASSISTANT_IMAGE_BACKGROUND_AUTO: '',
    ASSISTANT_IMAGE_BACKGROUND_TRANSPARENT: 'transparent',
    ASSISTANT_IMAGE_BACKGROUND_OPAQUE: 'opaque',
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type AssistantImageBackground = typeof AssistantImageBackground[keyof typeof AssistantImageBackground];
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const AssistantBlockType = {
    ASSISTANT_BLOCK_TYPE_NONE: '',
    ASSISTANT_BLOCK_TYPE_DEVELOPER: 'developer',
    ASSISTANT_BLOCK_TYPE_USER: 'user',
    ASSISTANT_BLOCK_TYPE_ASSISTANT: 'assistant',
    ASSISTANT_BLOCK_TYPE_REASONING: 'reasoning',
    ASSISTANT_BLOCK_TYPE_MCP_CALL: 'mcp_call',
    ASSISTANT_BLOCK_TYPE_SCHEMA: 'schema',
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type AssistantBlockType = typeof AssistantBlockType[keyof typeof AssistantBlockType];
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface AssistantBlockMCPCall {
    id?: string;
    name?: string;
    serverLabel?: string;
    arguments?: string;
    status?: string;
    output?: string;
    error?: string;
    approvalRequestID?: string;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface AssistantBlock {
    id?: string;
    role?: AssistantBlockType;
    text?: string[];
    imageURLs?: string[];
    uploadIDs?: number[];
    mcpCall?: AssistantBlockMCPCall;
    schema?: Record<string, unknown>;
    openAIReasoningSignature?: string;
    googleThoughtSignature?: string;
    imageThoughtSignatures?: string[];
    anthropicMessages?: string;
    anthropicCallID?: string;
    model?: string;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface AssistantResponseIDs {
    openAIResponseID?: string;
    xAIResponseID?: string;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface AssistantUsage {
    inputTokens?: number;
    cacheReadTokens?: number;
    cacheWriteTokens?: number;
    outputTokens?: number;
    reasoningTokens?: number;
    webSearchRequests?: number;
    costUSD?: string;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface AssistantResponse {
    blocks?: AssistantBlock[];
    responseIDs?: AssistantResponseIDs;
    structuredOutputRaw?: string;
    result?: unknown;
    usage?: AssistantUsage;
    usageByModel?: Record<string, AssistantUsage>;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface AssistantRequest {
    model?: string;
    fallbackModels?: string[];
    prompt?: string;
    imageURLs?: string[];
    uploadIDs?: number[];
    requireImages?: boolean;
    resultInto?: unknown;
    resultSchema?: unknown;
    blocks?: AssistantBlock[];
    requireToolCalls?: string[];
    runAs?: string;
    resourceCompanyID?: string;
    iapTools?: string[];
    dryRun?: boolean;
    groundWithMaps?: boolean;
    webSearch?: boolean;
    responseIDs?: AssistantResponseIDs;
    temperature?: number;
    topP?: number;
    maxTokens?: number;
    verbosity?: AssistantVerbosity;
    reasoning?: AssistantReasoning;
    advisorModel?: string;
    imageAspectRatio?: AssistantImageAspectRatio;
    imageSize?: AssistantImageSize;
    imageQuality?: AssistantImageQuality;
    imageBackground?: AssistantImageBackground;
    newUploadTags?: string[];
    newUploadName?: string;
    systemPromptTemplate?: string;
    disableSystemPrompt?: boolean;
    systemPrompt?: string;
    systemPromptSuffix?: string;
    systemPromptSuffixPrompts?: string[];
    referencedPrompts?: string[];
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface AssistantModelInfo {
    name: string;
    displayName?: string;
    description?: string;
    supportsReasoning: boolean;
    supportedReasoningEfforts?: AssistantReasoning[];
    supportsVerbosity: boolean;
    supportsTemperature: boolean;
    supportsImageGeneration: boolean;
    supportedImageSizes?: AssistantImageSize[];
    supportsTransparentBackground: boolean;
    deprecated?: boolean;
    tier?: number;
    inputCost?: number;
    outputCost?: number;
    longContextFromTokens?: number;
    longContextInputCost?: number;
    longContextOutputCost?: number;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface AssistantModelsResponse {
    models: AssistantModelInfo[];
    aliases?: Record<string, string>;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface AssistantToolInfo {
    name: string;
    description?: string;
    readOnly: boolean;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface AssistantToolsResponse {
    tools: AssistantToolInfo[];
}

// go/v2/blanks.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface Blank {
    id?: string;
    factoryID?: FactoryID;
    lineItemID?: LineItemID;
    name?: string;
    current?: number;
    pending?: number;
    sold?: number;
    type?: BlankType;
    backgroundColor?: string;
    finish?: string;
    vendor?: string;
    baseMetal?: string;
    memo?: string;
    sortOrder?: number;
    createdByUserID?: string;
    updatedByUserID?: string;
    created?: string;
    validFrom?: string;
    validUntil?: string;
    version?: number;
    latest?: boolean;
    factory?: Factory;
    lineItem?: LineItem;
    createdBy?: User;
    updatedBy?: User;
}
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const BlankType = {
    BLANK_TYPE_BLANK: 'BLANK',
    BLANK_TYPE_MATERIAL: 'MATERIAL',
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type BlankType = typeof BlankType[keyof typeof BlankType];

// go/v2/blogposts.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface BlogPost {
    id?: string;
    companyID?: string;
    uploadID?: number;
    title?: string;
    author?: string;
    url?: string;
    slug?: string;
    aliases?: string[];
    html?: string;
    markdown?: string;
    published?: boolean;
    unpublished?: boolean;
    unlisted?: boolean;
    featured?: boolean;
    tags?: string[];
    category?: string;
    description?: string;
    productUploadIDs?: number[];
    createdByUserID?: string;
    updatedByUserID?: string;
    created?: string;
    validFrom?: string;
    validUntil?: string;
    version?: number;
    latest?: boolean;
    realm?: Realm;
    upload?: Upload;
    previous?: BlogPost[];
    productUploads?: Upload[];
}

// go/v2/builderdesigns.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface BuilderDesign {
    id?: string;
    companyID?: string;
    userID?: string;
    key?: string;
    uploadID?: number;
    uploadIDs?: number[];
    uploadLineItem?: CartItemUploadLineItem;
    designData?: unknown;
    createdByUserID?: string;
    created?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
    createdBy?: User;
    rowCreatedBy?: User;
    upload?: Upload;
}

// go/v2/callservices.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface CallService {
    id?: string;
    name?: string;
    createdByUserID?: string;
    created?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
    createdBy?: User;
    rowCreatedBy?: User;
}

// go/v2/campaigns.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface Campaign {
    id?: string;
    companyID?: string;
    name?: string;
    slug?: string;
    description?: string;
    createdByUserID?: string;
    created?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
    realm?: Realm;
    createdBy?: User;
    rowCreatedBy?: User;
    links?: Link[];
}

// go/v2/carrierclosures.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface CarrierClosure {
    id?: string;
    countryID?: CountryID;
    carrierID?: CarrierID;
    year?: number;
    name?: string;
    sourceURL?: string;
    firstDate?: string;
    lastDate?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
}

// go/v2/carrierpaperlessaccounts.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface CarrierPaperlessAccount {
    id?: string;
    carrierID?: CarrierID;
    accountNumber?: string;
    notAuthorized?: string;
    authorized?: string;
    createdByUserID?: string;
    created?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
}

// go/v2/carriers.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface Carrier {
    id?: CarrierID;
    name?: string;
    phone?: string;
    sortOrder?: number;
    link?: string;
    trackingSupported?: boolean;
    active?: boolean;
    created?: string;
    updated?: string;
}
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const CarrierID = {
    CARRIERS_AMAZON: 17,
    CARRIERS_DHL: 2,
    CARRIERS_FED_EX: 5,
    CARRIERS_OTHER: 1,
    CARRIERS_UPS: 4,
    CARRIERS_USPS: 3,
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type CarrierID = typeof CarrierID[keyof typeof CarrierID];

// go/v2/cartitems.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface CartItem {
    id?: string;
    cartID?: string;
    stockItemID?: string;
    quoteID?: string;
    orderID?: string;
    uploadID?: number;
    uploadLineItem?: CartItemUploadLineItem;
    designProofID?: string;
    builderDesignID?: string;
    builderDesignVersion?: number;
    quantity?: number;
    customizations?: Record<string, string>;
    options?: CartItemOption[];
    active?: boolean;
    quantities?: Record<string, number>;
    deletedLineItems?: string[];
    created?: string;
    subtotal?: string;
    total?: string;
    networkTotal?: string;
    maxNetworkTotal?: string;
    maxNetworkSubtotal?: string;
    quantityPricing?: Record<number, string>;
    cart?: Cart;
    quote?: Quote;
    order?: Order;
    stockItem?: StockItem;
    upload?: Upload;
    designProof?: DesignProof;
    cartItemUploads?: CartItemUpload[];
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface CartItemMod {
    id?: string;
    stockItemID?: string;
    quoteID?: string;
    uploadID?: number;
    designProofID?: string;
    uploadLineItem?: CartItemUploadLineItem;
    builderDesignID?: string;
    builderDesignVersion?: number;
    customizations?: Record<string, string>;
    options?: CartItemOption[];
    quantities?: Record<string, number>;
    deletedLineItems?: string[];
    quantity?: number;
    orderID?: string;
    active?: boolean;
    lineItems?: CartItemLineItemMod[];
    cartItemUploads?: CartItemUploadMod[];
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface CartItemLineItemMod {
    id: string;
    quantity?: number;
    active?: boolean;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface CartItemUploadLineItem {
    name?: string;
    lineItemID?: LineItemID;
    lineItemTypeID?: LineItemTypeID;
    lineItemTypeSizeID?: string;
    networkSKUID?: string;
    flagIDs?: FlagID[];
    childLineItems?: CartItemUploadChildLineItem[];
    price?: string;
    lineItem?: LineItem;
    lineItemType?: LineItemType;
    lineItemTypeSize?: LineItemTypeSize;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface CartItemUploadChildLineItem {
    childLineItemID?: ChildLineItemID;
    childLineItemOptionID?: ChildLineItemOptionID;
    quantity?: number;
    price?: string;
    childLineItem?: ChildLineItem;
    childLineItemOption?: ChildLineItemOption;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface CartItemOption {
    name?: string;
    value?: string;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface OrderReorder {
    cartItems?: CartItemMod[];
    code?: string;
}

// go/v2/cartitemuploads.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface CartItemUpload {
    id?: string;
    cartItemID?: string;
    uploadID?: number;
    tags?: string[];
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    cartItem?: CartItem;
    upload?: Upload;
    createdBy?: User;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface CartItemUploadMod {
    id?: string;
    uploadID?: number;
    createdByUserID?: string;
    tags?: string[];
    active?: boolean;
}

// go/v2/cartorders.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface CartOrder {
    id?: string;
    cartID?: string;
    orderID?: string;
    quantityIncreased?: boolean;
    quantityDecreased?: boolean;
    quantityChangeWorth?: string;
    quantityChanges?: CartOrderQuantityChange[];
    deletedLineItem?: boolean;
    quantityChangeAllowed?: boolean;
    subtotal?: string;
    createdByUserID?: string;
    companyID?: string;
    pageRequestID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    orders?: Order[];
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface CartOrderQuantityChange {
    id?: string;
    original?: number;
    new?: number;
}

// go/v2/carts.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface Cart {
    id?: string;
    parentCartID?: string;
    userID?: string;
    companyID?: string;
    pageRequestID?: string;
    possibleUserID?: string;
    created?: string;
    name?: string;
    admin?: boolean;
    active?: boolean;
    company?: Realm;
    user?: User;
    cartItems?: CartItem[];
    cartOrders?: CartOrder[];
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface CartPendingDepositOrder {
    projectName?: string;
    sameProject?: boolean;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface ResumableOrder {
    orderID?: string;
    key?: string;
    invoiceNumber?: number;
    balance?: string;
    availableDiscount?: string;
    shippingOption?: ShippingOption;
    userTaxExemption?: UserTaxExemption;
    payments?: ResumablePayment[];
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface ResumablePayment {
    orderPaymentID?: string;
    paymentOptionID?: string;
    paymentOptionTypeID?: PaymentOptionTypeID;
    creditCardFirst6?: string;
    creditCardLast4?: string;
    total?: string;
    paid?: string;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface CartLineItemOverride {
    objectLineItemID?: string;
    objectChildLineItemID?: string;
    quantity?: number;
    price?: string;
}

// go/v2/changelog.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface ModelChangelogEntry {
    userID: string;
    column: string;
    oldValue: unknown;
    newValue: unknown;
    time: string;
}

// go/v2/checkboxchecks.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface CheckboxCheck {
    checkboxCode?: string;
    value?: string;
    bid2?: string;
    buuid?: string;
    checkbox?: Checkbox;
}

// go/v2/checkboxes.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface Checkbox {
    checkboxCode?: string;
    userID?: string;
    checkboxChecks?: CheckboxCheck[];
}

// go/v2/childlineitemoptions.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface ChildLineItemOption {
    id?: string;
    childLineItemID?: string;
    name?: string;
    pluralName?: string;
    factoryName?: string;
    pluralFactoryName?: string;
    description?: string;
    default?: boolean;
    defaultQuantity?: number;
    weight?: string;
    sortOrder?: number;
    cachedSort?: string;
    cachedFactorySort?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    networkChildLineItemOption?: NetworkChildLineItemOption;
    translations?: ChildLineItemOptionTranslation[];
}
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const ChildLineItemOptionID = {
    CHILD_LINE_ITEM_OPTION_COIN_MOLD_FEE_NEW_BOTH_SIDES: 'FUGi6b6Z4YI',
    CHILD_LINE_ITEM_OPTION_COIN_MOLD_FEE_NEW_ONE_SIDE: 'FUGi6b6aQ0I',
    CHILD_LINE_ITEM_OPTION_COIN_3_D_MOLD_FEE_NEW_BOTH_SIDES: 'FUGi6b6ho_I',
    CHILD_LINE_ITEM_OPTION_COIN_3_D_MOLD_FEE_NEW_ONE_SIDE: 'FUGi6b6hBBI',
    CHILD_LINE_ITEM_OPTION_COIN_3_D_IMAGE_BOTH_SIDES: 'GBiJ0R75nx0',
    CHILD_LINE_ITEM_OPTION_COIN_3_D_IMAGE_ONE_SIDE: 'GBiJ0CmDG-c',
    CHILD_LINE_ITEM_OPTION_COIN_PACKAGING_PLASTIC_STAND: 'FUGi6b-QR9I',
    CHILD_LINE_ITEM_OPTION_COIN_PACKAGING_VELVET_BAG: 'FUGi6b_--4I',
    CHILD_LINE_ITEM_OPTION_COIN_PACKAGING_VELVET_CASE: 'FUGi6b-0kII',
    CHILD_LINE_ITEM_OPTION_COIN_PACKAGING_METAL_STAND: 'GMAKsNA4zyU',
    CHILD_LINE_ITEM_OPTION_PIN_PACKAGING_VELVET_CASE: 'FUGi6b-UEEI',
    CHILD_LINE_ITEM_OPTION_MEDAL_MOLD_FEE_NEW_BOTH_SIDES: 'GCOK6Gh1OhA',
    CHILD_LINE_ITEM_OPTION_ORNAMENT_MOLD_FEE_NEW_BOTH_SIDES: 'FWsQOF1XXbQ',
    CHILD_LINE_ITEM_OPTION_COIN_CUT_OUTS_1: 'FUGi6b6T_qI',
    CHILD_LINE_ITEM_OPTION_COIN_PLATING_ANTIQUE_SILVER: 'FUGi6b9CZVI',
    CHILD_LINE_ITEM_OPTION_COIN_PLATING_ANTIQUE_GOLD: 'FUGi6b-VlDI',
    CHILD_LINE_ITEM_OPTION_COIN_EDGE_REEDED_RIM: 'FUGi6b8VOkI',
    CHILD_LINE_ITEM_OPTION_COIN_UV_PRINT_SETUP_FEE_BOTH_SIDES: 'F-eyez50y4Q',
    CHILD_LINE_ITEM_OPTION_COIN_UV_PRINT_SETUP_FEE_ONE_SIDE: 'F-eyeCDrH7I',
    CHILD_LINE_ITEM_OPTION_COIN_UV_PRINT_TOOLING_BOTH_SIDES: 'F-eygPAkxKM',
    CHILD_LINE_ITEM_OPTION_COIN_UV_PRINT_TOOLING_ONE_SIDE: 'F-eyfp2LCFM',
    CHILD_LINE_ITEM_OPTION_LAPEL_PINS_OFFSET_PRINTED_SETUP_FEES_STANDARD: 'GBh3R_Dnt7E',
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type ChildLineItemOptionID = typeof ChildLineItemOptionID[keyof typeof ChildLineItemOptionID];

// go/v2/childlineitemoptiontranslations.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface ChildLineItemOptionTranslation {
    id?: string;
    childLineItemOptionID?: string;
    language?: string;
    name?: string;
    pluralName?: string;
    factoryName?: string;
    pluralFactoryName?: string;
    description?: string;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
}

// go/v2/childlineitems.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface ChildLineItem {
    id?: string;
    lineItemID?: string;
    name?: string;
    pluralName?: string;
    factoryName?: string;
    pluralFactoryName?: string;
    description?: string;
    limit?: number;
    default?: boolean;
    autoQuantity?: boolean;
    linkedQuantity?: boolean;
    sortOrder?: number;
    mold?: boolean;
    weight?: string;
    notShipped?: boolean;
    cachedOptionsCount?: number;
    cachedSort?: string;
    cachedFactorySort?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    lineItem?: LineItem;
    networkChildLineItem?: NetworkChildLineItem;
    childLineItemOptions?: ChildLineItemOption[];
}
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const ChildLineItemID = {
    CHILD_LINE_ITEM_PIN_MOLD_FEE: 'FUGi9HxFM8I',
    CHILD_LINE_ITEM_PIN_3_D_MOLD_FEE: 'FUGi9HuUC6I',
    CHILD_LINE_ITEM_LAPEL_PIN_OFFSET_PRINTED_SETUP_FEE: 'FUGi9HvJR6I',
    CHILD_LINE_ITEM_LAPEL_PIN_SILK_SCREEN_IMPRINT: 'FUGi9HvVw6I',
    CHILD_LINE_ITEM_COIN_MOLD_FEE: 'FUGi9HupB5I',
    CHILD_LINE_ITEM_COIN_3_D_MOLD_FEE: 'FUGi9HxVHJI',
    CHILD_LINE_ITEM_COIN_3_D_IMAGE: 'FUGi9HuNt1I',
    CHILD_LINE_ITEM_CHARM_MOLD_FEE: 'FUGi9HuJ4CI',
    CHILD_LINE_ITEM_KEY_CHAIN_MOLD_FEE: 'FUGi9HueI-I',
    CHILD_LINE_ITEM_MEDAL_MOLD_FEE: 'FUGi9HxJ5HI',
    CHILD_LINE_ITEM_BELT_BUCKLE_MOLD_FEE: 'FUGi9Hu3N2I',
    CHILD_LINE_ITEM_ORNAMENT_MOLD_FEE: 'FWsQOFz-80Q',
    CHILD_LINE_ITEM_COIN_PLATING: 'FUGi9HufXwI',
    CHILD_LINE_ITEM_COIN_EDGE: 'FUGi9Hu30hI',
    CHILD_LINE_ITEM_BOTTLE_OPENER_SETUP_FEE: 'FUGi9Ht5ZBI',
    CHILD_LINE_ITEM_BOTTLE_OPENER_TOOLING_FEE: 'FUGi9Ht48zI',
    CHILD_LINE_ITEM_COIN_CUTOUTS: 'FUGi9HxOKrI',
    CHILD_LINE_ITEM_COIN_UV_PRINT_SETUP_FEE: 'F-eyY1K5Zc4',
    CHILD_LINE_ITEM_COIN_UV_PRINT_TOOLING: 'F-eybVXlT7g',
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type ChildLineItemID = typeof ChildLineItemID[keyof typeof ChildLineItemID];

// go/v2/commissiontotals.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface CommissionTotal {
    id?: string;
    orderID?: string;
    managingCompanyID?: string;
    percentage?: string;
    orderCommission?: string;
    factoryCommission?: string;
    shippingCommission?: string;
    total?: string;
    created?: string;
}

// go/v2/commissiontransfers.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface CommissionTransfer {
    id?: string;
    orderID?: string;
    managingCompanyID?: string;
    orderCommission?: string;
    factoryCommission?: string;
    shippingCommission?: string;
    orderAmount?: string;
    factoryAmount?: string;
    shippingAmount?: string;
    total?: string;
    percentage?: string;
    transferred?: boolean;
    markedAsTransferred?: boolean;
    memo?: string;
    created?: string;
    order?: Order;
}

// go/v2/companydetails.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface CompanyDetail {
    id?: string;
    companyID?: string;
    name: string;
    value: string;
    json: boolean;
    active?: boolean;
    created?: string;
    updated?: string;
}

// go/v2/companyshippingaccounts.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface CompanyShippingAccount {
    id?: string;
    companyID?: string;
    shippingAccountID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    shippingAccount?: ShippingAccount;
}

// go/v2/contacts.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface Contact {
    id?: string;
    companyID?: string;
    userID?: string;
    formSubmissionID?: string;
    name?: string;
    company?: string;
    email?: string;
    phone?: string;
    body?: string;
    remoteAddress?: string;
    referer?: string;
    spam?: boolean;
    created?: string;
    uploads?: Upload[];
}

// go/v2/countries.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface Country {
    id?: CountryID;
    name?: string;
    countryCode2?: string;
    countryCode3?: string;
    sortOrder?: number;
    states?: State[];
}
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const CountryID = {
    COUNTRIES_UNITED_STATES: 235,
    COUNTRIES_PUERTO_RICO: 181,
    COUNTRIES_GUAM: 95,
    COUNTRIES_US_VIRGIN_ISLANDS: 241,
    COUNTRIES_AMERICAN_SAMOA: 11,
    COUNTRIES_NORTHERN_MARIANA_ISLANDS: 151,
    COUNTRIES_UNITED_KINGDOM: 80,
    COUNTRIES_CANADA: 40,
    COUNTRIES_MEXICO: 143,
    COUNTRIES_AUSTRALIA: 15,
    COUNTRIES_CHINA: 44,
    COUNTRIES_VIET_NAM: 242,
    COUNTRIES_BANGLADESH: 23,
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type CountryID = typeof CountryID[keyof typeof CountryID];

// go/v2/customeremailattachments.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface CustomerEmailAttachment {
    id?: string;
    customerEmailID?: string;
    name?: string;
    path?: string;
    size?: number;
    'sha3-224'?: string;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    customerEmail?: CustomerEmail;
    createdBy?: User;
}

// go/v2/customeremailclicks.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface CustomerEmailClick {
    id?: string;
    customerEmailID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
}

// go/v2/customeremailopens.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface CustomerEmailOpen {
    id?: string;
    customerEmailID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
}

// go/v2/customeremails.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface CustomerEmail {
    id?: string;
    companyID?: string;
    userID?: string;
    sentEmailID?: string;
    sentEmailCategoryID?: string;
    emailTemplate?: string;
    emailTypeID?: number;
    followUpID?: string;
    subject?: string;
    text?: string;
    html?: string;
    ids?: CustomerEmailIDs;
    sent?: number;
    bccCompany?: boolean;
    bccFrontOffice?: boolean;
    sendAfter?: string;
    allowHTML?: boolean;
    useMaster?: boolean;
    conditions?: unknown;
    emailTriggerID?: string;
    addresses?: CustomerEmailAddresses;
    version?: number;
    data?: unknown;
    sqsMsgGrpID?: number;
    dev?: boolean;
    createdByAdmin?: boolean;
    error?: string;
    unsubscribed?: boolean;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    sentUpdated?: string;
    realm?: Realm;
    user?: User;
    sentEmail?: SentEmail;
    emailType?: EmailType;
    createdBy?: User;
    customerEmailAttachments?: CustomerEmailAttachment[];
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface CustomerEmailAddresses {
    to?: EmailAddresses;
    cc?: EmailAddresses;
    bcc?: EmailAddresses;
    replyTo?: EmailAddresses;
    from?: EmailAddresses;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare type EmailAddresses = Record<string, string>;
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface CustomerEmailIDs {
    userID?: string;
    orderID?: string;
    loginCodeID?: string;
    customerEmailID?: string;
    secondaryCustomerEmailID?: string;
    quoteSentInstanceID?: string;
    shipmentID?: string;
    shippingOptionID?: string;
    orderShippingOptionID?: string;
    orderShippingOptionShipmentID?: string;
    quoteRequestProjectTaskID?: string;
    quoteRequestProjectID?: string;
    quoteRequestID?: string;
    quoteID?: string;
    lineItemID?: string;
    pageRequestID?: string;
    linkID?: string;
    forgotPasswordKey?: string;
    userEventID?: string;
    promotionalCodeID?: string;
    cartID?: string;
}

// go/v2/designartpoints.go
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const DesignArtPointKind = {
    DESIGN_ART_POINT_KIND_INITIAL: 'initial',
    DESIGN_ART_POINT_KIND_REVISION: 'revision',
    DESIGN_ART_POINT_KIND_MANUAL: 'manual',
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type DesignArtPointKind = typeof DesignArtPointKind[keyof typeof DesignArtPointKind];
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface DesignArtPoint {
    id?: string;
    designID?: string;
    designProofID?: string;
    userID?: string;
    kind?: DesignArtPointKind;
    weight: string;
    difficulty: string;
    points: string;
    requestingDesignVersion?: number;
    difficultySetByUserID?: string;
    memo?: string;
    createdByUserID?: string;
    created?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface DesignArtPointCorrection {
    userID?: string;
    difficulty?: string;
    points?: string;
    memo: string;
}

// go/v2/designchildlineitemdiscounts.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface DesignChildLineItemDiscount {
    id?: string;
    designChildLineItemID?: string;
    quantity?: number;
    percent?: string;
    createdByUserID?: string;
    created?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
}

// go/v2/designchildlineitems.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface DesignChildLineItem {
    id?: string;
    designProofID?: string;
    childLineItemID?: string;
    childLineItemOptionID?: string;
    customName?: string;
    customBasePrice?: string;
    customBaseQuantity?: number;
    autoQuantity?: boolean;
    linkedQuantity?: boolean;
    quantity?: number;
    description?: string;
    sort?: number;
    createdByUserID?: string;
    created?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
    discounts?: DesignChildLineItemDiscount[];
}

// go/v2/designmessages.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface DesignMessage {
    id?: string;
    designID?: string;
    internal?: boolean;
    body?: string;
    uploadIDs?: number[];
    read?: string;
    createdByUserID?: string;
    created?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
    uploads?: Upload[];
}

// go/v2/designmolds.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface DesignMold {
    id?: string;
    designID?: string;
    moldID?: string;
    sort?: number;
    createdByUserID?: string;
    created?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
}

// go/v2/designpriorities.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface DesignPriority {
    id?: DesignPriorityID;
    name?: string;
    default?: boolean;
    color?: string;
    sortOrder?: number;
    active?: boolean;
    created?: string;
    updated?: string;
}
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const DesignPriorityID = {
    DESIGN_PRIORITIES_BUMP: 1,
    DESIGN_PRIORITIES_LOW: 2,
    DESIGN_PRIORITIES_MEDIUM: 3,
    DESIGN_PRIORITIES_RTO: 4,
    DESIGN_PRIORITIES_REPEAT_CUSTOMER: 5,
    DESIGN_PRIORITIES_RUSH: 6,
    DESIGN_PRIORITIES_PREPAID: 7,
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type DesignPriorityID = typeof DesignPriorityID[keyof typeof DesignPriorityID];

// go/v2/designproofpricing.go
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const DesignProofPriceLineKind = {
    DESIGN_PROOF_PRICE_LINE_PRODUCT: 'product',
    DESIGN_PROOF_PRICE_LINE_CHILD: 'child',
    DESIGN_PROOF_PRICE_LINE_MOLD_FEE: 'moldFee',
    DESIGN_PROOF_PRICE_LINE_DISCOUNT: 'discount',
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type DesignProofPriceLineKind = typeof DesignProofPriceLineKind[keyof typeof DesignProofPriceLineKind];
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface DesignProofPriceLine {
    kind?: DesignProofPriceLineKind;
    name?: string;
    description?: string;
    quantity?: number;
    unitPrice?: string;
    total?: string;
    designChildLineItemID?: string;
    moldID?: string;
    discountID?: string;
    reorder?: boolean;
    waived?: boolean;
    shared?: boolean;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface DesignProofPrice {
    designProofID?: string;
    quantity?: number;
    combinedQuantity?: number;
    lines?: DesignProofPriceLine[];
    subtotal?: string;
    discountTotal?: string;
    total?: string;
    freeShipping?: boolean;
    appliedDiscountIDs?: string[];
}

// go/v2/designproofs.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface DesignProof {
    id?: string;
    designID?: string;
    proofNumber?: number;
    uploadID?: number;
    lineItemID?: string;
    lineItemTypeID?: string;
    lineItemTypeSizeID?: string;
    networkSKUID?: string;
    sides?: number;
    blocked?: boolean;
    createdByUserID?: string;
    created?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
    upload?: Upload;
    design?: Design;
    price?: DesignProofPrice;
    suggestedReplacementDesignProofID?: string;
}

// go/v2/designs.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface Design {
    id?: string;
    companyID?: string;
    networkID?: string;
    userID?: string;
    name?: string;
    key?: string;
    designStatusID?: DesignStatusID;
    designPriorityID?: DesignPriorityID;
    assignedUserID?: string;
    salesUserID?: string;
    salesTeamID?: string;
    originalSalesTeamID?: string;
    quantity?: number;
    timeBudget?: number;
    hiddenFromArtists?: boolean;
    clearinghouse?: boolean;
    formSubmissionID?: string;
    forkedFromDesignID?: string;
    dateNeeded?: string;
    snoozedUntil?: string;
    snoozedUntilActivity?: boolean;
    difficulty?: string;
    createdByUserID?: string;
    created?: string;
    user?: User;
    assignedUser?: User;
    salesUser?: User;
    designProofs?: DesignProof[];
    designMolds?: DesignMold[];
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
}

// go/v2/designstatuses.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface DesignStatus {
    id?: DesignStatusID;
    name?: string;
    default?: boolean;
    color?: string;
    sortOrder?: number;
    active?: boolean;
    created?: string;
    updated?: string;
}
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const DesignStatusID = {
    DESIGN_STATUSES_HOLD: 1,
    DESIGN_STATUSES_ART_IN_PROGRESS: 2,
    DESIGN_STATUSES_ADJUSTMENT_NEEDED: 3,
    DESIGN_STATUSES_FIX_NEEDED: 4,
    DESIGN_STATUSES_ART_DONE: 5,
    DESIGN_STATUSES_SENT: 6,
    DESIGN_STATUSES_BUMP: 7,
    DESIGN_STATUSES_QUALIFIED: 8,
    DESIGN_STATUSES_UNQUALIFIED: 9,
    DESIGN_STATUSES_VECTOR_DONE: 10,
    DESIGN_STATUSES_PAUSED: 11,
    DESIGN_STATUSES_REVIEW_NEEDED: 12,
    DESIGN_STATUSES_CUSTOMER_CANCELED: 13,
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type DesignStatusID = typeof DesignStatusID[keyof typeof DesignStatusID];

// go/v2/designtimes.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface DesignTime {
    id?: string;
    designID?: string;
    userID?: string;
    started?: string;
    stopped?: string;
    paused?: boolean;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
}

// go/v2/details.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface Detail {
    id?: string;
    json?: unknown;
    active?: boolean;
    created?: string;
    updated?: string;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface Details {
    defaultTaskTimeBudgets?: Record<string, Record<string, Record<string, number>>>;
    defaultGoalPercentage?: string;
    goalAmount?: Record<string, {
        companyID: string;
        targetAmount: string;
    }[]>;
    quotaAmount?: Record<string, {
        companyID: string;
        quotaAmount: string;
    }[]>;
    grafanaDashboardTemplates?: Record<string, unknown>;
    salesTeamStandings?: SalesTeamStandings;
    shippingBoxTypes?: ShippingBoxType[];
    leadExpectedValues?: LeadExpectedValues;
    salesTeamWorkloadStats?: SalesTeamWorkloadStats;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface LeadExpectedValues {
    updated?: string;
    default?: string;
    realms?: Record<string, LeadExpectedValue>;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface LeadExpectedValue {
    value?: string;
    closeRate?: string;
    avgOrderValue?: string;
    quoteRequests?: number;
    orders?: number;
    avgQuantity?: number;
    quantityCap?: number;
    quantityCurve?: LeadQuantityCurve;
    quantityBuckets?: LeadQuantityBucket[];
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface LeadQuantityCurve {
    valueIntercept: number;
    valueExponent: number;
    closeIntercept: number;
    closeSlope: number;
    minQuantity: number;
    maxValue?: string;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface LeadQuantityBucket {
    minQuantity: number;
    value?: string;
    closeRate?: string;
    avgOrderValue?: string;
    quoteRequests?: number;
    orders?: number;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface SalesTeamWorkloadStats {
    updated?: string;
    teams?: Record<string, SalesTeamWorkloadStat>;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface SalesTeamWorkloadStat {
    unsentQuoteRequestProjects?: number;
    activeFridayTasks?: number;
    openEmailConversations?: number;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface SalesTeamStandings {
    quarter: string;
    lastUpdated: string;
    workingDaysProcessed: number;
    dailySnapshots: Record<string, SalesTeamDailyResult[]>;
    standings: SalesTeamStanding[];
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface SalesTeamDailyResult {
    originalSalesTeamID: string;
    salesTeamName: string;
    position: number;
    points: number;
    isWin: boolean;
    isSecond: boolean;
    isThird: boolean;
    isPodium: boolean;
    todayTotal: string;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface SalesTeamStanding {
    originalSalesTeamID: string;
    salesTeamName: string;
    position: number;
    points: number;
    wins: number;
    seconds: number;
    thirds: number;
    podiums: number;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface ShippingBoxType {
    id: string;
    name: string;
    length: string;
    width: string;
    height: string;
    maxWeight: string;
    category: string;
    carrierCode?: string;
}

// go/v2/discounts.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface Discount {
    id?: string;
    companyID?: string;
    networkID?: string;
    userID?: string;
    designID?: string;
    percent?: string;
    amount?: string;
    freeShipping?: boolean;
    expires?: string;
    usesLimit?: number;
    usesRemaining?: number;
    note?: string;
    createdByUserID?: string;
    created?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
}

// go/v2/discountuses.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface DiscountUse {
    id?: string;
    discountID?: string;
    orderID?: string;
    orderLineItemID?: string;
    confirmed?: string;
    createdByUserID?: string;
    created?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
}

// go/v2/emailaddresses.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface EmailAddress {
    id?: string;
    email?: string;
    createdByUserID?: string;
    created?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
    createdBy?: User;
    rowCreatedBy?: User;
}

// go/v2/emailblasts.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface EmailBlast {
    id?: string;
    networkID?: string;
    companyID?: string;
    name?: string;
    emailMessageTemplateID?: string;
    emailMessageTemplateVersion?: number;
    emailCategoryID?: string;
    recipientCount?: number;
    snippet?: string;
    extractedMarkdown?: string;
    sendAfter?: string;
    createdByUserID?: string;
    created?: string;
    externalID?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
    network?: Network;
    realm?: Realm;
    messageTemplate?: EmailMessageTemplate;
    category?: EmailCategory;
    createdBy?: User;
    rowCreatedBy?: User;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface EmailBlastUpdate {
    currentVersion: number;
    name?: string;
    sendAfter?: string;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface EmailBlastContent {
    name?: string;
    companyID: string;
    emailCategoryID: string;
    subjectTemplate: string;
    htmlBodyTemplate?: string;
    textBodyTemplate?: string;
    useMaster?: boolean;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface EmailBlastRecipient {
    userID: string;
    recipients?: EmailRecipients;
    ids?: NodeContextIDs;
    data?: unknown;
}

// go/v2/emailcategories.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface EmailCategory {
    id?: string;
    name?: string;
    optional?: boolean;
    dripQuietDays?: number;
    createdByUserID?: string;
    created?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
    createdBy?: User;
    rowCreatedBy?: User;
}

// go/v2/emaildrips.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface EmailDrip {
    emailTemplateNameID?: string;
    name?: string;
    emailMessageTemplateID?: string;
    version?: number;
    emailCategoryID?: string;
    dripPriority?: number;
}

// go/v2/emailmessagetemplatecontents.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface EmailMessageTemplateContent {
    id?: string;
    emailMessageTemplateID?: string;
    emailMessageTemplateVersion?: number;
    snippet?: string;
    extractedMarkdown?: string;
    created?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
}

// go/v2/emailmessagetemplates.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface EmailMessageTemplate {
    id?: string;
    networkID?: string;
    companyID?: string;
    emailTemplateNameID?: string;
    emailCategoryID?: string;
    subjectTemplate?: string;
    htmlBodyTemplate?: string;
    textBodyTemplate?: string;
    markdownBodyTemplate?: string;
    useMaster?: boolean;
    drip?: boolean;
    dripPriority?: number;
    dripQuery?: string;
    dripEnds?: string;
    createdByUserID?: string;
    created?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
    network?: Network;
    realm?: Realm;
    templateName?: EmailTemplateName;
    category?: EmailCategory;
    createdBy?: User;
    rowCreatedBy?: User;
}

// go/v2/emailpreferences.go
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const EmailsStateValue = {
    EMAILS_STATE_ON: 'on',
    EMAILS_STATE_OFF: 'off',
    EMAILS_STATE_PAUSED: 'paused',
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type EmailsStateValue = typeof EmailsStateValue[keyof typeof EmailsStateValue];
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface EmailsUpdate {
    state?: EmailsStateValue;
    pauseDays?: number;
    categories?: Record<string, boolean>;
}

// go/v2/emails.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface EmailSendChunk {
    emailIDs: string[];
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface EmailSendChunkResult {
    sent: number;
    skipped: number;
    failed: number;
    remaining: number;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface EmailParticipant {
    emailAddressID?: string;
    displayName?: string;
    unresolvedEmail?: string;
    emailAddress?: EmailAddress;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface EmailRecipients {
    from?: EmailParticipant[];
    to?: EmailParticipant[];
    cc?: EmailParticipant[];
    bcc?: EmailParticipant[];
    replyTo?: EmailParticipant[];
    sender?: EmailParticipant[];
}
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const EmailSenderKind = {
    EMAIL_SENDER_CUSTOMER: 'customer',
    EMAIL_SENDER_STAFF: 'staff',
    EMAIL_SENDER_AI: 'ai',
    EMAIL_SENDER_SYSTEM: 'system',
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type EmailSenderKind = typeof EmailSenderKind[keyof typeof EmailSenderKind];

// go/v2/emailtemplatenames.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface EmailTemplateName {
    id?: string;
    name?: string;
    createdByUserID?: string;
    created?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
    createdBy?: User;
    rowCreatedBy?: User;
}

// go/v2/emailtypes.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface EmailType {
    id?: number;
    name?: string;
    sparkPostPool?: string;
    from?: string;
    transactional?: boolean;
    sqsQueue?: string;
    userID?: string;
    created?: string;
    updated?: string;
}

// go/v2/factories.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface Factory {
    id?: string;
    originalFactoryID?: string;
    factoryIDSHA3224?: string;
    productionSheetID?: string;
    nativeName?: string;
    name?: string;
    realName?: string;
    notes?: string;
    bidding?: boolean;
    qboVendorID?: string;
    shipExecName?: string;
    shipExecShipper?: string;
    upsAccountNumber?: string;
    kind?: string;
    supportedCarrierIDs?: CarrierID[];
    preferred?: FactoryPreferred;
    exclusions?: FactoryPreferred;
    exclusionsJS?: string;
    customsOverrides?: FactoryCustomsOverride[];
    holidays?: Holiday[];
    estimatedCapacity?: number;
    estimatedOrderCapacity?: number;
    paused?: boolean;
    accountBilling?: boolean;
    dirigibleRolloutPercent?: number;
    costTargetAdjustment?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    address?: Address;
    addresses?: FactoryAddress[];
    factoryContacts?: FactoryContact[];
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface FactoryPreferred {
    flagIDs?: FlagID[];
    lineItemIDs?: string[];
    lineItemTypeIDs?: string[];
    lineItemTypeSizeIDs?: string[];
    childLineItemIDs?: string[];
    childLineItemOptionIDs?: string[];
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface FactoryCustomsOverride {
    lineItemID?: LineItemID;
    customsDescription?: string;
    harmonizedCode?: string;
}
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const FactoryID = {
    FACTORY_SMG: 'Flmb8bxscBg',
    FACTORY_MARTIN: 'FrXw6GKlXas',
    FACTORY_DAVID_NING: 'FU5zbPh5V6E',
    FACTORY_TONY_WANG: 'FU5zbPh02AE',
    FACTORY_HELEN_BD: 'F78vAIxSA-c',
    FACTORY_JENNY_HUANG_BD: 'FxjE0JBEe4o',
    FACTORY_JIM_CEN_VN: 'GBUaNe7LEhM',
    FACTORY_KAREN_BD: 'F3f3rjuof2U',
    FACTORY_OWEN_BD: 'Fe3amapI0FA',
    FACTORY_SPLIT_PAYMENT: 'FZFuffkynIA',
    FACTORY_CANCELED: 'FfRJe_CIcRA',
    FACTORY_EXPRESS_A_BUTTON: 'FU5zbPh1e7E',
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type FactoryID = typeof FactoryID[keyof typeof FactoryID];
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const FactoryKind = {
    FACTORY_KIND_FACTORY: 'FACTORY',
    FACTORY_KIND_VENDOR: 'MISC',
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type FactoryKind = typeof FactoryKind[keyof typeof FactoryKind];
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare type Holiday = string;
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface FactoryClosure {
    firstDate: string;
    lastDate: string;
    name: string;
    carrierID?: CarrierID;
}

// go/v2/factoryaddresses.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface FactoryAddress {
    id?: string;
    factoryID?: string;
    addressID?: string;
    addressVersion?: number;
    default?: boolean;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
    address?: Address;
}

// go/v2/factorycontacts.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface FactoryContact {
    id?: string;
    factoryID?: string;
    name?: string;
    phone?: string;
    email?: string;
    created?: string;
}

// go/v2/factorycosts.go
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const FactoryCostApprovedReasonID = {
    FACTORY_COST_APPROVED_REASONS_NOT: 0,
    FACTORY_COST_APPROVED_REASONS_UNDER: 1,
    FACTORY_COST_APPROVED_REASONS_AUTO_UPDATED: 2,
    FACTORY_COST_APPROVED_REASONS_LINE_ITEMS_GROUPED: 3,
    FACTORY_COST_APPROVED_REASONS_LINE_ITEMS_FORGOTTEN: 4,
    FACTORY_COST_APPROVED_REASONS_CONCEDED_DEFEAT: 5,
    FACTORY_COST_APPROVED_REASONS_HISTORICALLY_APPROVED: 6,
    FACTORY_COST_APPROVED_REASONS_MANUALLY_APPROVED: 7,
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type FactoryCostApprovedReasonID = typeof FactoryCostApprovedReasonID[keyof typeof FactoryCostApprovedReasonID];

// go/v2/factoryoauthtokens.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface FactoryOAuthToken {
    id?: string;
    originalFactoryID?: string;
    carrierID?: CarrierID;
    refreshToken?: string;
    refreshTokenExpiresAt?: string;
    authorizedAt?: string;
    accountNumbers?: AccountNumber[];
    createdByUserID?: string;
    created?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
    rowCreatedBy?: User;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface AccountNumber {
    number?: string;
    nickname?: string;
}

// go/v2/flagflags.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface FlagFlag {
    id?: string;
    flagID?: FlagID;
    userID?: string;
    orderID?: string;
    quoteRequestProjectID?: string;
    pageRequestID?: string;
    expiresAt?: string;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    user?: User;
    createdByUser?: User;
    order?: Order;
    quoteRequestProject?: QuoteRequestProject;
    pageRequest?: PageRequest;
    flag?: Flag;
}

// go/v2/flags.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare type FlagTranslations = Record<string, string>;
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface Flag {
    id?: FlagID;
    flagType?: string;
    name?: string;
    shortName?: string;
    description?: string;
    nameTranslations?: FlagTranslations;
    shortNameTranslations?: FlagTranslations;
    descriptionTranslations?: FlagTranslations;
    icon?: FlagIcons;
    sortOrder?: number;
    color?: string;
    order?: boolean;
    user?: boolean;
    quoteRequestProject?: boolean;
    pageRequest?: boolean;
    userEditable?: boolean;
    readPerm?: boolean;
    writePerm?: boolean;
    defaultExpiresAfter?: number;
    active?: boolean;
    created?: string;
    updated?: string;
    readPermString?: string;
    writePermString?: string;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface FlagIcons {
    fa4?: FlagIcon;
    fa5?: FlagIcon;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface FlagIcon {
    class: string;
    style?: string;
}
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const FlagType = {
    FLAG_TYPE_ORDER: 1,
    FLAG_TYPE_USER: 2,
    FLAG_TYPE_QUOTE_REQUEST_PROJECT: 3,
    FLAG_TYPE_PAGE_REQUEST: 4,
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type FlagType = typeof FlagType[keyof typeof FlagType];
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const FlagID = {
    FLAG_ACTIVE_ARTWORK: 1,
    FLAG_ACTIVE_REVISION: 16,
    FLAG_PENDING_RESPONSE: 17,
    FLAG_PENDING_FEEDBACK: 18,
    FLAG_RTO: 19,
    FLAG_ORDERING_INSTRUCTIONS_SENT: 20,
    FLAG_ON_HOLD: 21,
    FLAG_HOT: 22,
    FLAG_ORDERED: 23,
    FLAG_RUSH: 24,
    FLAG_UNQUALIFIED_LEAD: 25,
    FLAG_LOST_AND_REASON_PROVIDED: 26,
    FLAG_LOST_WITHOUT_REASON_PROVIDED: 27,
    FLAG_PENDING_DESIGN_APPROVAL: 28,
    FLAG_PENDING_FUNDS: 29,
    FLAG_DIFFICULT: 30,
    FLAG_KIND: 31,
    FLAG_MULTI_NETWORK: 32,
    FLAG_PREFERS_EMAIL: 33,
    FLAG_PREFERS_SMS: 34,
    FLAG_REPEAT_CUSTOMER: 35,
    FLAG_RESPONSIVE: 36,
    FLAG_UNSUBSCRIBED: 37,
    FLAG_SHIP_TO_BUILDING: 38,
    FLAG_POOR_REVIEWER: 39,
    FLAG_RESELLER_BLIND_SHIP: 40,
    FLAG_VERIFIED: 42,
    FLAG_FACTORY_MISTAKE: 43,
    FLAG_SPELLING_MISTAKE: 44,
    FLAG_TOLERANCE_MISTAKE: 45,
    FLAG_LATE_ORDER: 46,
    FLAG_FUP: 47,
    FLAG_3_D_MOLD_APPROVAL: 48,
    FLAG_ART_PROBLEM: 49,
    FLAG_DONT_PAY_FACTORY_COST: 50,
    FLAG_DONT_PAY_EXTRA_SHIPPING: 51,
    FLAG_FACTORY_PRICING_MISTAKE: 52,
    FLAG_FUTURE_CREDIT_GIVEN: 53,
    FLAG_MISSING_PRODUCT: 54,
    FLAG_PACKAGE_LOST: 55,
    FLAG_PROBLEM_RESOLVED: 56,
    FLAG_PROMO_APPROVAL: 57,
    FLAG_QUALITY_PROBLEM: 58,
    FLAG_REMAKE_REQUIRED: 59,
    FLAG_REORDER: 60,
    FLAG_SALES_TEAM_MISTAKE: 61,
    FLAG_SHIPPING_MISTAKES: 62,
    FLAG_STOCK_ITEMS: 63,
    FLAG_WAITING_ON_SALES: 64,
    FLAG_EVENT: 65,
    FLAG_DOMESTIC_PRODUCTION_PREFERENCE: 66,
    FLAG_ARTISTS_REWARDED: 67,
    FLAG_COMPLETELY_UNDERSTANDING: 68,
    FLAG_NOT_HAPPY: 69,
    FLAG_UPSET: 70,
    FLAG_FIRM_DATE: 71,
    FLAG_LIVID: 72,
    FLAG_CANCEL_AND_CREDIT: 73,
    FLAG_DELIVERED: 74,
    FLAG_PROJECT_ON_HOLD: 75,
    FLAG_SAMPLE_REQUEST: 76,
    FLAG_SAMPLE_PHOTOGRAPHED: 77,
    FLAG_SAMPLE_RECEIVED: 78,
    FLAG_PO_APPROVED: 79,
    FLAG_NO_FOLLOW_UPS: 106,
    FLAG_PRE_FORM_EMAIL: 110,
    FLAG_SMS: 111,
    FLAG_SHIPPED: 112,
    FLAG_SHIPPING_EXCEPTION: 113,
    FLAG_DOD_DOWNLOAD_GUIDE_GENERIC: 2865,
    FLAG_DOD_DOWNLOAD_GUIDE_COIN: 2866,
    FLAG_DOD_DOWNLOAD_GUIDE_BELT_BUCKLE: 2867,
    FLAG_DOD_DOWNLOAD_GUIDE_DOG_TAG: 2868,
    FLAG_DOD_DOWNLOAD_GUIDE_BOTTLE_OPENER: 2869,
    FLAG_DOD_DOWNLOAD_GUIDE_TIPS_AND_TRICKS: 2870,
    FLAG_IGNORE_SAMPLE_PHOTOS: 3236,
    FLAG_BASEBALL_PRE_FORM_USER: 3326,
    FLAG_SOFTBALL_PRE_FORM_USER: 3327,
    FLAG_BASEBALL: 3372,
    FLAG_SOFTBALL: 3373,
    FLAG_ENGAGED_AFTER_QUOTE: 3658,
    FLAG_QUARTERLY_BONUS: 4685,
    FLAG_PRE_DESIGN: 7093,
    FLAG_FORCE_PROMPT_SHIPMENT: 7473,
    FLAG_PENDING_DEPOSIT: 9333,
    FLAG_DOUBLE_PAY_SHIPPING_REVIEWED: 11631,
    FLAG_LOST_PROJECT_CANCELED: 11723,
    FLAG_RAISED_COST_AFTER_AWARD: 16316,
    FLAG_NON_CHINESE_PRODUCTION: 16609,
    FLAG_NO_FED_EX: 26879,
    FLAG_NO_UPS: 26880,
    FLAG_NO_DHL: 26881,
    FLAG_NO_USPS: 26882,
    FLAG_NO_AMAZON_SHIPPING: 26883,
    FLAG_INVALID_EMAIL: 17854,
    FLAG_VERIFIED_EMAIL: 45518,
    FLAG_UNVERIFIED_EMAIL: 45519,
    FLAG_FOLLOWED_UP_WITH: 18837,
    FLAG_PREFERS_CALLING: 32219,
    FLAG_EXPEDITED_SHIPPING_APPROVED: 37746,
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type FlagID = typeof FlagID[keyof typeof FlagID];
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const FlagCategory = {
    FLAG_CATEGORY_JOURNEY_STEP: 'Journey Step',
    FLAG_CATEGORY_CHARACTERISTIC: 'Characteristic',
    FLAG_CATEGORY_MISTAKES: 'Mistakes',
    FLAG_CATEGORY_REMINDERS: 'Reminders',
    FLAG_CATEGORY_ACCOUNTING: 'Accounting',
    FLAG_CATEGORY_MARKETING: 'Marketing',
    FLAG_CATEGORY_SOURCING: 'Sourcing',
    FLAG_CATEGORY_CUSTOMER_SENTIMENT: 'Customer Sentiment',
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type FlagCategory = typeof FlagCategory[keyof typeof FlagCategory];
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface FlagTypeGroup {
    ids: FlagID[];
    flagType: string;
    user?: boolean;
    order?: boolean;
    quoteRequestProject?: boolean;
    pageRequest?: boolean;
}
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const FlagFor = {
    FLAG_FOR_ORDER: 'order',
    FLAG_FOR_USER: 'user',
    FLAG_FOR_QUOTE_REQUEST_PROJECT: 'quoteRequestProject',
    FLAG_FOR_PAGE_REQUEST: 'pageRequest',
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type FlagFor = typeof FlagFor[keyof typeof FlagFor];

// go/v2/followups.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface FollowUp {
    id?: string;
    followUpAltID?: number;
    followUpTemplateID?: string;
    networkID?: string;
    name?: string;
    subject?: string;
    html?: string;
    text?: string;
    sendAfter?: string;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    network?: Network;
}

// go/v2/formsubmissions.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface FormSubmission {
    id?: string;
    companyID?: string;
    networkID?: string;
    userID?: string;
    form?: string;
    variant?: string;
    payload?: unknown;
    uploadIDs?: number[];
    pageRequestID?: string;
    reCaptchaPassed?: boolean;
    reCaptchaVersion?: number;
    createdByUserID?: string;
    created?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
    network?: Network;
    realm?: Realm;
    user?: User;
}

// go/v2/galleries.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface Gallery {
    id?: string;
    networkID?: string;
    name?: string;
    createdByUserID?: string;
    updatedByUserID?: string;
    created?: string;
    updated?: string;
    active?: boolean;
    network?: Network;
    createdBy?: User;
    updatedBy?: User;
    galleryUploads?: GalleryUpload[];
}

// go/v2/galleryuploads.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface GalleryUpload {
    id?: string;
    galleryID?: string;
    uploadID?: number;
    name?: string;
    details?: GalleryUploadDetails;
    sortOrder?: number;
    createdByUserID?: string;
    updatedByUserID?: string;
    created?: string;
    updated?: string;
    active?: boolean;
    gallery?: Gallery;
    upload?: Upload;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface GalleryUploadDetails {
    invoiceNumber?: number;
    lineItem?: string;
    type?: string;
    size?: string;
    plating?: string;
    edge?: string;
    industry?: string;
    attachment?: string;
    lanyardColor?: string;
    manufacturingLocation?: string;
    description?: string;
    is3d?: boolean;
}

// go/v2/groupchatmembers.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface GroupChatMember {
    id?: string;
    groupChatID?: string;
    adminRoleID?: AdminRoleID;
    originalFactoryID?: string;
    userID?: string;
    customer?: boolean;
    readOnly?: boolean;
    closedAt?: string;
    autoClosed?: boolean;
    createdByUserID?: string;
    created?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
    groupChat?: GroupChat;
    adminRole?: AdminRole;
    factory?: Factory;
    user?: User;
    createdBy?: User;
    rowCreatedBy?: User;
}

// go/v2/groupchatmessages.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface GroupChatMessageSender {
    adminRoleID?: AdminRoleID;
    originalFactoryID?: string;
    userID?: string;
    customer?: boolean;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface GroupChatMessage {
    id?: string;
    groupChatID?: string;
    userEventID?: string;
    repliedToGroupChatMessageID?: string;
    repliedToGroupChatMessageVersion?: number;
    forwardedGroupChatMessageID?: string;
    userID?: string;
    pinned?: boolean;
    silent?: boolean;
    content?: string;
    contentType?: string;
    uploadIDs?: number[];
    approvedAt?: string;
    approvedByUserID?: string;
    creatorAdminRoleIDs?: AdminRoleID[];
    creatorOriginalFactoryIDs?: string[];
    sender?: GroupChatMessageSender;
    createdByUserID?: string;
    created?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
    groupChat?: GroupChat;
    uploads?: Upload[];
    user?: User;
    approvedBy?: User;
    createdBy?: User;
    rowCreatedBy?: User;
    forwardedGroupChatMessage?: GroupChatMessage;
}

// go/v2/groupchats.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface GroupChat {
    id?: string;
    orderID?: string;
    createdByUserID?: string;
    created?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
    members?: GroupChatMember[];
    messages?: GroupChatMessage[];
    order?: Order;
    createdBy?: User;
    rowCreatedBy?: User;
}

// go/v2/imagerekognitionlabels.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface ImageRekognitionLabel {
    id?: number;
    imageID?: string;
    label?: string;
    moderation?: boolean;
    confidence?: number;
    active?: boolean;
    created?: string;
    updated?: string;
    image?: Image;
}

// go/v2/images.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface Image {
    id?: string;
    path?: string;
    name?: string;
    files?: ImageFiles;
    totalSize?: number;
    'sha3-224'?: string;
    text?: string;
    hasRekognition?: boolean;
    hasRaster?: boolean;
    companyID?: string;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    proof?: Proof;
    company?: Realm;
    createdBy?: User;
    imageRekognitionLabels?: ImageRekognitionLabel[];
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface ImageFile {
    File?: string;
    'SHA3-224'?: string;
    Size?: number;
    Width?: number;
    Height?: number;
    Mime?: string;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface ImageFiles {
    Large?: ImageFile;
    Large2x?: ImageFile;
    LargeWebP?: ImageFile;
    LargeWebP2x?: ImageFile;
    LargeAV1?: ImageFile;
    LargeAV12x?: ImageFile;
    Main?: ImageFile;
    Main2x?: ImageFile;
    MainWebP?: ImageFile;
    MainWebP2x?: ImageFile;
    MainAV1?: ImageFile;
    MainAV12x?: ImageFile;
    Original?: ImageFile;
    Raster?: ImageFile;
    Thumbnail?: ImageFile;
}

// go/v2/invoicestatuses.go
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const InvoiceStatusID = {
    INVOICE_STATUSES_OPEN: 1,
    INVOICE_STATUSES_DELETED: 2,
    INVOICE_STATUSES_PAID: 3,
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type InvoiceStatusID = typeof InvoiceStatusID[keyof typeof InvoiceStatusID];

// go/v2/invoicetemplates.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface InvoiceTemplate {
    id?: string;
    name?: string;
    body?: string;
    createdByUserID?: string;
    created?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
    networkInvoiceTemplates?: NetworkInvoiceTemplate[];
}

// go/v2/jobs.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface Job {
    id?: string;
    companyID?: string;
    apiName?: string;
    key?: string;
    completed?: boolean;
    failed?: boolean;
    failedReason?: string;
    attempt?: number;
    createdByUserID?: string;
    created?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
    request?: string;
    response?: string;
    createdBy?: User;
    rowCreatedBy?: User;
}

// go/v2/lineitems.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface LineItem {
    id?: string;
    name?: string;
    pluralName?: string;
    factoryName?: string;
    pluralFactoryName?: string;
    description?: string;
    children?: number;
    types?: number;
    tax?: boolean;
    shipping?: boolean;
    product?: boolean;
    factories?: boolean;
    sortOrder?: number;
    descriptionOverride?: boolean;
    mold?: boolean;
    forceTypeField?: boolean;
    hideSize?: boolean;
    customsDescription?: string;
    harmonizedCode?: string;
    artistRewardValue?: string;
    taxJarCode?: string;
    cachedSort?: string;
    cachedFactorySort?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    networkLineItem?: NetworkLineItem;
    lineItemTypes?: LineItemType[];
    childLineItems?: ChildLineItem[];
    lineItemStages?: LineItemStage[];
    translations?: LineItemTranslation[];
}
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const LineItemID = {
    LINE_ITEMS_LAPEL_PIN: 'FUGjGOoc0LI',
    LINE_ITEMS_BELT_BUCKLE: 'FUGjGOoeNbI',
    LINE_ITEMS_BUTTON: 'FUGjGOoerjI',
    LINE_ITEMS_CHALLENGE_COIN: 'FUGjGOofEAI',
    LINE_ITEMS_CHARM: 'FUGjGOofbSI',
    LINE_ITEMS_KEY_CHAIN: 'FUGjGOofw9I',
    LINE_ITEMS_LANYARD: 'FUGjGOogHBI',
    LINE_ITEMS_MEDAL: 'FUGjGOogc6I',
    LINE_ITEMS_PATCH: 'FUGjGOogxzI',
    LINE_ITEMS_POKER_CHIP: 'FUGjGOohGpI',
    LINE_ITEMS_STICKER: 'FUGjGOohb8I',
    LINE_ITEMS_T_SHIRT: 'FUGjGOohxiI',
    LINE_ITEMS_WRIST_BAND: 'FUGjGOoiGgI',
    LINE_ITEMS_STOCK_ITEM: 'FUGjGOoibbI',
    LINE_ITEMS_FED_EX_SHIPPING: 'FUGjGOoiwcI',
    LINE_ITEMS_UPS_SHIPPING: 'FUGjGOojFoI',
    LINE_ITEMS_SALES_TAX: 'FUGjGOojaFI',
    LINE_ITEMS_SALES_TAX_EXEMPT: 'FUGjGOojvOI',
    LINE_ITEMS_RUSH_FEE: 'FUGjGOokbII',
    LINE_ITEMS_DISCOUNT: 'FUGjGOokv5I',
    LINE_ITEMS_SHIPPING: 'FUGjGOolGJI',
    LINE_ITEMS_PRE_PRODUCTION_SAMPLING_FEE: 'FUGjGOola7I',
    LINE_ITEMS_FACTORY_COST_ADJUSTMENT: 'FVD-wKN_PRQ',
    LINE_ITEMS_ORNAMENT: 'FWsNT7IuKIQ',
    LINE_ITEMS_ROUNDING_ADJUSTMENT: 'FW0-C3uLcqA',
    LINE_ITEMS_STORE_CREDIT: 'FYa0LGTO2iI',
    LINE_ITEMS_FACTORY_SHIPPING_CHARGES: 'FZm8uAxzgdA',
    LINE_ITEMS_PROMO_CODE: 'FZpEpKIHhZA',
    LINE_ITEM_STL_FILE: 'GDmNno1XrTw',
    LINE_ITEMS_PREPAY_DEPOSIT: 'GK1jr6kj1m4',
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type LineItemID = typeof LineItemID[keyof typeof LineItemID];

// go/v2/lineitemstages.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface LineItemStage {
    id?: string;
    lineItemID?: string;
    stageID?: string;
    sortOrder?: number;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    lineItem?: LineItem;
    stage?: Stage;
    createdBy?: User;
}

// go/v2/lineitemtranslations.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface LineItemTranslation {
    id?: string;
    lineItemID?: string;
    language?: string;
    name?: string;
    pluralName?: string;
    factoryName?: string;
    pluralFactoryName?: string;
    description?: string;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
}

// go/v2/lineitemtypes.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface LineItemType {
    id?: string;
    lineItemID?: string;
    name?: string;
    pluralName?: string;
    factoryName?: string;
    pluralFactoryName?: string;
    description?: string;
    fridayLineItemNameOverride?: boolean;
    sortOrder?: number;
    active?: boolean;
    created?: string;
    updated?: string;
    lineItem?: LineItem;
    networkLineItemType?: NetworkLineItemType;
    lineItemTypeSizes?: LineItemTypeSize[];
    translations?: LineItemTypeTranslation[];
}
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const LineItemTypeID = {
    LINE_ITEM_TYPE_LAPEL_PIN_DIE_STRUCK: 'FUGjIgHrngI',
    LINE_ITEM_TYPE_LAPEL_PIN_SOFT_ENAMEL: 'FUGjIgHow9I',
    LINE_ITEM_TYPE_LAPEL_PIN_OFFSET_PRINTED: 'FUGjIgHeo2I',
    LINE_ITEM_TYPE_LAPEL_PIN_SILK_SCREEN: 'FUGjIgHtCVI',
    LINE_ITEM_TYPE_LAPEL_PIN_MADE_IN_USA_RUSH_PINS: 'FqkPvMM33lc',
    LINE_ITEM_TYPE_LAPEL_PIN_EPOLA: 'FUGjIgHz-FI',
    LINE_ITEM_TYPE_LAPEL_PIN_TRADING_PINS: 'FUGjIgH_1KI',
    LINE_ITEM_TYPE_LAPEL_PIN_RUSH_PINS: 'FUGjIgH7zlI',
    LINE_ITEM_TYPE_LAPEL_PIN_PHOTO_DOME: 'FUGjIgHufCI',
    LINE_ITEM_TYPE_LAPEL_PIN_PHOTO_ETCHED: 'FUGjIgHWkkI',
    LINE_ITEM_TYPE_PATCH_100_PERCENT_EMBROIDERY: 'FUGjIgHgKSI',
    LINE_ITEM_TYPE_PATCH_75_PERCENT_EMBROIDERY: 'FUGjIgHxRsI',
    LINE_ITEM_TYPE_PATCH_MADE_IN_USA_LEATHER: 'F67XBlhFoho',
    LINE_ITEM_TYPE_BELT_BUCKLE_MADE_IN_USA_SIMULATED_ENAMEL: 'F6miyahUpn0',
    LINE_ITEM_TYPE_LANYARD_IMPRINTED_POLYESTER: 'FUGjIgH6YvI',
    LINE_ITEM_TYPE_LANYARD_IMPRINTED_TUBE: 'FUGjIgH8ifI',
    LINE_ITEM_TYPE_LANYARD_WOVEN_POLYESTER: 'FUGjIgHsVAI',
    LINE_ITEM_TYPE_CHALLENGE_COIN_MADE_IN_USA_DIE_STRUCK: 'Fy6bD-U6mvs',
    LINE_ITEM_TYPE_CHALLENGE_COIN_MADE_IN_USA_NO_COLOR_DIE_STRUCK: 'Fqc5cBst4Sc',
    LINE_ITEM_TYPE_CHALLENGE_COIN_MADE_IN_USA_SIMULATED_ENAMEL: 'Fy6bWgwi1Q4',
    LINE_ITEM_TYPE_CHALLENGE_COIN_SOFT_ENAMEL_BOTH_SIDES: 'FUGjIgH_FRI',
    LINE_ITEM_TYPE_CHALLENGE_COIN_SOFT_ENAMEL_ONE_SIDE: 'FUGjIgHzO9I',
    LINE_ITEM_TYPE_CHALLENGE_COIN_SPINNER: 'GCWzdl3pEgv',
    LINE_ITEM_TYPE_CHALLENGE_COIN_NO_COLOR: 'FUGjIgHVDcI',
    LINE_ITEM_TYPE_CHALLENGE_COIN_EPOLA_ON_BOTH_SIDES: 'FUGjIgHl4gI',
    LINE_ITEM_TYPE_CHALLENGE_COIN_EPOLA_ON_ONE_SIDE: 'FUGjIgHd3lI',
    LINE_ITEM_TYPE_CHALLENGE_COIN_PERSONALIZED_ITEMS: 'GJoP52AwrIg',
    LINE_ITEM_TYPE_ORNAMENT_CHRISTMAS_SWEATER: 'GHemB5iAJK4',
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type LineItemTypeID = typeof LineItemTypeID[keyof typeof LineItemTypeID];

// go/v2/lineitemtypesizes.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface LineItemTypeSize {
    id?: string;
    lineItemTypeID?: string;
    width?: string;
    height?: string;
    type?: string;
    weight?: string;
    name?: string;
    nameMurmur2?: number;
    active?: boolean;
    created?: string;
    updated?: string;
    lineItemType?: LineItemType;
    networkLineItemTypeSize?: NetworkLineItemTypeSize;
}

// go/v2/lineitemtypetranslations.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface LineItemTypeTranslation {
    id?: string;
    lineItemTypeID?: string;
    language?: string;
    name?: string;
    pluralName?: string;
    factoryName?: string;
    pluralFactoryName?: string;
    description?: string;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
}

// go/v2/links.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface Link {
    id?: string;
    campaignID?: string;
    lookupKey?: string;
    name?: string;
    url?: string;
    source?: string;
    medium?: string;
    content?: string;
    term?: string;
    createdByUserID?: string;
    created?: string;
    lookupKeyMurmur32?: number;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
    campaign?: Campaign;
    createdBy?: User;
    rowCreatedBy?: User;
    shortURL?: string;
}

// go/v2/logincodes.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface LoginCode {
    id?: string;
    userID?: string;
    code?: string;
    used?: string;
    emailAddressID?: string;
    phoneNumberID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
}

// go/v2/managingcompanies.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface ManagingCompany {
    id?: string;
    name?: string;
    created?: string;
    active?: boolean;
}

// go/v2/molds.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface Mold {
    id?: string;
    companyID?: string;
    userID?: string;
    networkID?: string;
    label?: string;
    lineItemTypeID?: string;
    sizeType?: string;
    widthInches?: string;
    heightInches?: string;
    cost?: string;
    satisfied?: string;
    satisfiedOrderID?: string;
    expires?: string;
    sourceProofID?: string;
    createdByUserID?: string;
    created?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
    user?: User;
}

// go/v2/networkartrewardpolicies.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface NetworkArtRewardPolicy {
    id?: string;
    networkID?: string;
    lineItemID?: string;
    perSideAmount: string;
    initialWeight: string;
    revisionWeight: string;
    createdByUserID?: string;
    created?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
}

// go/v2/networkchildlineitemoptions.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface NetworkChildLineItemOption {
    id?: string;
    networkID?: string;
    childLineItemOptionID?: string;
    networkSKUID?: string;
    name?: string;
    pluralName?: string;
    description?: string;
    price?: string;
    sortOrder?: number;
    enabled?: boolean;
    default?: boolean;
    defaultQuantity?: number;
    builder?: boolean;
    defaultBuilder?: boolean;
    priceJS?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    childLineItemOption?: ChildLineItemOption;
    designPrice?: NetworkDesignPrice;
}

// go/v2/networkchildlineitems.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface NetworkChildLineItem {
    id?: string;
    networkID?: string;
    childLineItemID?: string;
    networkSKUID?: string;
    name?: string;
    pluralName?: string;
    description?: string;
    price?: string;
    other?: boolean;
    none?: boolean;
    sortOrder?: number;
    enabled?: boolean;
    quoteForm?: boolean;
    default?: boolean;
    builder?: boolean;
    priceJS?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    childLineItem?: ChildLineItem;
    designPrice?: NetworkDesignPrice;
    networkChildLineItemOptions?: NetworkChildLineItemOption[];
}

// go/v2/networkdesignpricediscounts.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface NetworkDesignPriceDiscount {
    id?: string;
    networkDesignPriceID?: string;
    quantity?: number;
    percent?: string;
    createdByUserID?: string;
    created?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
}

// go/v2/networkdesignprices.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface NetworkDesignPrice {
    id?: string;
    networkID?: string;
    lineItemTypeSizeID?: string;
    networkChildLineItemID?: string;
    networkChildLineItemOptionID?: string;
    basePrice?: string;
    baseQuantity?: number;
    createdByUserID?: string;
    created?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
    discounts?: NetworkDesignPriceDiscount[];
}

// go/v2/networkinvoicetemplates.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface NetworkInvoiceTemplate {
    id?: string;
    invoiceTemplateID?: string;
    created?: string;
    network?: Network;
    invoiceTemplate?: InvoiceTemplate;
}

// go/v2/networklineitems.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface NetworkLineItem {
    id?: string;
    networkID?: string;
    lineItemID?: string;
    networkSKUID?: string;
    name?: string;
    pluralName?: string;
    description?: string;
    minimumQuantity?: number;
    networkLineItemTypeFeeID?: string;
    networkLineItemTypeSizeFeeID?: string;
    networkChildLineItemOptionFeeID?: string;
    sortOrder?: number;
    enabled?: boolean;
    descriptionOverride?: boolean;
    forceCompanyID?: string;
    builder?: boolean;
    active?: boolean;
    created?: string;
    updated?: string;
    lineItem?: LineItem;
    networkLineItemTypes?: NetworkLineItemType[];
}

// go/v2/networklineitemtypes.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface NetworkLineItemType {
    id?: string;
    networkID?: string;
    lineItemTypeID?: string;
    networkSKUID?: string;
    lineItemID?: string;
    name?: string;
    pluralName?: string;
    description?: string;
    minimumQuantity?: number;
    sortOrder?: number;
    default?: boolean;
    enabled?: boolean;
    builder?: boolean;
    defaultBuilder?: boolean;
    active?: boolean;
    created?: string;
    updated?: string;
    lineItemType?: LineItemType;
    networkLineItemTypeSizes?: NetworkLineItemTypeSize[];
}

// go/v2/networklineitemtypesizequantityprices.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface NetworkLineItemTypeSizeQuantityPrice {
    id?: string;
    networkID?: string;
    lineItemTypeSizeID?: string;
    lineItemTypeID?: string;
    quantity?: number;
    price?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    network?: Network;
    lineItemTypeSize?: LineItemTypeSize;
}

// go/v2/networklineitemtypesizes.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface NetworkLineItemTypeSize {
    id?: string;
    networkID?: string;
    lineItemTypeSizeID?: string;
    lineItemTypeID?: string;
    name?: string;
    description?: string;
    sortOrder?: number;
    enabled?: boolean;
    builder?: boolean;
    defaultBuilder?: boolean;
    active?: boolean;
    created?: string;
    updated?: string;
    lineItemTypeSize?: LineItemTypeSize;
    prices?: NetworkLineItemTypeSizeQuantityPrice[];
}

// go/v2/networkmoldpolicies.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface NetworkMoldPolicy {
    id?: string;
    networkID?: string;
    lineItemID?: string;
    costJS?: string;
    freeJS?: string;
    expiryMonths?: number;
    createdByUserID?: string;
    created?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface MoldFreeOrderMold {
    rank: number;
    cost: number;
    pooledQuantity: number;
    widthInches: number;
    heightInches: number;
    lineItemTypeID: string;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface MoldFreeOrderLine {
    quantity: number;
    subtotal: number;
    widthInches: number;
    heightInches: number;
    lineItemTypeID: string;
}

// go/v2/networks.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface Network {
    id?: string;
    number?: number;
    managingCompanyID?: string;
    name?: string;
    nameShort?: string;
    icon?: string;
    iconUnicode?: string;
    iconFA5?: string;
    color?: string;
    brightnessOffset?: number;
    addressLine1?: string;
    addressLine2?: string;
    city?: string;
    zip?: string;
    stateID?: StateID;
    countryID?: CountryID;
    templateID?: string;
    processorName?: string;
    reCaptchaSiteKey?: string;
    reCaptchaSecretKey?: string;
    cloudFront?: string;
    trackEmails?: boolean;
    maintenanceMessage?: string;
    phoneFormat?: string;
    spc2?: string;
    spc3?: string;
    quoteSerialFormat?: string;
    description?: string;
    social?: SocialLinks;
    googleTitle?: string;
    googleDescription?: string;
    twitterTitle?: string;
    twitterDescription?: string;
    facebookTitle?: string;
    facebookDescription?: string;
    facebookAppID?: string;
    ahrefsVerification?: string;
    googleTagManagerID?: string;
    bingUET?: string;
    bingWebmasterVerification?: string;
    pinterestVerification?: string;
    oneSignalAppID?: string;
    placeID?: string;
    trustpilotAPIKey?: string;
    trustpilotAPISecret?: string;
    shortDomain?: string;
    fattmerchantOmniWebPaymentsToken?: string;
    promotionalCodeOwnerDescription?: string;
    promotionalCodeFormula?: string;
    promotionalCodeOwnerFormula?: string;
    promotionalCodeMinimumSubtotal?: string;
    promotionalCodeMax?: string;
    cartRevisionRequestLinks?: boolean;
    bucket?: string;
    sort?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    state?: State;
    country?: Country;
    companies?: Realm[];
    networkInvoiceTemplates?: NetworkInvoiceTemplate[];
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare type SocialLinks = string[];
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const NetworkID = {
    NETWORKS_1800_MY_BUTTONS: 'FUGkiMh1fxI',
    NETWORKS_ALL_ABOUT_NETWORK_LLC: 'FUGkiMh0eZI',
    NETWORKS_CHALLENGE_COIN_NATION_LLC: 'FUGkiMhyDPI',
    NETWORKS_CITY_PROMOTIONS_LLC: 'FUGkiMhyfTI',
    NETWORKS_GRANT: 'FUGkiMhwFrI',
    NETWORKS_LAPEL_PINS_EXPRESS_LLC: 'FUGkiMhzslI',
    NETWORKS_LEE: 'FUGkiMh16LI',
    NETWORKS_SIGNATURE_MINT_LLC: 'Fx0NH-JinpE',
    NETWORKS_SIGNATURE_PROMOTIONAL_GROUP_LLC: 'FUGkiMh0GfI',
    NETWORKS_STERLING_MARKETING_GROUP_LLC: 'FUGkiMh3bNI',
    NETWORKS_THE_LAPEL_PINAND_BUTTON_COMPANY_LLC: 'FUGkiMh3DzI',
    NETWORKS_THE_LAPEL_PINS_PLUS_NETWORK_LLC: 'FUGkiMh01xI',
    NETWORKS_THE_PIN_DEPOT_NETWORK_LLC: 'FUGkiMhy53I',
    NETWORKS_TNG_CONSOLIDATED_LLC: 'FUGkiMhxhFI',
    NETWORKS_TRADING_PINS_COM_LLC: 'FUGkiMhzUeI',
    NETWORKS_USDOD_COINS_LLC: 'FUGkiMh2r-I',
    NETWORKS_USA_NETWORK_LLC: 'FUGkiMh2U3I',
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type NetworkID = typeof NetworkID[keyof typeof NetworkID];

// go/v2/networkskus.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface NetworkSKU {
    id?: string;
    networkID?: string;
    companyID?: string;
    prefix?: string;
    number?: number;
    subNumber?: number;
    sku?: string;
    name?: string;
    secondaryName?: string;
    url?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    network?: Network;
    realm?: Realm;
}
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const NetworkSKUID = {
    NETWORK_SK_US_3_D_CHALLENGE_COINS: 'FbKZhUfwCHA',
    NETWORK_SK_US_SOFT_ENAMEL_PINS: 'FbRrgH3djlA',
    NETWORK_SK_US_CUSTOM_BOTTLE_OPENERS: 'GJYCKwyJ2X0',
    NETWORK_SK_US_CUSTOM_HANDCUFF_BOTTLE_OPENERS: 'GJYDCf9qxYE',
    NETWORK_SK_US_CUSTOM_SWEATER_ORNAMENTS: 'GJYDG-nvTDI',
    NETWORK_SK_US_CUSTOM_TROPHIES: 'GJYDIQZiR2g',
    NETWORK_SK_US_NO_MINIMUM_CUSTOM_COINS: 'GJYDJsAOVoU',
    NETWORK_SK_US_CUSTOM_PHOTO_ORNAMENTS: 'Fyn7b0MZVK0',
    NETWORK_SK_US_RIBBON_PINS: 'GJYD18NH7Gk',
    NETWORK_SK_US_NO_MINIMUM_CUSTOM_PINS: 'GL3mUF5lPJc',
    NETWORK_SK_US_PERSONALIZED_BELT_BUCKLES: 'GJYENGowXD8',
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type NetworkSKUID = typeof NetworkSKUID[keyof typeof NetworkSKUID];

// go/v2/nodeflows.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface NodeFlow {
    id?: string;
    workflowID?: string;
    name?: string;
    nodes?: Nodes;
    entrypoints?: string;
    enabled?: boolean;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    instanceCount?: number;
    inProgressInstanceCount?: number;
    abortedInstanceCount?: number;
    finishedInstanceCount?: number;
    createdBy?: User;
    workflow?: Workflow;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface NodeFlowUpdate {
    name?: string;
    nodes?: Nodes;
    enabled?: boolean;
    active?: boolean;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface NodeFlowUpdateWithID {
    id: string;
}

// go/v2/nodes.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface NodeFlowInstance {
    id?: string;
    parentNodeFlowInstanceID?: string;
    nodeFlowID?: string;
    context?: NodeContext;
    currentNodeID?: number;
    waitUntil?: string;
    aborted?: boolean;
    createdByUserID?: string;
    created?: string;
    updatedByUserID?: string;
    validFrom?: string;
    validUntil?: string;
    version?: number;
    latest?: boolean;
    nodeFlow?: NodeFlow;
    createdBy?: User;
    updatedBy?: User;
}
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const NodeName = {
    NODE_TIME: 'time',
    NODE_BUTTON: 'button',
    NODE_WEBHOOK: 'webhook',
    NODE_GET_USERS: 'get-users',
    NODE_UPDATE_USERS: 'update-users',
    NODE_USER_CREATED: 'user-created',
    NODE_USER_SALES_TEAM_UPDATED: 'user-sales-team-updated',
    NODE_CREATE_USER: 'create-user',
    NODE_FLAG_CREATED: 'flag-created',
    NODE_FLAG_UPDATED: 'flag-updated',
    NODE_FLAG_DELETED: 'flag-deleted',
    NODE_ORDER_FLAG_CREATED: 'order-flag-created',
    NODE_USER_FLAG_CREATED: 'user-flag-created',
    NODE_QUOTE_REQUEST_PROJECT_FLAG_CREATED: 'quote-request-project-flag-created',
    NODE_PAGE_REQUEST_FLAG_CREATED: 'page-request-flag-created',
    NODE_QUOTE_REQUEST_PROJECT_CREATED: 'quote-request-project-created',
    NODE_QUOTE_REQUEST_PROJECT_UPDATED: 'quote-request-project-updated',
    NODE_ORDER_FLAG_DELETED: 'order-flag-deleted',
    NODE_USER_FLAG_DELETED: 'user-flag-deleted',
    NODE_QUOTE_REQUEST_PROJECT_FLAG_DELETED: 'quote-request-project-flag-deleted',
    NODE_PAGE_REQUEST_FLAG_DELETED: 'page-request-flag-deleted',
    NODE_SLEEP: 'sleep',
    NODE_BUSINESS_HOURS: 'business-hours',
    NODE_JS: 'js',
    NODE_GET_HELP_SCOUT_CONVERSATION: 'get-helpscout-conversation',
    NODE_GET_HELP_SCOUT_CUSTOMER: 'get-helpscout-customer',
    NODE_UPDATE_HELP_SCOUT_CONVERSATION: 'update-helpscout-conversation',
    NODE_HELP_SCOUT_CONVERSATION_TAGS: 'helpscout-conversation-tags',
    NODE_GET_HELP_SCOUT_FIRST_CONVERSATION: 'get-helpscout-first-conversation',
    NODE_GET_HELP_SCOUT_CONVERSATIONS: 'get-helpscout-conversations',
    NODE_GET_HELP_SCOUT_CONVERSATION_I_DS: 'get-helpscout-conversation-ids',
    NODE_HELP_SCOUT_NEW_CONVERSATION: 'helpscout-new-conversation',
    NODE_HELP_SCOUT_INVALID_EMAIL: 'helpscout-invalid-email',
    NODE_HELP_SCOUT_THREAD_SOURCE: 'helpscout-thread-source',
    NODE_HELP_SCOUT_PUSH_CUSTOMER_TEAM: 'helpscout-push-customer-team',
    NODE_DRAFT_EMAIL_REPLY: 'draft-email-reply',
    NODE_ADD_HELP_SCOUT_NOTE: 'add-helpscout-note',
    NODE_GET_USER_FROM_HELP_SCOUT_CUSTOMER_ID: 'get-user-from-helpscout-customer-id',
    NODE_GET_SALES_TEAMS: 'get-sales-teams',
    NODE_GET_QUOTE_REQUEST_PROJECTS: 'get-quote-request-projects',
    NODE_UPDATE_QUOTE_REQUEST_PROJECTS: 'update-quote-request-projects',
    NODE_UPDATE_QUOTE_REQUEST: 'update-quote-request',
    NODE_CREDIT_CARD_DECLINED: 'credit-card-declined',
    NODE_PAY_PAL_CHECKOUT_STARTED: 'paypal-checkout-started',
    NODE_SEND_SMS: 'send-sms',
    NODE_LOGIN_CODE_CREATED: 'login-code-created',
    NODE_CUSTOMER_CART_CREATED: 'customer-cart-created',
    NODE_GET_CARTS: 'get-carts',
    NODE_CART_ITEM_CREATED: 'cart-item-created',
    NODE_ORDER_CREATED: 'order-created',
    NODE_ORDER_CHECKOUT_COMPLETE: 'order-checkout-complete',
    NODE_CUSTOMER_REVISION_REQUEST_CREATED: 'customer-revision-request-created',
    NODE_QUOTE_REQUEST_CREATED: 'quote-request-created',
    NODE_FORM_SUBMISSION_CREATED: 'form-submission-created',
    NODE_DESIGN_CREATED: 'design-created',
    NODE_DESIGN_UPDATED: 'design-updated',
    NODE_DESIGN_MESSAGE_CREATED: 'design-message-created',
    NODE_ORDER_EXCEPTION_OPENED: 'order-exception-opened',
    NODE_ORDER_EXCEPTION_UPDATED: 'order-exception-updated',
    NODE_PROCESS_CONTACT_FORM_SUBMISSION: 'process-contact-form-submission',
    NODE_SHIPPING_OPTION_CREATED: 'shipping-option-created',
    NODE_PAYMENT_OPTION_CREATED: 'payment-option-created',
    NODE_PAYMENT_OPTION_UPDATED: 'payment-option-updated',
    NODE_QUOTE_SENT_INSTANCE_CREATED: 'quote-sent-instance-created',
    NODE_ORDER_PLACED_WITH_FACTORY: 'order-placed-with-factory',
    NODE_ORDER_MOVED_FROM_PENDING: 'order-moved-from-pending',
    NODE_ORDER_PAYMENT_CREATED: 'order-payment-created',
    NODE_ORDER_PAYMENT_UPDATED: 'order-payment-updated',
    NODE_UPDATE_ORDER_PAYMENTS: 'update-order-payments',
    NODE_FORGOT_PASSWORD_CREATED: 'forgot-password-created',
    NODE_GET_SHIPMENTS: 'get-shipments',
    NODE_GET_ORDER_SHIPPING_RATES: 'get-order-shipping-rates',
    NODE_SHIPMENT_CREATED: 'shipment-created',
    NODE_SHIPMENT_UPDATED: 'shipment-updated',
    NODE_REFRESH_SHIPMENT_STATUS: 'refresh-shipment-status',
    NODE_SWEEP_LATE_RISK: 'sweep-late-risk',
    NODE_REFRESH_EMAIL_DRIP_STATS: 'refresh-email-drip-stats',
    NODE_REFRESH_EMAIL_DRIP_REPORT: 'refresh-email-drip-report',
    NODE_REFRESH_EMAIL_DRIP_AUDIENCES: 'refresh-email-drip-audiences',
    NODE_END_EMAIL_DRIPS: 'end-email-drips',
    NODE_POST_SCHEDULED_GROUP_CHAT_MESSAGES: 'post-scheduled-group-chat-messages',
    NODE_REGISTER_TRACKING_WEBHOOK: 'register-tracking-webhook',
    NODE_AUDIT_SHIP_ENGINE_LABELS: 'audit-shipengine-labels',
    NODE_RETRY_SHIPMENT_VOIDS: 'retry-shipment-voids',
    NODE_VOID_STALE_LABELS: 'void-stale-labels',
    NODE_VOID_SHIP_ENGINE_LABEL: 'void-shipengine-label',
    NODE_ORDER_LINE_ITEM_STAGE_CREATED: 'order-line-item-stage-created',
    NODE_ORDER_LINE_ITEM_STAGE_COMPLETED: 'order-line-item-stage-completed',
    NODE_UPLOAD_KEPT: 'upload-kept',
    NODE_UPLOAD_CREATED: 'upload-created',
    NODE_UPLOAD_UPDATED: 'upload-updated',
    NODE_UPDATE_UPLOAD_META: 'upload-update-meta',
    NODE_IMAGE_CREATED: 'image-created',
    NODE_UPDATE_IMAGE_REKOGNITION: 'image-update-rekognition',
    NODE_GET_REALMS: 'get-realms',
    NODE_GET_NETWORKS: 'get-networks',
    NODE_GET_ORDER_INVOICE: 'get-order-invoice',
    NODE_GET_QUOTE_INVOICE: 'get-quote-invoice',
    NODE_HTML_TO_PDF: 'html-to-pdf',
    NODE_SHIPMENT_LABEL_PDF: 'shipment-label-pdf',
    NODE_GET_ORDERS: 'get-orders',
    NODE_GET_ORDERS_V_2: 'get-orders-v2',
    NODE_GET_QUOTES: 'get-quotes',
    NODE_NEW_QUOTE_SENTS: 'new-quote-sents',
    NODE_NEW_FLAGS: 'new-flags',
    NODE_DELETE_FLAGS: 'delete-flags',
    NODE_USER_HAS_FLAG: 'user-has-flag',
    NODE_ORDER_HAS_FLAG: 'order-has-flag',
    NODE_GET_FLAGS: 'get-flags',
    NODE_GET_FLAG_FLAGS: 'get-flag-flags',
    NODE_EXPIRE_FLAG_FLAGS: 'expire-flag-flags',
    NODE_ORDER_TAX_JAR_SYNC: 'order-tax-jar-sync',
    NODE_ORDER_TAX_EXEMPTION_INCONSISTENT: 'order-tax-exemption-inconsistent',
    NODE_ORDER_DUPLICATE_PURCHASE_ORDER: 'order-duplicate-purchase-order',
    NODE_SHIPPING_OPTION_UPDATED: 'shipping-option-updated',
    NODE_ORDER_SHIPPING_OPTION_UPDATED: 'order-shipping-option-updated',
    NODE_ORDER_TOTAL_UPDATED: 'order-total-updated',
    NODE_ORDER_TOTAL_SANS_TAX_UPDATED: 'order-total-sans-tax-updated',
    NODE_ORDER_FACTORY_COST_UPDATED: 'order-factory-cost-updated',
    NODE_USER_TAX_EXEMPTION_ORDER_CREATED: 'user-tax-exemption-order-created',
    NODE_USER_TAX_EXEMPTION_ORDER_DELETED: 'user-tax-exemption-order-deleted',
    NODE_USER_TAX_EXEMPTION_CREATED: 'user-tax-exemption-created',
    NODE_USER_TAX_EXEMPTION_UPDATED: 'user-tax-exemption-updated',
    NODE_USER_TAX_EXEMPTION_DELETED: 'user-tax-exemption-deleted',
    NODE_USER_ADMIN_ROLE_CREATED: 'user-admin-role-created',
    NODE_USER_ADMIN_ROLE_UPDATED: 'user-admin-role-updated',
    NODE_USER_NETWORK_CREATED: 'user-network-created',
    NODE_USER_NETWORK_DELETED: 'user-network-deleted',
    NODE_USER_COMPANY_CREATED: 'user-company-created',
    NODE_USER_COMPANY_DELETED: 'user-company-deleted',
    NODE_USER_MANAGING_COMPANY_CREATED: 'user-managing-company-created',
    NODE_USER_MANAGING_COMPANY_UPDATED: 'user-managing-company-updated',
    NODE_USER_FACTORY_CREATED: 'user-factory-created',
    NODE_USER_FACTORY_UPDATED: 'user-factory-updated',
    NODE_ORDER_SHIPPING_OPTION_CREATED: 'order-shipping-option-created',
    NODE_ORDER_SHIPPING_OPTION_DELETED: 'order-shipping-option-deleted',
    NODE_SHIPPING_OPTION_DELETED: 'shipping-option-deleted',
    NODE_GET_SHIPPING_OPTIONS: 'get-shipping-options',
    NODE_GET_USER_TAX_EXEMPTIONS: 'get-user-tax-exemptions',
    NODE_ORDER_DELETED: 'order-deleted',
    NODE_ORDER_RESTORED: 'order-restored',
    NODE_ORDER_MARKED_AS_SHIPPED_UPDATED: 'order-marked-as-shipped-updated',
    NODE_ORDER_MARKED_AS_SHIPPED: 'order-marked-as-shipped',
    NODE_ORDER_ORDER_STATUS_UPDATED: 'order-order-status-updated',
    NODE_ORDER_LINE_ITEMS_UPDATED: 'order-line-items-updated',
    NODE_PURGE_NOTIFICATIONS: 'delete-old-notifications',
    NODE_PURGE_DATA_TABLES: 'delete-old-datatables',
    NODE_PURGE_MEILISEARCH_LOG: 'purge-meilisearch-log',
    NODE_UPDATE_BUBBLE_COUNTS: 'update-bubble-counts',
    NODE_ORDER_SHIPPING_ACCOUNT_UPDATED: 'order-shipping-account-updated',
    NODE_ORDER_SALES_TEAM_UPDATED: 'order-sales-team-updated',
    NODE_ORDER_BIDS_NEEDED_UPDATED: 'order-bids-needed-updated',
    NODE_ORDER_UPDATED_BY_USER_UPDATED: 'order-updated-by-user-updated',
    NODE_ORDER_SALES_USER_UPDATED: 'order-sales-user-updated',
    NODE_ORDER_FACTORY_SHIP_DATE_UPDATED: 'order-factory-ship-date-updated',
    NODE_ORDER_CUSTOMER_SHIP_DATE_UPDATED: 'order-customer-ship-date-updated',
    NODE_ORDER_CUSTOMER_EVENT_DATE_UPDATED: 'order-event-date-updated',
    NODE_GET_FACTORIES: 'get-factories',
    NODE_ORDER_UPDATED: 'order-updated',
    NODE_ORDER_RESET_TOTALS: 'order-reset-totals',
    NODE_GET_ORDER_ORDERS: 'get-order-orders',
    NODE_ORDER_SHIPPING_OPTION_SHIPPING_OPTION_UPDATED: 'order-shipping-option-shipping-option-updated',
    NODE_IMPORT_NEW_SHIPPING_INVOICES: 'import-new-shipping-invoices',
    NODE_NEW_UNSUBSCRIBED_EMAIL: 'new-unsubscribed-email',
    NODE_GET_USER_EVENTS: 'get-user-events',
    NODE_NEW_USER_EVENT: 'new-user-event',
    NODE_USER_EVENT_DELETED: 'user-event-deleted',
    NODE_UPDATE_USER_EVENTS: 'update-user-events',
    NODE_UPDATE_USER_EVENT: 'update-user-event',
    NODE_USER_EVENTS_UPDATED: 'user-events-updated',
    NODE_USER_EVENTS_DELETED: 'user-events-deleted',
    NODE_PURGE_NODE_FLOW_INSTANCES: 'purge-node-flow-instances',
    NODE_NEW_PROMOTIONAL_CODES: 'new-promotional-codes',
    NODE_GET_PROMOTIONAL_CODES: 'get-promotional-codes',
    NODE_PAYMENT_OPTION_DELETED: 'payment-option-deleted',
    NODE_GET_ORDER_TAXES: 'get-order-taxes',
    NODE_CONTACT_CREATED: 'contact-created',
    NODE_PODIUM_IMPORT_MESSAGE: 'podium-import-message',
    NODE_PODIUM_UPDATE_CONVERSATION: 'podium-update-conversation',
    NODE_PODIUM_GET_CONVERSATION: 'podium-get-conversation',
    NODE_PODIUM_GET_CALL: 'podium-get-call',
    NODE_PODIUM_ENABLED: 'podium-enabled',
    NODE_UPDATE_ORDER: 'update-order',
    NODE_FACTORY_EXCLUDED: 'factory-excluded',
    NODE_PODIUM_CREATE_CONTACT_TAG: 'podium-create-contact-tag',
    NODE_PODIUM_DELETE_CONTACT_TAG: 'podium-delete-contact-tag',
    NODE_PODIUM_GET_CONTACT: 'podium-get-contact',
    NODE_PODIUM_GET_CONTACT_CONVERSATIONS: 'podium-get-contact-conversations',
    NODE_PODIUM_NEW_NOTE: 'podium-new-note',
    NODE_PODIUM_UPDATE_CONVERSATION_ASSIGNEES: 'podium-update-conversation-assignees',
    NODE_PODIUM_PUSH_CUSTOMER_TEAM: 'podium-push-customer-team',
    NODE_GET_QUOTE_SENTS: 'get-quote-sents',
    NODE_QUOTE_REQUEST_UPDATED: 'quote-request-updated',
    NODE_GET_QUOTE_REQUESTS: 'get-quote-requests',
    NODE_QUOTE_REQUEST_ACTIVE_UPDATED: 'quote-request-active-updated',
    NODE_USER_ADDED_BALANCE: 'user-added-balance',
    NODE_QUOTE_REQUEST_PROJECT_TASK_CREATED: 'quote-request-project-task-created',
    NODE_GET_QUOTE_REQUEST_PROJECT_TASKS: 'get-quote-request-project-tasks',
    NODE_NEW_QUOTE_REQUEST_PROJECT_TASK: 'new-qrpt',
    NODE_BLOG_POST_PUBLISHED_UPDATED: 'blog-post-published-updated',
    NODE_BLOG_POST_PUBLISH: 'blog-post-publish',
    NODE_BLOG_POST_PUBLISHED: 'blog-post-published',
    NODE_BLOG_POST_DELETED: 'blog-post-deleted',
    NODE_QUOTE_REQUEST_PROJECT_TASK_USER_EVENT_CREATED: 'qrpt-user-event-created',
    NODE_QUOTE_REQUEST_PROJECT_TASK_DELETED: 'qrpt-deleted',
    NODE_QUOTE_REQUEST_PROJECT_TASK_CANCELED: 'qrpt-canceled',
    NODE_QUOTE_REQUEST_PROJECT_TASK_PREPAID: 'qrpt-prepaid',
    NODE_QUOTE_REQUEST_PROJECT_TASK_STATUS_REOPENED: 'qrpt-status-reopened',
    NODE_QUEUE_QUOTE_REQUEST_PROJECT_MEILI_INDEX: 'qrp-meili-index',
    NODE_REINDEX_QUOTE_REQUEST_PROJECTS: 'qrp-reindex',
    NODE_REINDEX_QUOTE_REQUEST_PROJECTS_CHUNK: 'qrp-reindex-chunk',
    NODE_USER_EVENT_CREATED: 'user-event-created',
    NODE_USER_EVENT_UPDATED: 'user-event-updated',
    NODE_QUOTE_UPDATED: 'quote-updated',
    NODE_QUOTE_CREATED: 'quote-created',
    NODE_QUOTE_REQUEST_PROJECT_TASK_ACTIVE_UPDATED: 'qrpt-active-updated',
    NODE_USER_UPDATED: 'user-updated',
    NODE_USER_ORDER_BID_CREATED: 'user-order-bid-created',
    NODE_USER_ORDER_BID_UPDATED: 'user-order-bid-updated',
    NODE_NEW_USER_ORDER_BID: 'new-user-order-bid',
    NODE_GET_USER_ORDER_BIDS: 'get-user-order-bids',
    NODE_USER_ORDER_BID_ACCEPTED: 'user-order-bid-accepted',
    NODE_UPDATE_USER_ORDER_BID: 'update-user-order-bid',
    NODE_GET_NODE_FLOW_INSTANCES: 'get-node-flow-instances',
    NODE_GET_LOG: 'get-log',
    NODE_NEW_USER_EXISTS: 'new-user-exists',
    NODE_ORDER_QBO_SYNC: 'order-qbo-sync',
    NODE_USER_QBO_SYNC: 'user-qbo-sync',
    NODE_ORDER_PAYMENT_QBO_SYNC: 'order-payment-qbo-sync',
    NODE_FACTORY_BILL_QBO_SYNC: 'factory-bill-qbo-sync',
    NODE_GET_ORDER_PAYMENTS: 'get-order-payments',
    NODE_GET_PROOFS: 'get-proofs',
    NODE_ORDER_SHIPPING_OPTIONS_MEILI_INDEX: 'order-shipping-options-meili-index',
    NODE_ORDER_SHIPPING_OPTIONS_MEILI_INDEX_DELETE: 'order-shipping-options-meili-index-delete',
    NODE_GET_UPLOADS: 'get-uploads',
    NODE_UPLOAD_GENERATE_DESCRIPTION: 'upload-generate-description',
    NODE_OCR_UPLOAD: 'ocr-upload',
    NODE_REMOVE_BACKGROUND: 'remove-background',
    NODE_GET_LINE_ITEMS: 'get-line-items',
    NODE_CALL_ASSISTANT: 'call-assistant',
    NODE_NEW_TEXT_MESSAGE: 'new-text-message',
    NODE_TEXT_MESSAGE_CREATED: 'text-message-created',
    NODE_TEXT_MESSAGE_UPDATED: 'text-message-updated',
    NODE_CALL_CREATED: 'call-created',
    NODE_CALL_UPDATED: 'call-updated',
    NODE_GET_CALLS: 'get-calls',
    NODE_NEW_CALL: 'new-call',
    NODE_UPDATE_CALL: 'update-call',
    NODE_UPSERT_CALL: 'upsert-call',
    NODE_EMAIL_CREATED: 'email-created',
    NODE_EMAIL_UPDATED: 'email-updated',
    NODE_GET_EMAILS: 'get-emails',
    NODE_GET_EMAIL_CATEGORIES: 'get-email-categories',
    NODE_NEW_EMAILS: 'new-emails',
    NODE_DELETE_EMAILS: 'delete-emails',
    NODE_EXTRACT_EMAIL_CONTENT: 'extract-email-content',
    NODE_NEW_EMAIL: 'new-email',
    NODE_FORWARD_EMAIL: 'forward-email',
    NODE_SEND_EMAIL: 'send-email',
    NODE_QUEUE_EMAILS: 'queue-emails',
    NODE_SEND_EMAIL_CHUNK: 'send-email-chunk',
    NODE_UPDATE_EMAIL: 'update-email',
    NODE_RECORD_EMAIL_BOUNCE: 'record-email-bounce',
    NODE_NEW_EMAIL_OPEN: 'new-email-open',
    NODE_NEW_EMAIL_CLICK: 'new-email-click',
    NODE_SEND_TEXT_MESSAGE: 'send-text-message',
    NODE_NEW_PHONE_NUMBER: 'new-phone-number',
    NODE_GET_TEXT_MESSAGES: 'get-text-messages',
    NODE_UPDATE_TEXT_MESSAGE: 'update-text-message',
    NODE_UPDATE_TEXT_CONVERSATION: 'update-text-conversation',
    NODE_UPSERT_TEXT_CONVERSATION: 'upsert-text-conversation',
    NODE_EMAIL_CONVERSATION_CREATED: 'email-conversation-created',
    NODE_EMAIL_CONVERSATION_UPDATED: 'email-conversation-updated',
    NODE_GET_EMAIL_CONVERSATIONS: 'get-email-conversations',
    NODE_UPDATE_EMAIL_CONVERSATION: 'update-email-conversation',
    NODE_UPSERT_EMAIL_CONVERSATION: 'upsert-email-conversation',
    NODE_WORKFLOW_MATCH: 'workflow-match',
    NODE_WORKFLOW_ACTION: 'workflow-action',
    NODE_PUT_DETAIL: 'put-detail',
    NODE_GET_DETAILS: 'get-details',
    NODE_GET_DATES: 'get-dates',
    NODE_SALES_TEAM_LEADERBOARD: 'sales-team-leaderboard',
    NODE_FETCH_URL: 'fetch-url',
    NODE_DISPATCH_GIT_HUB_WORKFLOW: 'dispatch-github-workflow',
    NODE_NOTIFY_DEV_SLACK: 'notify-dev-slack',
    NODE_GROUP_CHAT_MESSAGE_CREATED: 'group-chat-message-created',
    NODE_GROUP_CHAT_MESSAGE_UPDATED: 'group-chat-message-updated',
    NODE_GET_GROUP_CHAT_MESSAGES: 'get-group-chat-messages',
    NODE_NEW_GROUP_CHAT_MESSAGE: 'new-group-chat-message',
    NODE_UPDATE_GROUP_CHAT_MESSAGE: 'update-group-chat-message',
    NODE_FACEBOOK_CONVERSIONS_API: 'facebook-conversions-api',
    NODE_GOOGLE_CONVERSIONS_API: 'google-conversions-api',
    NODE_GOOGLE_CONVERSIONS_STATUS: 'google-conversions-status',
    NODE_TRYBE_ORDERS_API: 'trybe-orders-api',
    NODE_LEAD_EXPECTED_VALUES: 'lead-expected-values',
    NODE_ORGANIZATION_CREATED: 'organization-created',
    NODE_ORGANIZATION_UPDATED: 'organization-updated',
    NODE_ORGANIZATION_MEMBER_CREATED: 'organization-member-created',
    NODE_ORGANIZATION_MEMBER_UPDATED: 'organization-member-updated',
    NODE_ORGANIZATION_INVITE_CREATED: 'organization-invite-created',
    NODE_ORGANIZATION_INVITE_UPDATED: 'organization-invite-updated',
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type NodeName = typeof NodeName[keyof typeof NodeName];
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface NodeContext {
    payloads: Record<number, unknown>;
    ids?: NodeContextIDs;
    data: Record<string, unknown>;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface NodeContextIDs {
    nodeFlowID?: string;
    networkID?: string;
    companyID?: string;
    userID?: string;
    orderID?: string;
    parentOrderID?: string;
    loginCodeID?: string;
    cartID?: string;
    cartItemID?: string;
    quoteID?: string;
    stockItemID?: string;
    uploadID?: number;
    shippingOptionID?: string;
    paymentOptionID?: string;
    quoteRequestID?: string;
    quoteRequestProjectID?: string;
    quoteRequestProjectTaskID?: string;
    forgotPasswordID?: number;
    countryID?: CountryID;
    stateID?: StateID;
    salesTeamID?: string;
    pageRequestID?: string;
    quoteSentID?: string;
    quoteSentInstanceID?: string;
    imageID?: string;
    flagID?: FlagID;
    flagFlagID?: string;
    userTaxExemptionID?: string;
    orderShippingOptionID?: string;
    factoryID?: string;
    carrierID?: CarrierID;
    promotionalCodeID?: string;
    orderPaymentID?: string;
    contactID?: string;
    orderShippingOptionShipmentID?: string;
    shipmentID?: string;
    blogPostID?: string;
    userEventID?: string;
    userEventUploadID?: string;
    userOrderBidID?: string;
    followUpID?: string;
    textMessageID?: string;
    callID?: string;
    emailID?: string;
    lineItemID?: string;
    groupChatID?: string;
    groupChatMessageID?: string;
    emailConversationID?: string;
    textConversationID?: string;
    formSubmissionID?: string;
    designID?: string;
    designProofID?: string;
    organizationID?: string;
    organizationMemberID?: string;
    organizationInviteID?: string;
    orderExceptionID?: string;
    createdByUserID?: string;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare type Nodes = Node[];
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface Node {
    nodeID: number;
    name: NodeName;
    data: Record<string, unknown>;
    outputs: NodeOutput[];
    title: string;
    description: string;
    payloads?: string;
    x: number;
    y: number;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface NodeOutput {
    output: number;
    nodeID: number;
    input: number;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface NodeInput {
    output: number;
    nodeID: number;
    input: number;
}

// go/v2/notifications.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface NotificationCategoryPreference {
    name: string;
    enabled: boolean;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface NotificationChannelPreferences {
    enabled: boolean;
    pausedUntil?: string;
    categories: NotificationCategoryPreference[];
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface NotificationPreferences {
    emails: NotificationChannelPreferences;
    textMessages: NotificationChannelPreferences;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface NotificationPreferencesUpdate {
    emails?: EmailsUpdate;
    textMessages?: TextMessagesUpdate;
}

// go/v2/orderartrewardallocations.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface OrderArtRewardAllocation {
    id?: string;
    orderArtRewardID?: string;
    orderID?: string;
    orderLineItemID?: string;
    designArtPointID?: string;
    designID?: string;
    requestingDesignVersion?: number;
    kind?: DesignArtPointKind;
    userID?: string;
    points: string;
    share: string;
    amount: string;
    createdByUserID?: string;
    created?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
}

// go/v2/orderartrewards.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface OrderArtReward {
    id?: string;
    orderID?: string;
    orderLineItemID?: string;
    designID?: string;
    designProofID?: string;
    networkArtRewardPolicyID?: string;
    networkArtRewardPolicyVersion?: number;
    perSideAmount: string;
    sides?: number;
    total: string;
    totalPoints: string;
    createdByUserID?: string;
    created?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
}

// go/v2/orderchildlineitems.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface OrderChildLineItem {
    id?: string;
    orderLineItemID?: string;
    childLineItemID?: ChildLineItemID;
    child?: string;
    childLineItemOptionID?: ChildLineItemOptionID;
    option?: string;
    autoQuantity?: boolean;
    linkedQuantity?: boolean;
    quantity?: number;
    price?: string;
    description?: string;
    sortOrder?: number;
    factoryCost?: string;
    chargeSalesTeam?: boolean;
    factoryID?: string;
    cachedOrderID?: string;
    cachedTotal?: string;
    cachedFactoryCost?: string;
    cachedOriginalFactoryID?: string;
    cachedExpectedFactoryChildCost?: string;
    cachedExpectedFactoryOptionCost?: string;
    cachedTotalExpectedFactoryCost?: string;
    cachedLineItemTypeSizeID?: string;
    cachedParentQuantity?: number;
    cachedExpectedFactoryChildQuantityCost?: string;
    cachedExpectedFactoryOptionQuantityCost?: string;
    cachedLineItemTypeSizeMurmur2?: number;
    cachedNetworkID?: string;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    orderLineItem?: OrderLineItem;
    order?: Order;
    childLineItem?: ChildLineItem;
    childLineItemOption?: ChildLineItemOption;
    factory?: Factory;
}

// go/v2/orderconfirmations.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface OrderConfirmation {
    id?: string;
    orderID?: string;
    factoryID?: string;
    originalFactoryID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    factory?: Factory;
    originalFactory?: Factory;
    order?: Order;
}

// go/v2/orderdetails.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface OrderDetail {
    id?: string;
    orderID?: string;
    name?: string;
    value?: unknown;
    active?: boolean;
    created?: string;
    updated?: string;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface OrderDetails {
    factoryPreference: string[];
    biddingWaitUntil?: string;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface OrderDetailsMod {
    factoryPreference?: string[];
    biddingWaitUntil?: string;
}

// go/v2/orderexceptions.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface OrderException {
    id?: string;
    orderID?: string;
    type?: OrderExceptionType;
    reasonCode?: OrderExceptionReasonCode;
    severity?: OrderExceptionSeverity;
    source?: OrderExceptionSource;
    openedByUserID?: string;
    ownerUserID?: string;
    resolvedByUserID?: string;
    opened?: string;
    firstResponse?: string;
    resolved?: string;
    customerImpact?: boolean;
    costImpact?: string;
    costBearer?: OrderExceptionCostBearer;
    requiresApproval?: boolean;
    approvedByUserID?: string;
    approved?: string;
    outcome?: OrderExceptionOutcome;
    proofID?: string;
    groupChatMessageID?: string;
    shipmentID?: string;
    relatedOrderID?: string;
    notes?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
}
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const OrderExceptionType = {
    ORDER_EXCEPTION_TYPE_RETURNED_TO_SALES: 'returnedToSales',
    ORDER_EXCEPTION_TYPE_RETURNED_TO_ART: 'returnedToArt',
    ORDER_EXCEPTION_TYPE_PRODUCTION_RISK: 'productionRisk',
    ORDER_EXCEPTION_TYPE_ESCALATION: 'escalation',
    ORDER_EXCEPTION_TYPE_LATE_RISK: 'lateRisk',
    ORDER_EXCEPTION_TYPE_REMAKE_ROOT_CAUSE: 'remakeRootCause',
    ORDER_EXCEPTION_TYPE_FACTORY_COST_DISPUTE: 'factoryCostDispute',
    ORDER_EXCEPTION_TYPE_CUSTOMER_CONCESSION: 'customerConcession',
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type OrderExceptionType = typeof OrderExceptionType[keyof typeof OrderExceptionType];
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const OrderExceptionReasonCode = {
    ORDER_EXCEPTION_REASON_CODE_SALES_SPEC_OMISSION: 'salesSpecOmission',
    ORDER_EXCEPTION_REASON_CODE_SALES_DEADLINE_MISS: 'salesDeadlineMiss',
    ORDER_EXCEPTION_REASON_CODE_EXPECTATION_MISMATCH: 'expectationMismatch',
    ORDER_EXCEPTION_REASON_CODE_ART_PROOF_ERROR: 'artProofError',
    ORDER_EXCEPTION_REASON_CODE_ART_MANUFACTURABILITY: 'artManufacturability',
    ORDER_EXCEPTION_REASON_CODE_CUSTOMER_CHANGE_AFTER_APPROVAL: 'customerChangeAfterApproval',
    ORDER_EXCEPTION_REASON_CODE_FACTORY_DEFECT: 'factoryDefect',
    ORDER_EXCEPTION_REASON_CODE_FACTORY_DELAY: 'factoryDelay',
    ORDER_EXCEPTION_REASON_CODE_SHIPPING_LOSS_OR_DELAY: 'shippingLossOrDelay',
    ORDER_EXCEPTION_REASON_CODE_ACCOUNTING_PAYMENT_HOLD: 'accountingPaymentHold',
    ORDER_EXCEPTION_REASON_CODE_OPS_MISS: 'opsMiss',
    ORDER_EXCEPTION_REASON_CODE_PROCESS_GAP: 'processGap',
    ORDER_EXCEPTION_REASON_CODE_UNAVOIDABLE: 'unavoidable',
    ORDER_EXCEPTION_REASON_CODE_NO_FACTORY_ETA: 'noFactoryEta',
    ORDER_EXCEPTION_REASON_CODE_ETA_PAST_SHIP_DATE: 'etaPastShipDate',
    ORDER_EXCEPTION_REASON_CODE_NO_TRACKING_NEAR_SHIP_DATE: 'noTrackingNearShipDate',
    ORDER_EXCEPTION_REASON_CODE_TRACKING_NO_MOVEMENT: 'trackingNoMovement',
    ORDER_EXCEPTION_REASON_CODE_FACTORY_UNRESPONSIVE: 'factoryUnresponsive',
    ORDER_EXCEPTION_REASON_CODE_UNCONFIRMED_TOO_LONG: 'unconfirmedTooLong',
    ORDER_EXCEPTION_REASON_CODE_TRANSIT_TOO_SLOW: 'transitTooSlow',
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type OrderExceptionReasonCode = typeof OrderExceptionReasonCode[keyof typeof OrderExceptionReasonCode];
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const OrderExceptionSeverity = {
    ORDER_EXCEPTION_SEVERITY_LOW: 'low',
    ORDER_EXCEPTION_SEVERITY_MEDIUM: 'medium',
    ORDER_EXCEPTION_SEVERITY_HIGH: 'high',
    ORDER_EXCEPTION_SEVERITY_CRITICAL: 'critical',
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type OrderExceptionSeverity = typeof OrderExceptionSeverity[keyof typeof OrderExceptionSeverity];
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const OrderExceptionSource = {
    ORDER_EXCEPTION_SOURCE_CUSTOMER: 'customer',
    ORDER_EXCEPTION_SOURCE_SALES: 'sales',
    ORDER_EXCEPTION_SOURCE_ART: 'art',
    ORDER_EXCEPTION_SOURCE_FACTORY: 'factory',
    ORDER_EXCEPTION_SOURCE_OPS: 'ops',
    ORDER_EXCEPTION_SOURCE_ACCOUNTING: 'accounting',
    ORDER_EXCEPTION_SOURCE_SYSTEM: 'system',
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type OrderExceptionSource = typeof OrderExceptionSource[keyof typeof OrderExceptionSource];
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const OrderExceptionOutcome = {
    ORDER_EXCEPTION_OUTCOME_RESOLVED_ON_TIME: 'resolvedOnTime',
    ORDER_EXCEPTION_OUTCOME_MISSED: 'missed',
    ORDER_EXCEPTION_OUTCOME_CONCESSION: 'concession',
    ORDER_EXCEPTION_OUTCOME_CHARGEBACK_RECOVERED: 'chargebackRecovered',
    ORDER_EXCEPTION_OUTCOME_REMADE: 'remade',
    ORDER_EXCEPTION_OUTCOME_NO_ACTION_NEEDED: 'noActionNeeded',
    ORDER_EXCEPTION_OUTCOME_ACCEPTED_RISK: 'acceptedRisk',
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type OrderExceptionOutcome = typeof OrderExceptionOutcome[keyof typeof OrderExceptionOutcome];
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const OrderExceptionState = {
    ORDER_EXCEPTION_STATE_OPEN: 'open',
    ORDER_EXCEPTION_STATE_RESOLVED: 'resolved',
    ORDER_EXCEPTION_STATE_DELETED: 'deleted',
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type OrderExceptionState = typeof OrderExceptionState[keyof typeof OrderExceptionState];
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const OrderExceptionCostBearer = {
    ORDER_EXCEPTION_COST_BEARER_US: 'us',
    ORDER_EXCEPTION_COST_BEARER_FACTORY: 'factory',
    ORDER_EXCEPTION_COST_BEARER_SALES_TEAM: 'salesTeam',
    ORDER_EXCEPTION_COST_BEARER_CUSTOMER: 'customer',
    ORDER_EXCEPTION_COST_BEARER_SPLIT: 'split',
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type OrderExceptionCostBearer = typeof OrderExceptionCostBearer[keyof typeof OrderExceptionCostBearer];
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const OrderExceptionApprovalState = {
    ORDER_EXCEPTION_APPROVAL_STATE_NOT_REQUIRED: 'notRequired',
    ORDER_EXCEPTION_APPROVAL_STATE_PENDING: 'pending',
    ORDER_EXCEPTION_APPROVAL_STATE_APPROVED: 'approved',
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type OrderExceptionApprovalState = typeof OrderExceptionApprovalState[keyof typeof OrderExceptionApprovalState];
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const OrderExceptionTransition = {
    ORDER_EXCEPTION_TRANSITION_RESOLVE: 'resolve',
    ORDER_EXCEPTION_TRANSITION_REOPEN: 'reopen',
    ORDER_EXCEPTION_TRANSITION_APPROVE: 'approve',
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type OrderExceptionTransition = typeof OrderExceptionTransition[keyof typeof OrderExceptionTransition];

// go/v2/orderlineitemblanks.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface OrderLineItemBlank {
    id?: string;
    orderLineItemID?: string;
    blankID?: string;
    blankVersion?: number;
    quantity?: number;
    createdByUserID?: string;
    created?: string;
    validUntil?: string;
    blank?: Blank;
}

// go/v2/orderlineitemmolds.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface OrderLineItemMold {
    id?: string;
    orderLineItemID?: string;
    moldID?: string;
    createdByUserID?: string;
    created?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
}

// go/v2/orderlineitems.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface OrderLineItem {
    id?: string;
    orderID?: string;
    lineItemID?: LineItemID;
    lineItem?: string;
    lineItemTypeID?: LineItemTypeID;
    type?: string;
    lineItemTypeSizeID?: string;
    size?: string;
    quantity?: number;
    price?: string;
    description?: string;
    salesTeamID?: string;
    factoryID?: string;
    shippingAccountID?: string;
    orderProofID?: string;
    networkSKUID?: string;
    quoteLineItemID?: string;
    designProofID?: string;
    parentOrderLineItemID?: string;
    stockItemID?: string;
    sortOrder?: number;
    factoryCost?: string;
    chargeSalesTeam?: boolean;
    artistReward?: string;
    editables?: unknown;
    builderDesignID?: string;
    builderDesignVersion?: number;
    cachedTotal?: string;
    cachedFactoryCost?: string;
    cachedTotalExpectedFactoryCost?: string;
    cachedCompanyID?: string;
    cachedNetworkID?: string;
    cachedOriginalFactoryID?: string;
    cachedPendingUpdated?: string;
    cachedTax?: boolean;
    cachedFactory?: boolean;
    cachedStats?: boolean;
    cachedWidth?: string;
    cachedHeight?: string;
    cachedLineItemTypeSizeMurmur2?: number;
    orderLineItemIDSHA3224?: string;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    customerEditable?: boolean;
    invalidCustomQuantity?: boolean;
    quantityTiers?: QuantityTierPrice[];
    order?: Order;
    lineItemModel?: LineItem;
    lineItemType?: LineItemType;
    lineItemTypeSize?: LineItemTypeSize;
    networkSKU?: NetworkSKU;
    quoteLineItem?: QuoteLineItem;
    orderProof?: OrderProof;
    stockItem?: StockItem;
    orderChildLineItems?: OrderChildLineItem[];
    orderLineItemStages?: OrderLineItemStage[];
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface QuantityTierPrice {
    quantity: number;
    unitPrice: string;
    fixedPrice: string;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface ResolvedOrderLineItem {
    id: string;
    childIDs: string[];
}

// go/v2/orderlineitemstages.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface OrderLineItemStage {
    id?: string;
    orderLineItemID?: string;
    stageID?: string;
    start?: string;
    stop?: string;
    user?: string;
    notes?: string;
    denormOrderID?: string;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    orderLineItem?: OrderLineItem;
    stage?: Stage;
    createdBy?: User;
}

// go/v2/ordermanagingcompanypercentages.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface OrderManagingCompanyPercentage {
    id?: number;
    orderID?: string;
    managingCompanyID?: string;
    rate?: string;
    active?: boolean;
    created?: string;
    updated?: string;
}

// go/v2/orderorders.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface OrderOrder {
    id?: number;
    orderID?: string;
    parentOrderID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
}

// go/v2/orderpayments.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface OrderPayment {
    id?: string;
    orderID?: string;
    paymentOptionID?: string;
    originalChargeCompanyID?: string;
    userBalanceTransactionID?: string;
    total?: string;
    checkNumber?: string;
    purchaseOrderNumber?: string;
    paid?: string;
    staxTransactionID?: string;
    payPalToken?: string;
    qboPaymentID?: string;
    qboSync?: boolean;
    qboDeposited?: boolean;
    denormPaymentOptionTypeID?: PaymentOptionTypeID;
    denormUserID?: string;
    denormTransactionID?: string;
    createdByUserID?: string;
    created?: string;
    updated?: string;
    active?: boolean;
    order?: Order;
    createdBy?: User;
    paymentOption?: PaymentOption;
    originalChargeRealm?: Realm;
    orderPayments?: OrderPayment[];
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface PurchaseOrderDuplicatesResponse {
    duplicates: Order[];
}

// go/v2/orderproofs.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface OrderProof {
    id?: string;
    orderID?: string;
    proofID?: string;
    name?: string;
    createdByUserID?: string;
    updatedByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    order?: Order;
    proof?: Proof;
    createdBy?: User;
    updatedBy?: User;
    quoteProof?: QuoteProof;
    stockItemImage?: StockItemImage;
}

// go/v2/orders.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface Order {
    id?: string;
    invoiceNumber?: number;
    companyID?: string;
    orderStatusID?: OrderStatusID;
    invoiceStatusID?: InvoiceStatusID;
    factoryID?: string;
    originalFactoryID?: string;
    shippingAccountID?: string;
    promotionalCodeID?: string;
    linkID?: string;
    salesTeamID?: string;
    originalSalesTeamID?: string;
    userID?: string;
    clientID?: string;
    salesUserID?: string;
    pageRequestID?: string;
    parentOrderID?: string;
    problemOrderID?: string;
    factoryCostUpdatedUserID?: string;
    factoryCostApprovedLastUserID?: string;
    name?: string;
    date?: string;
    confirmedTime?: string;
    placedTime?: string;
    factoryShipDate?: string;
    customerShipDate?: string;
    factoryConfirmedShipDate?: string;
    eventDate?: string;
    dueDate?: string;
    lateOrderIgnored?: string;
    pending?: boolean;
    preorder?: boolean;
    bidsNeeded?: boolean;
    sync?: boolean;
    key?: string;
    saveID?: string;
    unshippedSortOrder?: number;
    markedAsShipped?: boolean;
    markedAsShippedTime?: string;
    markedAsShippedUserID?: string;
    placeOrder?: number;
    placeOrderRemind?: boolean;
    factoryCostUpdatedTime?: string;
    factoryCostApprovedReason?: FactoryCostApprovedReasonID;
    factoryCostApproved?: string;
    pendingUpdated?: string;
    taxJarSynced?: string;
    taxJarInactive?: boolean;
    taxTransactionDate?: string;
    taxPropsHash?: string;
    qboInvoiceID?: string;
    qboBillID?: string;
    qboSync?: boolean;
    qboFactoryCostSync?: boolean;
    qboFactoryCostSynced?: string;
    billTransfer?: number;
    billTransferred?: string;
    remindCount?: number;
    noInvoice?: boolean;
    chargeSalesTeamPercent?: string;
    promotionalApproval?: boolean;
    classicForm?: boolean;
    potentialOwnerReferralAmount?: string;
    ownerReferralGranted?: string;
    orderIDSHA3224?: string;
    total?: string;
    totalSansTax?: string;
    paid?: string;
    factoryCost?: string;
    expectedFactoryCost?: string;
    shippingCost?: string;
    balance?: string;
    paidUpdated?: string;
    shipByForEventDate?: string;
    shipmentsCount?: number;
    primaryShipmentsCount?: number;
    apo?: number;
    apoIgnored?: number;
    apoTracking?: number;
    shippingOptions?: number;
    fromBuildingShipments?: number;
    delivered?: string;
    unconfirmedOrPreorder?: boolean;
    networkID?: string;
    referer?: string;
    refererRootDomain?: string;
    refererRootDomainMurmur2?: number;
    pendingUpdatedDate?: string;
    notSynced?: number;
    customerShipDateDenorm?: string;
    firstIngressPageRequestID?: string;
    lastIngressPageRequestID?: string;
    createdByUserID?: string;
    updatedByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    factory?: Factory;
    shippingAccount?: ShippingAccount;
    salesTeam?: SalesTeam;
    realm?: Realm;
    user?: User;
    firstIngressPageRequest?: PageRequest;
    lastIngressPageRequest?: PageRequest;
    salesUser?: User;
    createdBy?: User;
    lateRisk?: OrderException;
    quoteOrders?: QuoteOrder[];
    orderOrders?: OrderOrder[];
    artistRewards?: ArtistReward[];
    orderProofs?: OrderProof[];
    orderLineItems?: OrderLineItem[];
    orderShippingOptions?: OrderShippingOption[];
    userTaxExemptionOrders?: UserTaxExemptionOrder[];
    orderPayments?: OrderPayment[];
    quoteRequestProjectTasks?: QuoteRequestProjectTask[];
    flagFlags?: FlagFlag[];
    userFlagIDs?: FlagID[];
    groupChatMessages?: GroupChatMessage[];
    orderUploads?: OrderUpload[];
    purchaseOrderFiles?: PurchaseOrderFile[];
    orderDetails?: OrderDetails;
    rawOrderDetails?: OrderDetail[];
    userOrderBids?: UserOrderBid[];
    orderConfirmations?: OrderConfirmation[];
    applyPrepaidDeposits?: boolean;
    skipDepositOrderIDs?: string[];
    hasVerifiedPayment?: boolean;
    factoryHasAcceptedBid?: boolean;
    forcedNewShipping?: boolean;
    ignoreFactoryExclusions?: boolean;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface ShipmentOrderRefusal {
    orderID: string;
    invoiceNumber: number;
    code: string;
    reason: string;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface OrderPackagingUpgrade {
    orderLineItemID: string;
    childLineItemID: string;
    availableUntil: string;
    options: OrderPackagingUpgradeOption[];
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface OrderPackagingUpgradeOption {
    childLineItemOptionID: string;
    name: string;
    description?: string;
    quantity: number;
    maxQuantity: number;
    unitPrice: string;
}

// go/v2/ordershippingoptions.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface OrderShippingOption {
    id?: string;
    orderID?: string;
    shippingOptionID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    createdByUserID?: string;
    updatedByUserID?: string;
    apo?: boolean;
    shipments?: number;
    primaryShipments?: number;
    apoTracking?: number;
    fromBuildingShipments?: number;
    cachedCost?: string;
    companyID?: string;
    factoryID?: string;
    delivered?: string;
    countryID?: CountryID;
    stateID?: StateID;
    city?: string;
    zip?: string;
    apoIgnored?: boolean;
    shipToBuilding?: boolean;
    order?: Order;
    shippingOption?: ShippingOption;
    orderShippingOptionShipments?: OrderShippingOptionShipment[];
    deliveryPointKey?: string;
}

// go/v2/ordershippingoptionshipments.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface OrderShippingOptionShipment {
    id?: string;
    orderShippingOptionID?: string;
    shipmentID?: string;
    customerEmailID?: string;
    ignoreCarrierExclusion?: boolean;
    cachedOrderID?: string;
    apo?: boolean;
    fromBuilding?: boolean;
    secondary?: boolean;
    factoryPrimary?: boolean;
    cachedCost?: string;
    share?: string;
    companyID?: string;
    factoryID?: string;
    denormParentActive?: boolean;
    denormShipmentActive?: boolean;
    delivered?: string;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    shipment?: Shipment;
    orderShippingOption?: OrderShippingOption;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface ShipmentCostShare {
    id?: string;
    shipmentID?: string;
    orderID?: string;
    invoiceNumber?: number;
    share?: string;
}

// go/v2/orderstatuses.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface OrderStatus {
    id?: OrderStatusID;
    name?: string;
    active?: boolean;
    created?: string;
    updated?: string;
}
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const OrderStatusID = {
    ORDER_STATUSES_CONFIRMED: 4,
    ORDER_STATUSES_INVOICE_ONLY: 1,
    ORDER_STATUSES_ORDER: 2,
    ORDER_STATUSES_UNCONFIRMED: 3,
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type OrderStatusID = typeof OrderStatusID[keyof typeof OrderStatusID];

// go/v2/orderuploads.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface OrderUpload {
    id?: string;
    orderID?: string;
    uploadID?: number;
    tags?: string[];
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    order?: Order;
    upload?: Upload;
    createdBy?: User;
}

// go/v2/organizationinvites.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface OrganizationInvite {
    id?: string;
    organizationID?: string;
    email?: string;
    acceptedByUserID?: string;
    expires?: string;
    createdByUserID?: string;
    created?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
    createdBy?: User;
}

// go/v2/organizationmembers.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface OrganizationMember {
    id?: string;
    organizationID?: string;
    userID?: string;
    owner?: boolean;
    createdByUserID?: string;
    created?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
    user?: User;
}

// go/v2/organizations.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface Organization {
    id?: string;
    networkID?: string;
    name?: string;
    uploadID?: number;
    createdByUserID?: string;
    created?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
    logo?: Upload;
    network?: Network;
    createdBy?: User;
    members?: OrganizationMember[];
    invites?: OrganizationInvite[];
}

// go/v2/pagerequests.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface PageRequest {
    id?: string;
    companyID?: string;
    ipAddress?: string;
    userID?: string;
    sentEmailID?: string;
    blogID?: string;
    host?: string;
    requestURI?: string;
    referer?: string;
    os?: string;
    osVersion?: string;
    browser?: string;
    browserVersion?: string;
    userAgent?: string;
    mobile?: boolean;
    width?: number;
    height?: number;
    unique?: boolean;
    countryID?: CountryID;
    stateID?: StateID;
    clientID?: string;
    dateTimeOnline?: string;
    linkID?: string;
    followUpAltID?: number;
    ingress?: boolean;
    possibleUserID?: string;
    fbp?: string;
    trybeVID?: string;
    path?: string;
    pathMurmur?: number;
    dateAdded?: string;
    rootDomain?: string;
    companyReferer?: boolean;
    active?: boolean;
    created?: string;
    updated?: string;
    link?: Link;
    followUp?: FollowUp;
    emailBlast?: EmailBlast;
}

// go/v2/paymentoptions.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface PaymentOption {
    id?: string;
    paymentOptionTypeID?: PaymentOptionTypeID;
    companyID?: string;
    userID?: string;
    addressID?: string;
    addressVersion?: number;
    name?: string;
    fullName?: string;
    company?: string;
    email?: string;
    addressLine1?: string;
    addressLine2?: string;
    city?: string;
    stateID?: StateID;
    zip?: string;
    countryID?: CountryID;
    phone?: string;
    label?: string;
    creditCardFirst6?: string;
    creditCardLast4?: string;
    creditCardExpirationDate?: string;
    fattmerchantOmniPaymentMethodID?: string;
    key?: string;
    declined?: boolean;
    accountType?: PaymentOptionAccountType;
    bankType?: PaymentOptionBankType;
    sortOrder?: number;
    active?: boolean;
    created?: string;
    updated?: string;
    paymentOptionType?: PaymentOptionType;
    realm?: Realm;
    user?: User;
    address?: Address;
    country?: Country;
    state?: State;
    default?: boolean;
    orderPayments?: OrderPayment[];
}
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const PaymentOptionAccountType = {
    PAYMENT_OPTION_ACCOUNT_TYPE_CHECKING: 'checking',
    PAYMENT_OPTION_ACCOUNT_TYPE_SAVINGS: 'savings',
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type PaymentOptionAccountType = typeof PaymentOptionAccountType[keyof typeof PaymentOptionAccountType];
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const PaymentOptionBankType = {
    PAYMENT_OPTION_BANK_TYPE_PERSONAL: 'personal',
    PAYMENT_OPTION_BANK_TYPE_BUSINESS: 'business',
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type PaymentOptionBankType = typeof PaymentOptionBankType[keyof typeof PaymentOptionBankType];

// go/v2/paymentoptiontypes.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface PaymentOptionType {
    id?: PaymentOptionTypeID;
    name?: string;
    termName?: string;
}
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const PaymentOptionTypeID = {
    PAYMENT_OPTION_TYPE_NONE: 0,
    PAYMENT_OPTION_TYPE_CREDIT: 1,
    PAYMENT_OPTION_TYPE_CHECK: 2,
    PAYMENT_OPTION_TYPE_CASH: 3,
    PAYMENT_OPTION_TYPE_WIRE: 4,
    PAYMENT_OPTION_TYPE_PO: 5,
    PAYMENT_OPTION_TYPE_PAY_PAL: 6,
    PAYMENT_OPTION_TYPE_BALANCE: 7,
    PAYMENT_OPTION_TYPE_BANK: 8,
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type PaymentOptionTypeID = typeof PaymentOptionTypeID[keyof typeof PaymentOptionTypeID];

// go/v2/phonenumbers.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface PhoneNumber {
    id?: string;
    phone?: string;
    createdByUserID?: string;
    created?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
    createdBy?: User;
    rowCreatedBy?: User;
}

// go/v2/promotionalcodes.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface PromotionalCode {
    id?: string;
    networkID?: string;
    companyID?: string;
    linkID?: string;
    name?: string;
    description?: string;
    code?: string;
    formula?: string;
    ownerUserID?: string;
    ownerFormula?: string;
    expires?: string;
    minimumSubtotal?: string;
    max?: string;
    buy?: number;
    get?: number;
    js?: string;
    codeMurmur?: number;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    network?: Network;
    company?: Realm;
    link?: Link;
    createdBy?: User;
}

// go/v2/prompts.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface Prompt {
    id?: string;
    networkID?: string;
    companyID?: string;
    name?: string;
    markdown?: string;
    description?: string;
    trigger?: string;
    updateDescription?: string;
    createdByUserID?: string;
    created?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
    network?: Network;
    realm?: Realm;
    createdBy?: User;
    rowCreatedBy?: User;
}

// go/v2/prooflayouts.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface ProofLayout {
    id?: string;
    originalProofLayoutID?: string;
    companyID?: string;
    uploads?: ProofLayoutUploads;
    layout?: unknown;
    active?: boolean;
    created?: string;
    updated?: string;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface ProofLayoutUploads {
    twoInchGridProof?: number;
    threeInchGridProof?: number;
    fiveInchGridProof?: number;
    default?: number;
}

// go/v2/proofs.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface Proof {
    id?: string;
    imageID?: string;
    uploadID?: number;
    proofLayoutID?: string;
    hash?: string;
    name?: string;
    path?: string;
    file?: string;
    size?: number;
    emailSize?: number;
    live?: boolean;
    frontMoldID?: string;
    backMoldID?: string;
    proofIDSHA3224?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    main?: string;
    thumbnail?: string;
    moderationLabels?: ProofModerationLabel[];
    latestOrderFrontMold?: Order;
    latestOrderBackMold?: Order;
    frontMoldLatestConfirmed?: string;
    backMoldLatestConfirmed?: string;
    frontMoldExpires?: string;
    backMoldExpires?: string;
    moldExpires?: string;
    createdBy?: User;
    image?: Image;
    upload?: Upload;
    quoteProofs?: QuoteProof[];
    orderProofs?: OrderProof[];
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface ProofModerationLabel {
    label?: string;
    confidence?: number;
}

// go/v2/purchaseorderfiles.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface PurchaseOrderFile {
    id?: string;
    orderID?: string;
    imageID?: string;
    uploadID?: number;
    name?: string;
    path?: string;
    extension?: string;
    size?: number;
    active?: boolean;
    created?: string;
    image?: Image;
    upload?: Upload;
}

// go/v2/qrptstatusupdates.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface QRPTStatusUpdate {
    id?: string;
    quoteRequestProjectTaskStatusID?: QuoteRequestProjectTaskStatusID;
    quoteRequestProjectTaskID?: string;
    userID?: string;
    created?: string;
    user?: User;
    status?: QuoteRequestProjectTaskStatus;
}

// go/v2/quotechildlineitems.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface QuoteChildLineItem {
    id?: string;
    quoteLineItemID?: string;
    childLineItemID?: string;
    child?: string;
    childLineItemOptionID?: string;
    option?: string;
    autoQuantity?: boolean;
    linkedQuantity?: boolean;
    quantity?: number;
    price?: string;
    description?: string;
    sortOrder?: number;
    active?: boolean;
    created?: string;
    updated?: string;
    childLineItem?: ChildLineItem;
    childLineItemOption?: ChildLineItemOption;
    cachedQuoteID?: string;
    cachedNetworkID?: string;
}

// go/v2/quotelineitems.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface QuoteLineItem {
    id?: string;
    quoteID?: string;
    lineItemID?: LineItemID;
    lineItem?: string;
    lineItemTypeID?: LineItemTypeID;
    type?: string;
    lineItemTypeSizeID?: string;
    size?: string;
    quantity?: number;
    price?: string;
    description?: string;
    sortOrder?: number;
    open?: boolean;
    quoteProofID?: string;
    networkSKUID?: string;
    customerEditable?: boolean;
    invalidCustomQuantity?: boolean;
    cachedQuoteRequestProjectID?: string;
    cachedProduct?: boolean;
    cachedNetworkID?: string;
    cachedWidth?: string;
    cachedHeight?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    quoteProof?: QuoteProof;
    lineItemModel?: LineItem;
    lineItemType?: LineItemType;
    lineItemTypeSize?: LineItemTypeSize;
    quoteChildLineItems?: QuoteChildLineItem[];
}

// go/v2/quotemessageimage.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface QuoteMessageImage {
    id?: string;
    quoteMessageID?: string;
    imageID?: string;
    uploadID?: number;
    active?: boolean;
    created?: string;
    updated?: string;
}

// go/v2/quotemessages.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface QuoteMessage {
    id?: string;
    companyID?: string;
    name?: string;
    subject?: string;
    message?: string;
    contentType?: string;
    default?: boolean;
    active?: boolean;
    created?: string;
    updated?: string;
    realm?: Realm;
    quoteMessageImages?: QuoteMessageImage[];
}

// go/v2/quoteorders.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface QuoteOrder {
    id?: number;
    quoteID?: string;
    orderID?: string;
    denormCompanyID?: string;
    denormOrderUserID?: string;
    denormQuoteUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    quote?: Quote;
    order?: Order;
    denormLeadRating?: number;
}

// go/v2/quoteproofs.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface QuoteProof {
    id?: string;
    quoteID?: string;
    proofID?: string;
    name?: string;
    number?: string;
    created?: string;
    active?: boolean;
    updated?: string;
    cachedSort?: string;
    userEvents?: UserEvent[];
    proof?: Proof;
}

// go/v2/quoterequestimages.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface QuoteRequestImage {
    id?: string;
    quoteRequestID?: string;
    imageID?: string;
    quoteRequest?: QuoteRequest;
    image?: Image;
}

// go/v2/quoterequestprojects.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface QuoteRequestProject {
    id?: string;
    quoteRequestID?: string;
    quoteID?: string;
    companyID?: string;
    userID?: string;
    name?: string;
    leadRating?: number;
    predictedLeadRating?: number;
    saveID?: string;
    quoteRequestAdded?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    read?: boolean;
    addressed?: boolean;
    realm?: Realm;
    user?: User;
    quoteRequest?: QuoteRequest;
    quote?: Quote;
    quoteSent?: QuoteSent;
    quoteRequestProjects?: QuoteRequestProject[];
    quoteRequests?: QuoteRequest[];
    flagFlags?: FlagFlag[];
}

// go/v2/quoterequestprojecttaskpriorities.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface QuoteRequestProjectTaskPriority {
    id?: QuoteRequestProjectTaskPriorityID;
    name?: string;
    default?: boolean;
    color?: string;
    sortOrder?: number;
    active?: boolean;
    created?: string;
    updated?: string;
}
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const QuoteRequestProjectTaskPriorityID = {
    QUOTE_REQUEST_PROJECT_TASK_PRIORITIES_BUMP: 1,
    QUOTE_REQUEST_PROJECT_TASK_PRIORITIES_LOW: 2,
    QUOTE_REQUEST_PROJECT_TASK_PRIORITIES_MEDIUM: 3,
    QUOTE_REQUEST_PROJECT_TASK_PRIORITIES_RTO: 4,
    QUOTE_REQUEST_PROJECT_TASK_PRIORITIES_REPEAT_CUSTOMER: 5,
    QUOTE_REQUEST_PROJECT_TASK_PRIORITIES_RUSH: 6,
    QUOTE_REQUEST_PROJECT_TASK_PRIORITIES_PREPAID: 7,
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type QuoteRequestProjectTaskPriorityID = typeof QuoteRequestProjectTaskPriorityID[keyof typeof QuoteRequestProjectTaskPriorityID];

// go/v2/quoterequestprojecttaskproofs.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface QuoteRequestProjectTaskProof {
    id?: string;
    quoteRequestProjectTaskID?: string;
    proofID?: string;
}

// go/v2/quoterequestprojecttasks.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface QuoteRequestProjectTask {
    id?: string;
    companyID?: string;
    userID?: string;
    quoteRequestProjectID?: string;
    quoteRequestID?: string;
    orderID?: string;
    salesUserID?: string;
    assignedUserID?: string;
    lineItemID?: string;
    lineItemTypeID?: string;
    quoteProofID?: string;
    quoteRequestProjectTaskTypeID?: QuoteRequestProjectTaskTypeID;
    quoteRequestProjectTaskStatusID?: QuoteRequestProjectTaskStatusID;
    quoteRequestProjectTaskPriorityID?: QuoteRequestProjectTaskPriorityID;
    difficulty?: string;
    timeBudget?: number;
    numberOfDesigns?: number;
    projectedTaskTime?: number;
    sortOrder?: number;
    customerRequest?: boolean;
    clearinghouse?: boolean;
    phoned?: boolean;
    screenRecord?: boolean;
    hiddenFromArtists?: boolean;
    doneTime?: string;
    key?: string;
    changelog?: ModelChangelogEntry[];
    createdByUserID?: string;
    updatedByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    realm?: Realm;
    user?: User;
    userEvent?: UserEvent[];
    salesUser?: User;
    assignedUser?: User;
    createdBy?: User;
    quoteProof?: QuoteProof;
    quoteRequest?: QuoteRequest;
    quoteRequestProjectTaskType?: QuoteRequestProjectTaskType;
    quoteRequestProjectTaskStatus?: QuoteRequestProjectTaskStatus;
    quoteRequestProjectTaskPriority?: QuoteRequestProjectTaskPriority;
    lineItem?: LineItem;
    lineItemType?: LineItemType;
    qrptStatusUpdates?: QRPTStatusUpdate[];
    firstUserEvent?: UserEvent;
    estimatedHoursRemaining?: number;
    estimatedCompletion?: string;
}

// go/v2/quoterequestprojecttaskstatuses.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface QuoteRequestProjectTaskStatus {
    id?: QuoteRequestProjectTaskStatusID;
    name?: string;
    default?: boolean;
    color?: string;
    sortOrder?: number;
    active?: boolean;
    created?: string;
    updated?: string;
}
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const QuoteRequestProjectTaskStatusID = {
    QUOTE_REQUEST_PROJECT_TASK_STATUSES_HOLD: 1,
    QUOTE_REQUEST_PROJECT_TASK_STATUSES_IN_PROGRESS: 2,
    QUOTE_REQUEST_PROJECT_TASK_STATUSES_ADJUSTMENT_NEEDED: 3,
    QUOTE_REQUEST_PROJECT_TASK_STATUSES_FIX_NEEDED: 4,
    QUOTE_REQUEST_PROJECT_TASK_STATUSES_ART_DONE: 5,
    QUOTE_REQUEST_PROJECT_TASK_STATUSES_SENT: 6,
    QUOTE_REQUEST_PROJECT_TASK_STATUSES_BUMP: 7,
    QUOTE_REQUEST_PROJECT_TASK_STATUSES_QUALIFIED: 8,
    QUOTE_REQUEST_PROJECT_TASK_STATUSES_UNQUALIFIED: 9,
    QUOTE_REQUEST_PROJECT_TASK_STATUSES_VECTOR_DONE: 10,
    QUOTE_REQUEST_PROJECT_TASK_STATUSES_PAUSED: 11,
    QUOTE_REQUEST_PROJECT_TASK_STATUSES_REVIEW_NEEDED: 12,
    QUOTE_REQUEST_PROJECT_TASK_STATUSES_CUSTOMER_CANCELED: 13,
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type QuoteRequestProjectTaskStatusID = typeof QuoteRequestProjectTaskStatusID[keyof typeof QuoteRequestProjectTaskStatusID];

// go/v2/quoterequestprojecttasktimes.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface QuoteRequestProjectTaskTime {
    id?: string;
    quoteRequestProjectTaskID?: string;
    userID?: string;
    start?: string;
    stop?: string;
    pause?: boolean;
    active?: boolean;
    created?: string;
    updated?: string;
    user?: User;
}

// go/v2/quoterequestprojecttasktypes.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface QuoteRequestProjectTaskType {
    id?: QuoteRequestProjectTaskTypeID;
    name?: string;
    default?: boolean;
    color?: string;
    sortOrder?: number;
    artistRewardValue?: string;
    active?: boolean;
    created?: string;
    updated?: string;
}
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const QuoteRequestProjectTaskTypeID = {
    QUOTE_REQUEST_PROJECT_TASK_TYPES_REVISION: 1,
    QUOTE_REQUEST_PROJECT_TASK_TYPES_NEW: 2,
    QUOTE_REQUEST_PROJECT_TASK_TYPES_SMALL_REVISION: 3,
    QUOTE_REQUEST_PROJECT_TASK_TYPES_LARGE_REVISION: 4,
    QUOTE_REQUEST_PROJECT_TASK_TYPES_3_D_REVIEW: 5,
    QUOTE_REQUEST_PROJECT_TASK_TYPES_CONTENT_FIX: 6,
    QUOTE_REQUEST_PROJECT_TASK_TYPES_SPELLING_FIX: 7,
    QUOTE_REQUEST_PROJECT_TASK_TYPES_ADJUSTMENT: 8,
    QUOTE_REQUEST_PROJECT_TASK_TYPES_VECTOR_REVIEW: 9,
    QUOTE_REQUEST_PROJECT_TASK_TYPES_PROOF_NEEDED: 10,
    QUOTE_REQUEST_PROJECT_TASK_TYPES_FACTORY_FILE: 11,
    QUOTE_REQUEST_PROJECT_TASK_TYPES_CONCEPT: 12,
    QUOTE_REQUEST_PROJECT_TASK_TYPES_CLEAN_PROOF: 255,
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type QuoteRequestProjectTaskTypeID = typeof QuoteRequestProjectTaskTypeID[keyof typeof QuoteRequestProjectTaskTypeID];

// go/v2/quoterequests.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface QuoteRequest {
    id?: string;
    quoteRequestProjectID?: string;
    companyID?: string;
    userID?: string;
    clientID?: string;
    lineItemID?: LineItemID;
    stateID?: StateID;
    countryID?: CountryID;
    linkID?: string;
    pageRequestID?: string;
    formSubmissionID?: string;
    helenQuoteID?: string;
    company?: string;
    firstName?: string;
    lastName?: string;
    phone?: string;
    email?: string;
    addressLine1?: string;
    addressLine2?: string;
    city?: string;
    zip?: string;
    quantity?: number;
    dateNeeded?: string;
    notes?: string;
    notesObj?: Record<string, unknown>;
    remoteAddress?: string;
    budget?: string;
    form?: string;
    folder?: string;
    sales?: boolean;
    classicForm?: boolean;
    iap?: boolean;
    downloaded?: boolean;
    pendingFolder?: string;
    quoteRequestPendingFolderErrorID?: number;
    project?: string;
    hubSpotDealID?: number;
    hubSpotSynced?: string;
    date?: string;
    folderSHA3224?: string;
    denormCustomerName?: string;
    latestCustomerContact?: string;
    latest?: boolean;
    selfCreated?: boolean;
    unread?: boolean;
    notAddressed?: boolean;
    quoteCount?: number;
    firstIngressPageRequestID?: string;
    lastIngressPageRequestID?: string;
    latestInvoiceDateTimeAdded?: string;
    sentFirst?: string;
    emailMurmur3_32?: number;
    referer?: string;
    refererRootDomain?: string;
    refererRootDomainMurmur2?: number;
    requestURISansParamsMurmur2?: number;
    pageRequestWidth?: number;
    device?: number;
    createdByUserID?: string;
    updatedByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    realm?: Realm;
    user?: User;
    quoteRequestProject?: QuoteRequestProject;
    uploads?: Upload[];
    quoteRequestImages?: QuoteRequestImage[];
    quotes?: Quote[];
    quoteRequestProjectTasks?: QuoteRequestProjectTask[];
    quoteRequestUploads?: QuoteRequestUpload[];
    link?: Link;
    country?: Country;
    state?: State;
    pageRequest?: PageRequest;
    firstIngressPageRequest?: PageRequest;
    lastIngressPageRequest?: PageRequest;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface EasyQuoteRequestChild {
    child: string;
    option: string;
    quantity: number;
    skip: boolean;
    cheapestOption: boolean;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface EasyQuoteRequestExtra {
    name: string;
    value: string;
}

// go/v2/quoterequestuploads.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface QuoteRequestUpload {
    id?: string;
    quoteRequestID?: string;
    uploadID?: number;
    active?: boolean;
    created?: string;
    updated?: string;
    quoteRequest?: QuoteRequest;
    upload?: Upload;
}

// go/v2/quotes.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface Quote {
    id?: string;
    quoteRequestID?: string;
    open?: boolean;
    send?: boolean;
    viewed?: boolean;
    addressed?: boolean;
    shippingOptionID?: string;
    paymentOptionID?: string;
    serial?: string;
    hidden?: boolean;
    classicForm?: boolean;
    blocked?: boolean;
    eventDate?: string;
    userID?: string;
    key?: string;
    createdByUserID?: string;
    created?: string;
    active?: boolean;
    companyID?: string;
    sent?: boolean;
    cachedTotal?: string;
    cachedQuoteRequestProjectID?: string;
    quoteIDSHA3224?: string;
    notes?: string;
    latest?: boolean;
    serialRoot?: string;
    serialNumber?: number;
    networkID?: string;
    sentFirst?: string;
    ordered?: boolean;
    updated?: string;
    quoteRequest?: QuoteRequest;
    user?: User;
    createdBy?: User;
    realm?: Realm;
    quoteProofs?: QuoteProof[];
    quoteLineItems?: QuoteLineItem[];
    quoteSents?: QuoteSent[];
    quoteOrders?: QuoteOrder[];
    shippingOption?: ShippingOption;
    paymentOption?: PaymentOption;
}

// go/v2/quotesentimages.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface QuoteSentImage {
    id?: string;
    quoteSentInstanceID?: string;
    imageID?: string;
    uploadID?: number;
    sort?: number;
    createdByUserID?: string;
    created?: string;
    image?: Image;
    upload?: Upload;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
}

// go/v2/quotesents.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface QuoteSentAttachment {
    name?: string;
    key?: string;
    size?: number;
    publicURL?: string;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface QuoteSent {
    id?: string;
    quoteID?: string;
    sentEmailID?: string;
    createdByUserID?: string;
    quoteSentInstanceID?: string;
    followUpID?: string;
    name?: string;
    emails?: string;
    ccs?: string;
    phones?: string[];
    subject?: string;
    content?: string;
    contentType?: string;
    invoice?: boolean;
    key?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    userID?: string;
    companyID?: string;
    highestTotalQuoteID?: string;
    highestTotal?: string;
    lowestTotalQuoteID?: string;
    lowestTotal?: string;
    contacted?: string;
    sentWithProofs?: boolean;
    latest?: boolean;
    ordered?: boolean;
    attachments?: QuoteSentAttachment[];
    quote?: Quote;
    quoteRequest?: QuoteRequest;
    user?: User;
    realm?: Realm;
}

// go/v2/realms.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface Realm {
    id?: string;
    number?: number;
    networkID?: string;
    salesTeamID?: string;
    shippingAccountID?: string;
    defaultSalesUserID?: string;
    name?: string;
    description?: string;
    email?: string;
    phone?: string;
    url?: string;
    lineItemID?: string;
    cloudFront?: string;
    taxJarAPIKey?: string;
    helpScoutMailboxID?: number;
    helpScoutMailboxSlug?: string;
    fattmerchantOmniAPIKey?: string;
    host?: string;
    htmlEmails?: boolean;
    quoteLink?: string;
    orderLink?: string;
    fattmerchantOmniWebPaymentsToken?: string;
    productID?: string;
    minimumQuantity?: number;
    backStamp?: string;
    oldQBName?: string;
    parentCompanyName?: string;
    ccEmail?: string;
    topLeftImage?: string;
    topRightImage?: string;
    logo?: string;
    phoneImage?: string;
    documentRoot?: string;
    artworkWidth?: number;
    artworkHeight?: number;
    defaultQuoteAdminNotes?: string;
    smtpUser?: string;
    smtpServer?: string;
    smtpPort?: number;
    smtpSSL?: number;
    analyticsTrackingID?: string;
    extension?: string;
    orderSuccessLink?: string;
    builderLink?: string;
    spc2?: string;
    spc3?: string;
    zendesk?: string;
    social?: SocialLinks;
    googleTitle?: string;
    googleDescription?: string;
    twitterTitle?: string;
    twitterDescription?: string;
    facebookTitle?: string;
    facebookDescription?: string;
    ahrefsVerification?: string;
    googleTagManagerID?: string;
    facebookAppID?: string;
    facebookAppSecret?: string;
    bingUET?: string;
    pinterestVerification?: string;
    trackEmails?: boolean;
    bingWebmasterVerification?: string;
    oneSignalAppID?: string;
    placeID?: string;
    helpScoutBeaconID?: string;
    googleClientID?: string;
    googleClientSecret?: string;
    instagramClientID?: string;
    mondayAPIToken?: string;
    mondayUserID?: string;
    mondayBoardID?: string;
    mondayGroupID?: string;
    helpScout?: boolean;
    nameServers?: string;
    trustpilotBusinessUnitID?: string;
    ringCentralPhone?: string;
    bounceDomain?: string;
    staticCloudFrontDistributionID?: string;
    fattmerchantOmni?: boolean;
    payPalClientID?: string;
    payPalSecret?: string;
    quoteSending?: boolean;
    primaryOfDomain?: string;
    qboIncomeAccount?: string;
    apiDomains?: string[];
    hubSpotPortalID?: number;
    active?: boolean;
    created?: string;
    updated?: string;
    network?: Network;
    shippingAccount?: ShippingAccount;
    lineItem?: LineItem;
    companyDetails?: CompanyDetails;
    defaultSalesUser?: User;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface CompanyDetails {
    snsNumber?: string;
    v3CartCheckoutURL: string;
    v3CartCartURL: string;
    v3QuoteCheckoutURL?: string;
    v3QuoteCartURL?: string;
    v3QuoteViewURL?: string;
    v3QuoteInstanceViewURL?: string;
    v3RevisionURL?: string;
    v3OrderCheckoutURL?: string;
    v3OrderCartURL?: string;
    v3PasswordResetURL?: string;
    organizationInviteURL?: string;
    v3PaymentURL?: string;
    v3OrderTrackURL?: string;
    v3QRPTURL?: string;
    defaultSalesTeamIDs?: string[];
    weightedDefaultSalesTeamIDs?: WeightedSalesTeam[];
    successorCompanyID?: string;
    googleSignInClientID?: string;
    cartItemGlobalPricingContextJS?: string;
    payPalClientID?: string;
    payPalSecret?: string;
    customerAPIV2Root?: string;
    metaPixelID?: string;
    metaConversionsAccessToken?: string;
    metaConversionsTestEventCode?: string;
    trybeOrdersAPIKey?: string;
    googleAdsCustomerID?: string;
    googleAdsLoginCustomerID?: string;
    googleAdsPurchaseConversionActionID?: string;
    googleAdsLeadConversionActionID?: string;
    googleAdsQuoteSentConversionActionID?: string;
    googleAdsEngagedAfterQuoteConversionActionID?: string;
    googleAdsOAuthRefreshToken?: string;
    podiumLocationUID?: string;
    podiumLocationUIDs?: string[];
    smsNumber?: string;
    localPhoneNumber?: string;
    reCaptchaV2SiteKey?: string;
    reCaptchaV2SecretKey?: string;
    reCaptchaV3SiteKey?: string;
    reCaptchaV3SecretKey?: string;
    freeShippingMin?: string;
    depositFloor?: string;
    exceptionApprovalThreshold?: string;
    lateRiskThresholds?: LateRiskThresholds;
    disableHTMLEmails?: boolean;
    loadBalanceSalesTeamAssignment?: boolean;
    repo?: string;
    repoDir?: string;
    githubDeployWorkflowURL?: string;
    blogDir?: string;
    blogImgWidth?: number;
    hugoBaseURL?: string;
    ein?: string;
    productTypeQuizPrompt?: string;
    color?: string;
    moldExpiryInDays?: number;
    blogImagePhotoStyle?: string;
    skuTemplate?: string;
    reviewLinkTemplate?: string;
    reviewProductFeedURL?: string;
    reviewLinkCompanyTemplate?: string;
    reviewsIOStore?: string;
    designPricingPercent?: string;
    quoteRequestsFromQuoteRequestForms?: boolean;
    designsFromQuoteRequestForms?: boolean;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface WeightedSalesTeam {
    salesTeamID: string;
    weight: number;
}
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const CompanyID = {
    COMPANIES_ALL_ABOUT_CHALLENGE_COINS: 'FUGW1ERJC7I',
    COMPANIES_ALL_ABOUT_LANYARDS: 'FUGW1EhjGAI',
    COMPANIES_ALL_ABOUT_PATCHES: 'FUGW1ExnO0I',
    COMPANIES_ALL_ABOUT_PINS: 'FUGW1FBv_FI',
    COMPANIES_CHALLENGE_COIN_NATION: 'FUGW1CgJrPI',
    COMPANIES_CHALLENGE_COINS_CITY: 'FUGW1CwXsGI',
    COMPANIES_CHALLENGE_COINS_EXPRESS: 'FUGW1HS1YQI',
    COMPANIES_CHALLENGE_COINS_PLUS: 'FUGW1BfkosI',
    COMPANIES_COIN_DEPOT: 'FUGW1Afct_I',
    COMPANIES_CUSTOM_LANYARDS_PLUS: 'FUGW1BvvLaI',
    COMPANIES_CUSTOM_MEDALS_PLUS: 'FUGW1CQIILI',
    COMPANIES_EMBROIDERED_PATCHES_PLUS: 'FUGW1CAAssI',
    COMPANIES_GRANT: 'FUGW1ALgoQI',
    COMPANIES_LANYARD_DEPOT: 'FUGW1ALlC0I',
    COMPANIES_LANYARDS_EXPRESS: 'FUGW1HzY03I',
    COMPANIES_LAPEL_PIN_PRODUCTIONS: 'FUGW1Dg111I',
    COMPANIES_LAPEL_PINS_CITY: 'FUGW1DAdiBI',
    COMPANIES_LAPEL_PINS_EXPRESS: 'FUGW1HCqCEI',
    COMPANIES_LAPEL_PINS_ONLINE: 'FUGW1DxB1kI',
    COMPANIES_LAPEL_PINS_PLUS: 'FUGW1BPaCtI',
    COMPANIES_LAPEL_PINS_USA: 'FUGW1DQpvnI',
    COMPANIES_PATCH_DEPOT: 'FUGW1A_VHWI',
    COMPANIES_PATCHES_EXPRESS: 'FUGW1HjE_MI',
    COMPANIES_PIN_DEPOT: 'FUGW1AvY4hI',
    COMPANIES_PIN_PROMOTIONS: 'FUGW1EBBlMI',
    COMPANIES_SIGNATURE_COINS: 'FUGW1FiCBPI',
    COMPANIES_SIGNATURE_LANYARDS: 'FUGW1FyG6nI',
    COMPANIES_SIGNATURE_PATCHES: 'FUGW1GCK-OI',
    COMPANIES_SIGNATURE_PINS: 'FUGW1GyeryI',
    COMPANIES_SIGNATURE_TRADING_PINS: 'FUGW1GSPrGI',
    COMPANIES_STERLING_MARKETING_GROUP: 'FUGW1HCoItI',
    COMPANIES_THE_LAPEL_PIN_BUTTON_CO: 'FUGW1GiYoLI',
    COMPANIES_TNG_CONSOLIDATED: 'FUGW1HCmB2I',
    COMPANIES_TRADING_PINS: 'FUGW1ITiiyI',
    COMPANIES_USDOD_COINS: 'FUGW1IDiq_I',
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type CompanyID = typeof CompanyID[keyof typeof CompanyID];
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface LateRiskThresholds {
    noEtaDays?: number;
    etaBufferDays?: number;
    noTrackingDays?: number;
    noMovementDays?: number;
    paymentHoldDays?: number;
    factoryUnresponsiveHours?: number;
    factoryUnresponsiveWindowDays?: number;
    unconfirmedStageDays?: number;
}

// go/v2/rekognition.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface RekognitionLabel {
    label?: string;
    moderation?: boolean;
    created?: string;
    updated?: string;
}

// go/v2/reviewsio.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface OrderReview {
    rating: number;
    comments: string;
}

// go/v2/revisions.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface RevisionRequest {
    quoteProofID: string;
    notes: string;
    contentType?: string;
    uploadIDs: number[];
    point?: UserEventPoint;
    pointNumber?: number;
}

// go/v2/salesteammanagingcompanies.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface SalesTeamManagingCompany {
    salesTeamID?: string;
    managingCompanyID?: string;
    percent?: string;
    problemPercent?: string;
    quarterlyBonusPercent?: string;
    created?: string;
    salesTeam?: SalesTeam;
    managingCompany?: ManagingCompany;
}

// go/v2/salesteamnetworks.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface SalesTeamNetwork {
    id?: string;
    networkID?: string;
    salesTeamID?: string;
    created?: string;
    network?: Network;
    salesTeam?: SalesTeam;
}

// go/v2/salesteamrealms.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface SalesTeamRealm {
    id?: string;
    salesTeamID?: string;
    companyID?: string;
    createdByUserID?: string;
    created?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
    salesTeam?: SalesTeam;
    company?: Realm;
    createdBy?: User;
    rowCreatedBy?: User;
}

// go/v2/salesteams.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface SalesTeam {
    id?: string;
    name?: string;
    leaderboard?: boolean;
    primaryHelpScoutMailboxID?: number;
    helpScoutMailboxIDs?: number[];
    helpScoutTeamID?: number;
    primaryCompanyID?: string;
    podiumLocationUID?: string;
    originalSalesTeamID?: string;
    latest?: boolean;
    active?: boolean;
    created?: string;
    updated?: string;
    salesTeamNetworks?: SalesTeamNetwork[];
    salesTeamUsers?: SalesTeamUser[];
    salesTeamManagingCompanies?: SalesTeamManagingCompany[];
    salesTeamRealms?: SalesTeamRealm[];
    createdBy?: User;
}

// go/v2/salesteamusers.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface SalesTeamUser {
    id?: string;
    userID?: string;
    salesTeamID?: string;
    originalSalesTeamID?: string;
    hideFromLeaderboards?: boolean;
    created?: string;
    user?: User;
    salesTeam?: SalesTeam;
}

// go/v2/scheduledgroupchatmessages.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface ScheduledGroupChatMessageDraftMember {
    adminRoleID?: AdminRoleID;
    originalFactoryID?: string;
    userID?: string;
    customer?: boolean;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface ScheduledGroupChatMessageDraftChat {
    orderID?: string;
    members?: ScheduledGroupChatMessageDraftMember[];
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface ScheduledGroupChatMessageDraft {
    content?: string;
    contentType?: string;
    uploadIDs?: number[];
    repliedToGroupChatMessageID?: string;
    repliedToGroupChatMessageVersion?: number;
    sender?: GroupChatMessageSender;
    groupChatID?: string;
    groupChat?: ScheduledGroupChatMessageDraftChat;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface ScheduledGroupChatMessage {
    id?: string;
    orderID?: string;
    message?: ScheduledGroupChatMessageDraft;
    sendAt?: string;
    needsApproval?: boolean;
    groupChatMessageID?: string;
    sent?: string;
    error?: string;
    createdByUserID?: string;
    created?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
    createdBy?: User;
}

// go/v2/sentemailbccs.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface SentEmailBCC {
    id?: string;
    sentEmailID?: string;
    email?: string;
    name?: string;
    sentEmail?: SentEmail;
}

// go/v2/sentemailbodies.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface SentEmailBody {
    id?: string;
    sentEmailID?: string;
    body?: string;
    type?: string;
    sentEmail?: SentEmail;
}

// go/v2/sentemailccs.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface SentEmailCC {
    id?: string;
    sentEmailID?: string;
    email?: string;
    name?: string;
    sentEmail?: SentEmail;
}

// go/v2/sentemailreplytos.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface SentEmailReplyTo {
    id?: string;
    sentEmailID?: string;
    email?: string;
    name?: string;
    sentEmail?: SentEmail;
}

// go/v2/sentemails.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface SentEmail {
    id?: string;
    sentEmailCategoryID?: string;
    companyID?: string;
    subject?: string;
    fromEmail?: string;
    fromName?: string;
    trackEmail?: boolean;
    error?: boolean;
    bccError?: boolean;
    created?: string;
    realm?: Realm;
    sentEmailBodies?: SentEmailBody[];
}

// go/v2/sentemailtos.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface SentEmailTo {
    id?: string;
    sentEmailID?: string;
    email?: string;
    name?: string;
    sentEmail?: SentEmail;
}

// go/v2/shipmentcosts.go
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const ShipmentCostType = {
    SHIPMENT_COST_TYPE_FREIGHT: 'freight',
    SHIPMENT_COST_TYPE_DUTY: 'duty',
    SHIPMENT_COST_TYPE_ADJUSTMENT: 'adjustment',
    SHIPMENT_COST_TYPE_FEE: 'fee',
    SHIPMENT_COST_TYPE_OTHER: 'other',
    SHIPMENT_COST_TYPE_REFUND: 'refund',
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type ShipmentCostType = typeof ShipmentCostType[keyof typeof ShipmentCostType];
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface ShipmentCost {
    id?: string;
    shipmentID?: string;
    shippingBillID?: string;
    type?: ShipmentCostType;
    amount?: string;
    notes?: string;
    affectsCommissions?: boolean;
    affectsCommissionsUntil?: string;
    commissionsExcludedAt?: string;
    commissionsExcludedByUserID?: string;
    affectsCommissionsSetByUserID?: string;
    affectsCommissionsSetAt?: string;
    createdByUserID?: string;
    created?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
    shippingBill?: ShippingBill;
    estimate?: boolean;
}

// go/v2/shipmentpickups.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface ShipmentPickup {
    id?: string;
    shipmentID?: string;
    carrierID?: CarrierID;
    confirmationNumber?: string;
    location?: string;
    carrierCode?: string;
    pickupDate?: string;
    readyTime?: string;
    closeTime?: string;
    accountNumber?: string;
    cost?: string;
    createdByUserID?: string;
    created?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
    carrier?: Carrier;
    createdBy?: User;
}

// go/v2/shipmentratequotes.go
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const RateProgramID = {
    RATE_PROGRAM_NEGOTIATED: 1,
    RATE_PROGRAM_PUBLISHED: 2,
    RATE_PROGRAM_GUARANTEED: 3,
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type RateProgramID = typeof RateProgramID[keyof typeof RateProgramID];
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface ShipmentRateQuoteSurcharge {
    type?: string;
    description?: string;
    amount?: string;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface ShipmentRateQuote {
    id?: string;
    shipmentID?: string;
    carrierID?: CarrierID;
    serviceCode?: string;
    serviceName?: string;
    rateProgram?: RateProgramID;
    accountNumber?: string;
    factoryOAuthTokenID?: string;
    billToAccountNumber?: string;
    amount?: string;
    originalAmount?: string;
    originalCurrency?: string;
    surcharges?: ShipmentRateQuoteSurcharge[];
    deliveryDays?: number;
    selected?: boolean;
    createdByUserID?: string;
    created?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
    accountName?: string;
    billToAccountName?: string;
    factoryName?: string;
    factoryAccount?: boolean;
}

// go/v2/shipments.go
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const ShipmentDisposition = {
    SHIPMENT_DISPOSITION_NONE: '',
    SHIPMENT_DISPOSITION_REFUNDED: 'refunded',
    SHIPMENT_DISPOSITION_LOST: 'lost',
    SHIPMENT_DISPOSITION_RECEIVED: 'received',
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type ShipmentDisposition = typeof ShipmentDisposition[keyof typeof ShipmentDisposition];
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const ShipmentDestination = {
    SHIPMENT_DESTINATION_TO_CUSTOMER: 'toCustomer',
    SHIPMENT_DESTINATION_NOT_TO_CUSTOMER: 'notToCustomer',
    SHIPMENT_DESTINATION_UNKNOWN: 'unknown',
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type ShipmentDestination = typeof ShipmentDestination[keyof typeof ShipmentDestination];
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface Shipment {
    id?: string;
    parentShipmentID?: string;
    carrierID?: CarrierID;
    trackingNumber?: string;
    carrierShipmentID?: string;
    shippingAccountID?: string;
    factoryOAuthTokenID?: string;
    shipmentTypeID?: ShipmentTypeID;
    accountNumber?: string;
    cost?: string;
    insured?: boolean;
    fromAddressID?: string;
    fromAddressVersion?: number;
    toAddressID?: string;
    toAddressVersion?: number;
    returnAddressID?: string;
    reference?: string;
    real?: boolean;
    system?: boolean;
    waybillBolNumber?: string;
    harmonizedCode?: string;
    declaredValue?: string;
    customsDescription?: string;
    customsItems?: ShipmentCustomsItem[];
    toCustomer?: boolean;
    notToCustomer?: boolean;
    secondary?: boolean;
    insuranceClaimURL?: string;
    insuranceClaimPaid?: string;
    insuranceClaimPaidAt?: string;
    insuranceClaimPaidByUserID?: string;
    disposition?: ShipmentDisposition;
    dispositionReason?: string;
    dispositionAt?: string;
    dispositionByUserID?: string;
    postageErroredAt?: string;
    fromBuilding?: boolean;
    toBuilding?: boolean;
    weightLBS?: string;
    customsQuantity?: number;
    service?: string;
    failedToInsure?: boolean;
    orderID?: string;
    shippingBillID?: string;
    shippedAt?: string;
    deliveredAt?: string;
    estimatedDelivery?: string;
    returnedAt?: string;
    exceptionAt?: string;
    customsHoldAt?: string;
    customsHoldAlertedAt?: string;
    trackingEnteredAt?: string;
    trackingAcknowledgedAt?: string;
    trackingUnacknowledgedAt?: string;
    documents?: ShipmentUploads;
    request?: unknown;
    paperlessDocumentID?: string;
    paperlessFormsGroupID?: string;
    paperlessPushedAt?: string;
    billedToFactoryAccount?: boolean;
    factoryPaidCost?: string;
    costShareManual?: boolean;
    costShares?: ShipmentCostShare[];
    voidedAt?: string;
    voidFailedAt?: string;
    voidTerminal?: boolean;
    voidError?: string;
    costs?: ShipmentCost[];
    pickups?: ShipmentPickup[];
    rateQuotes?: ShipmentRateQuote[];
    orderShippingOptionShipments?: OrderShippingOptionShipment[];
    apo?: boolean;
    createdByUserID?: string;
    originalFactoryID?: string;
    created?: string;
    updated?: string;
    active?: boolean;
    shippingAccount?: ShippingAccount;
    carrier?: Carrier;
    factory?: Factory;
    label?: Upload;
    copyDocument?: Upload;
    commercialInvoice?: Upload;
    waybillDoc?: Upload;
    order?: Order;
    fromAddress?: Address;
    toAddress?: Address;
    returnAddress?: Address;
    shipments?: Shipment[];
    createdBy?: User;
    shippingBill?: ShippingBill;
    shipmentType?: ShipmentType;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface ShipmentCustomsItem {
    description: string;
    quantity: number;
    unitValue: string;
    weight: string;
    htsCode?: string;
    originCountry: string;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface ShipmentUploads {
    label?: number;
    originalLabel?: number;
    copyDocument?: number;
    commercialInvoice?: number;
    originalCommercialInvoice?: number;
    waybillDoc?: number;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface ShipmentLabelRenderResponse {
    images: string[];
}

// go/v2/shipmenttrackingevents.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface ShipmentTrackingEvent {
    id?: string;
    shipmentID?: string;
    status?: string;
    carrierCode?: string;
    description?: string;
    addressID?: string;
    addressVersion?: number;
    occurredAt?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
    location?: Address;
}

// go/v2/shipmenttypes.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface ShipmentType {
    id?: ShipmentTypeID;
    name?: string;
    active?: boolean;
    created?: string;
    updated?: string;
}
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const ShipmentTypeID = {
    SHIPMENT_TYPES_CUSTOM: 1,
    SHIPMENT_TYPES_FACTORY_TO_CUSTOMER: 2,
    SHIPMENT_TYPES_USPS: 3,
    SHIPMENT_TYPES_DIRIGIBLE: 10,
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type ShipmentTypeID = typeof ShipmentTypeID[keyof typeof ShipmentTypeID];

// go/v2/shippingaccountnetworks.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface ShippingAccountNetwork {
    id?: string;
    networkID?: string;
    shippingAccountID?: string;
    created?: string;
    shippingAccount?: ShippingAccount;
    network?: Network;
}

// go/v2/shippingaccounts.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface ShippingAccount {
    id?: string;
    originalShippingAccountID?: string;
    carrierID?: CarrierID;
    name?: string;
    accountNumber?: string;
    supportedShipmentTypeIDs?: ShipmentTypeID[];
    active?: boolean;
    created?: string;
    updated?: string;
    carrier?: Carrier;
    companyShippingAccounts?: CompanyShippingAccount[];
    shippingAccountNetworks?: ShippingAccountNetwork[];
}

// go/v2/shippingbills.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface ShippingBill {
    id?: string;
    shippingInvoiceFileID?: string;
    trackingNumber?: string;
    amount?: string;
    addressID?: string;
    addressVersion?: number;
    referenceLine1?: string;
    referenceLine2?: string;
    dateInvoiced?: string;
    dateShipped?: string;
    accountNumber?: string;
    sortableAccountNumber?: string;
    possibleInvoiceNumber?: number;
    ignored?: boolean;
    associated?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    paired?: boolean;
    shipmentID?: string;
    charges?: ShippingBillCharge[];
    shippingInvoiceFile?: ShippingInvoiceFile;
    order?: Order;
    address?: Address;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface ShippingBillCharge {
    description?: string;
    classification?: string;
    amount?: string;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface ShippingBillAccountUnpaired {
    accountNumber?: string;
    accountName?: string;
    carrierID?: CarrierID;
    carrierName?: string;
    unpaired?: string;
}

// go/v2/shippinginvoicefiles.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface ShippingInvoiceFile {
    id?: string;
    carrierID?: CarrierID;
    accountNumber?: string;
    invoiceDate?: string;
    name?: string;
    file?: string;
    sortableAccountNumber?: string;
    createdByUserID?: string;
    paid?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    carrier?: Carrier;
    createdBy?: User;
    shippingBills?: ShippingBill[];
}

// go/v2/shippingoptions.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface ShippingOption {
    id?: string;
    userID?: string;
    addressID?: string;
    addressVersion?: number;
    label?: string;
    sortOrder?: number;
    active?: boolean;
    created?: string;
    updated?: string;
    user?: User;
    address?: Address;
    country?: Country;
    state?: State;
    default?: boolean;
}

// go/v2/sitepages.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface SitePageTag {
    relPermalink: string;
    title: string;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface SitePageParams {
    readingduration?: string;
    product?: string;
    producttype?: string;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface SitePage {
    id: string;
    title: string;
    description: string;
    url: string;
    fullURL?: string;
    companyID?: string;
    site: string;
    page: string;
    section: string;
    type: string;
    tags: SitePageTag[];
    summary: string;
    file: string;
    lang: string;
    date?: string;
    lastmod?: string;
    rankingScore?: number;
    images: string[];
    params?: SitePageParams;
    html?: string;
    highlightedSummary?: string;
}

// go/v2/smstemplates.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface SMSTemplate {
    id?: string;
    companyID?: string;
    networkID?: string;
    name?: string;
    text?: string;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    createdBy?: User;
}

// go/v2/sparkpostrequests.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface SparkPostRequest {
    id?: string;
    userID?: string;
    customerEmailID?: string;
    sentEmailID?: string;
    body?: unknown;
    email?: string;
    type?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    user?: User;
}

// go/v2/stages.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface Stage {
    id?: string;
    name?: string;
    stageIDSHA3224?: string;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    createdBy?: User;
    translations?: StageTranslation[];
}

// go/v2/stagetranslations.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface StageTranslation {
    id?: string;
    stageID?: string;
    language?: string;
    name?: string;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    createdBy?: User;
}

// go/v2/states.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface State {
    id?: StateID;
    countryID?: CountryID;
    name?: string;
    stateCode?: string;
    apo?: boolean;
    international?: boolean;
    active?: boolean;
    created?: string;
    updated?: string;
}
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const StateID = {
    STATE_DISTRICT_OF_COLUMBIA: 8,
    STATE_FLORIDA: 9,
    STATE_PUERTO_RICO: 55,
    STATE_GUAM: 53,
    STATE_US_VIRGIN_ISLANDS: 56,
    STATE_AMERICAN_SAMOA: 52,
    STATE_NORTHERN_MARIANA_ISLANDS: 54,
    STATE_ARMED_FORCES_EUROPE: 140,
    STATE_JIANGSU: 114,
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type StateID = typeof StateID[keyof typeof StateID];

// go/v2/stockitemcategory.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface StockItemCategory {
    id?: string;
    name?: string;
}

// go/v2/stockitemimages.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface StockItemImage {
    id?: string;
    networkID?: string;
    path?: string;
    name?: string;
    description?: string;
    files?: StockItemImageFiles;
    totalSize?: number;
    main?: string;
    thumbnail?: string;
    image?: Image;
    stockItem?: StockItem;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface StockItemImageFiles {
    Original?: StockItemImageFile;
    Raster?: StockItemImageFile;
    Thumbnail?: StockItemImageFile;
    Small?: StockItemImageFile;
    Medium?: StockItemImageFile;
    Large?: StockItemImageFile;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface StockItemImageFile {
    File: string;
    Mime: string;
    Size: number;
    Width: number;
    Height: number;
}

// go/v2/stockitems.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface StockItem {
    id?: string;
    name?: string;
    pluralName?: string;
    description?: string;
    stockItemImageID?: string;
    weight?: string;
    size?: string;
    price?: string;
    quantity?: number;
    backorder?: boolean;
    quantityPricing?: Record<number, string>;
    body?: string;
    stockItemCategoryID?: string;
    tags?: string[];
    permalink?: string;
    published?: boolean;
    publishedTime?: string;
    updated?: string;
    created?: string;
    createdByUserID?: string;
    updatedByUserID?: string;
    validFrom?: string;
    validUntil?: string;
    version?: number;
    stockItemCategory?: StockItemCategory;
    stockItemImage?: StockItemImage;
    cartItems?: CartItem[];
    realm?: Realm;
}
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const StockItemID = {
    STOCK_ITEM_CHRISTMAS_ORNAMENT: 'Ee1l6m74JJSWWQJCrBIABA',
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type StockItemID = typeof StockItemID[keyof typeof StockItemID];
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface QuantityPrice {
    quantity: number;
    price: string;
}

// go/v2/stockitemuploads.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface StockItemUpload {
    id?: string;
    stockItemID?: string;
    uploadID?: number;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    stockItem?: StockItem;
    upload?: Upload;
    createdBy?: User;
}

// go/v2/system.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface FullProcessList {
    id?: number;
    user?: string;
    host?: string;
    db?: string;
    command?: string;
    time?: number;
    state?: string;
    info?: string;
    rowsSent?: number;
    rowsExamined?: number;
}

// go/v2/tableviews.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface TableView {
    id?: string;
    name?: string;
    page?: string;
    query?: string;
    sort?: string;
    visibleColumns?: string[];
    pageSize?: number;
    shared?: boolean;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    createdBy?: User;
}

// go/v2/textcategories.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface TextCategory {
    id?: string;
    name?: string;
    optional?: boolean;
    createdByUserID?: string;
    created?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
    createdBy?: User;
    rowCreatedBy?: User;
}

// go/v2/textmessages.go
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const TextMessagesStateValue = {
    TEXT_MESSAGES_STATE_ON: 'on',
    TEXT_MESSAGES_STATE_OFF: 'off',
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type TextMessagesStateValue = typeof TextMessagesStateValue[keyof typeof TextMessagesStateValue];
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface TextMessagesUpdate {
    state?: TextMessagesStateValue;
    categories?: Record<string, boolean>;
}
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const TextMessageSenderKind = {
    TEXT_MESSAGE_SENDER_CUSTOMER: 'customer',
    TEXT_MESSAGE_SENDER_STAFF: 'staff',
    TEXT_MESSAGE_SENDER_AI: 'ai',
    TEXT_MESSAGE_SENDER_SYSTEM: 'system',
    TEXT_MESSAGE_SENDER_AUTO_REPLY: 'autoReply',
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type TextMessageSenderKind = typeof TextMessageSenderKind[keyof typeof TextMessageSenderKind];
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface TextMessageContext {
    data?: unknown;
    ids?: NodeContextIDs;
}

// go/v2/textservices.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface TextService {
    id?: string;
    name?: string;
    createdByUserID?: string;
    created?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
    createdBy?: User;
    rowCreatedBy?: User;
}

// go/v2/texttemplatenames.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface TextTemplateName {
    id?: string;
    name?: string;
    createdByUserID?: string;
    created?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
    createdBy?: User;
    rowCreatedBy?: User;
}

// go/v2/texttemplates.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface TextTemplate {
    id?: string;
    networkID?: string;
    companyID?: string;
    textTemplateNameID?: string;
    textCategoryID?: string;
    text?: string;
    createdByUserID?: string;
    created?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
    network?: Network;
    realm?: Realm;
    templateName?: TextTemplateName;
    category?: TextCategory;
    createdBy?: User;
    rowCreatedBy?: User;
}

// go/v2/unsubscribedemails.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface UnsubscribedEmail {
    id?: string;
    companyID?: string;
    email?: string;
    active?: boolean;
    created?: string;
    updated?: string;
}

// go/v2/uploaddetails.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface UploadDetail {
    id?: string;
    uploadID?: number;
    name?: string;
    value?: unknown;
    createdByUserID?: string;
    updatedByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface UploadDetails {
    lineItem?: string;
    type?: string;
    size?: string;
    plating?: string;
    edge?: string;
    industry?: string;
    attachment?: string;
    lanyardColor?: string;
    manufacturingLocation?: string;
    generatedDescription?: string;
}

// go/v2/uploadrekognitionlabels.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface UploadRekognitionLabel {
    id?: number;
    uploadID?: number;
    label?: string;
    moderation?: boolean;
    confidence?: number;
    active?: boolean;
    created?: string;
    updated?: string;
    upload?: Upload;
    rekognitionLabel?: RekognitionLabel;
}

// go/v2/uploads.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface Upload {
    id?: number;
    originalUploadID?: number;
    companyID?: string;
    name?: string;
    mime?: string;
    tmpKey?: string;
    key?: string;
    size?: number;
    'sha3-224'?: string;
    region?: string;
    text?: string;
    hasRekognition?: boolean;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    tags?: string[];
    company?: Realm;
    createdBy?: User;
    uploadRekognitionLabels?: UploadRekognitionLabel[];
    uploadTags?: UploadTag[];
    uploadDetailRows?: UploadDetail[];
    uploadDetails?: UploadDetails;
    publicURL?: string;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface KeepUploadsResponse {
    files: KeepUploadsFile[];
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface KeepUploadsFile {
    uploadID: number;
    url: string;
    mime: string;
    name: string;
    sourceURL?: string;
}

// go/v2/uploadtags.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface UploadTag {
    id?: string;
    uploadID?: number;
    tag?: string;
    tagMurmur?: number;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    upload?: Upload;
    createdBy?: User;
}

// go/v2/useradminroles.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface UserAdminRole {
    id?: string;
    userID?: string;
    adminRoleID?: AdminRoleID;
    active?: boolean;
    created?: string;
    updated?: string;
    user?: User;
    adminRole?: AdminRole;
}

// go/v2/userassociations.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface UserAssociation {
    id?: string;
    userID?: string;
    associatedUserID?: string;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    user?: User;
    associatedUser?: User;
    createdBy?: User;
}

// go/v2/userbalancetransactions.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface UserBalanceTransaction {
    id?: string;
    userID?: string;
    companyID?: string;
    orderID?: string;
    type?: string;
    amount?: string;
    memo?: string;
    createdByUserID?: string;
    created?: string;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
}

// go/v2/usercompanies.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface UserCompany {
    id?: string;
    userID?: string;
    companyID?: string;
    dateTimeAdded?: string;
    company?: Realm;
}

// go/v2/userdetails.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface UserDetail {
    id?: string;
    userID?: string;
    name?: string;
    value?: string;
    json?: unknown;
    active?: boolean;
    created?: string;
    updated?: string;
}
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const HeardAboutUs = {
    HEARD_ABOUT_US_SEARCH: 'SEARCH',
    HEARD_ABOUT_US_AI_ASSISTANT: 'AI_ASSISTANT',
    HEARD_ABOUT_US_SOCIAL_MEDIA: 'SOCIAL_MEDIA',
    HEARD_ABOUT_US_FRIEND: 'FRIEND',
    HEARD_ABOUT_US_REPEAT_CUSTOMER: 'REPEAT_CUSTOMER',
    HEARD_ABOUT_US_EVENT: 'EVENT',
    HEARD_ABOUT_US_MAIL: 'MAIL',
    HEARD_ABOUT_US_OTHER: 'OTHER',
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type HeardAboutUs = typeof HeardAboutUs[keyof typeof HeardAboutUs];
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface HeardAboutUsAnswer {
    heardAboutUs: HeardAboutUs;
    heardAboutUsOther?: string;
}

// go/v2/usereventimages.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface UserEventImage {
    id?: string;
    userEventID?: string;
    imageID?: string;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    image?: Image;
}

// go/v2/usereventreads.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface UserEventRead {
    id?: string;
    userEventID?: string;
    userID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
}

// go/v2/userevents.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface UserEvent {
    buuid?: string;
    id?: string;
    userID?: string;
    userEventTypeID?: UserEventTypeID;
    quoteRequestProjectTaskID?: string;
    content?: string;
    contentType?: string;
    icon?: string;
    color?: string;
    pinned?: boolean;
    automated?: boolean;
    remind?: string;
    orderNotes?: boolean;
    friday?: boolean;
    small?: boolean;
    phoned?: boolean;
    customerRequest?: boolean;
    hiddenForArtists?: boolean;
    point?: UserEventPoint;
    pointNumber?: number;
    createdByUserID?: string;
    companyID?: string;
    created?: string;
    updated?: string;
    edited?: string;
    updatedByUserID?: string;
    active?: boolean;
    textContent?: string;
    userEventImages?: UserEventImage[];
    userEventUploads?: UserEventUpload[];
    company?: Realm;
    user?: User;
    createdBy?: User;
    updatedBy?: User;
    fromAdmin?: boolean;
    flagID?: FlagID;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface UserEventPoint {
    x: number;
    y: number;
}
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const UserEventTypeID = {
    USER_EVENT_TYPE_NONE: 0,
    USER_EVENT_TYPE_COMMENT: 1,
    USER_EVENT_TYPE_FLAG: 2,
    USER_EVENT_TYPE_REMOVED_USER_ASSOCIATION: 3,
    USER_EVENT_TYPE_FOLLOW_UP: 4,
    USER_EVENT_TYPE_CREDIT_CARD_DECLINED: 5,
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type UserEventTypeID = typeof UserEventTypeID[keyof typeof UserEventTypeID];

// go/v2/usereventuploads.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface UserEventUpload {
    id?: string;
    userEventID?: string;
    uploadID?: number;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    upload?: Upload;
}

// go/v2/userfactories.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface UserFactory {
    id?: number;
    factoryID?: string;
    originalFactoryID?: string;
    userID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    factory?: Factory;
}

// go/v2/usermanagingcompanies.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface UserManagingCompany {
    id?: string;
    managingCompanyID?: string;
    userID?: string;
    created?: string;
    active?: boolean;
    managingCompany?: ManagingCompany;
}

// go/v2/usernetworks.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface UserNetwork {
    id?: string;
    userID?: string;
    networkID?: string;
    created?: string;
    network?: Network;
}

// go/v2/userorderbids.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface UserOrderBid {
    id?: string;
    userID?: string;
    orderID?: string;
    factoryID?: string;
    originalFactoryID?: string;
    read?: boolean;
    submitted?: boolean;
    ignored?: boolean;
    factoryConfirmedShipDate?: string;
    accepted?: string;
    cachedCost?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    userOrderLineItemBids?: UserOrderLineItemBid[];
    userOrderChildLineItemBids?: UserOrderChildLineItemBid[];
    order?: Order;
    user?: User;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface FactoryBiddingStat {
    factoryID?: string;
    originalFactoryID?: string;
    avgWeightedShippedAfterConfirmed?: number;
    preferred?: FactoryPreferred;
    exclusions?: FactoryPreferred;
    exclusionsJS?: string;
    paused?: boolean;
    estimatedCapacity?: number;
    estimatedOrderCapacity?: number;
    medianShipDays?: number;
    hasShipHistory?: boolean;
    piecesInFlight?: number;
    piecesInFlight24h?: number;
    piecesInFlightToday?: number;
    ordersInFlight?: number;
    ordersInFlight24h?: number;
    ordersInFlightToday?: number;
    mistakePercent?: number;
    raisedCostPercent?: number;
    weightedDayDiff?: number;
    countryID?: CountryID;
    kind?: string;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface FactoryMetricPeerRank {
    rank: number;
    percentile: number;
    peerCount: number;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface FactoryBiddingStatCompared {
    capacityHeadroom: number;
    mistakePercentRank: FactoryMetricPeerRank;
    raisedCostPercentRank: FactoryMetricPeerRank;
    avgWeightedShippedAfterConfirmedRank: FactoryMetricPeerRank;
    weightedDayDiffRank: FactoryMetricPeerRank;
    capacityHeadroomRank: FactoryMetricPeerRank;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface BidScoreReason {
    reason: string;
    add: number;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface BidSelectionCandidate {
    factoryID?: string;
    isFake?: boolean;
    sourceFactoryID?: string;
    cachedCost?: string;
    score?: number;
    scoreReasons?: BidScoreReason[];
    excluded?: boolean;
    excludedReason?: string;
    skippedPass1?: boolean;
    pass1Reason?: string;
    skippedPass2?: boolean;
    pass2Reason?: string;
    winner?: boolean;
}

// go/v2/userorderchildlineitembids.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface UserOrderChildLineItemBid {
    id?: string;
    userOrderBidID?: string;
    orderChildLineItemID?: string;
    cost?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    orderChildLineItem?: OrderChildLineItem;
}

// go/v2/userorderlineitembids.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface UserOrderLineItemBid {
    id?: string;
    userOrderBidID?: string;
    orderLineItemID?: string;
    cost?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    orderLineItem?: OrderLineItem;
}

// go/v2/userquoteimages.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface UserQuoteImage {
    id?: string;
    userID?: string;
    imageID?: string;
    uploadID?: number;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    user?: User;
    image?: Image;
    createdBy?: User;
}

// go/v2/userquoterequestreads.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface UserQuoteRequestRead {
    id?: string;
    userID?: string;
    quoteRequestID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    user?: User;
    quoteRequest?: QuoteRequest;
}

// go/v2/userquotesccs.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface UserQuotesCC {
    id?: string;
    userID?: string;
    email?: string;
    sortOrder?: number;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    user?: User;
    createdBy?: User;
}

// go/v2/userquotesemails.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface UserQuotesEmail {
    id?: string;
    userID?: string;
    email?: string;
    sortOrder?: number;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    user?: User;
    createdBy?: User;
}

// go/v2/userroleoptions.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface UserRoleOption {
    id?: number;
    name?: string;
    sortOrder?: number;
    active?: boolean;
    created?: string;
    updated?: string;
}

// go/v2/users.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface User {
    id?: string;
    companyID?: string;
    salesTeamID?: string;
    originalSalesTeamID?: string;
    pageRequestID?: string;
    uploadID?: number;
    imageID?: string;
    quoteMessageID?: string;
    linkID?: string;
    networkID?: string;
    countryID?: CountryID;
    stateID?: StateID;
    email?: string;
    emailAddressID?: string;
    emailSHA3_224?: string;
    phone?: string;
    phoneNumberID?: string;
    phoneRFC3966?: string;
    firstName?: string;
    lastName?: string;
    company?: string;
    balance?: string;
    about?: string;
    folder?: string;
    color?: string;
    signature?: string;
    tz?: string;
    language?: string;
    listID?: string;
    ip?: string;
    facebookAccessToken?: string;
    facebookUserID?: string;
    facebookUsername?: string;
    twitterUsername?: string;
    googlePlusUsername?: string;
    linkedInUsername?: string;
    darkMode?: boolean;
    allowHTML?: boolean;
    sms?: boolean;
    emails?: number;
    permissions?: string[];
    quotesName?: string;
    quotesEmails?: string;
    quotesCCs?: string;
    quotesMessage?: string;
    quotesContentType?: string;
    quotesSubject?: string;
    passwordHash?: string;
    passwordVersion?: number;
    loginToken?: string;
    activationKey?: string;
    saveID?: string;
    dateTimeAdded?: string;
    dateTimeSynced?: string;
    dateTimeOnline?: string;
    lastAccessed?: string;
    proxyCDNsUntil?: string;
    contactedRX?: string;
    contactedTX?: string;
    lastCustomerContact?: string;
    helpScoutUserID?: number;
    qboCustomerID?: string;
    qboSync?: boolean;
    denormCustomer?: string;
    denormName?: string;
    denormLatestInvoiceDateTimeAdded?: string;
    denormInvoiceCount?: number;
    denormQuoteLatestAdded?: string;
    denormEmailMurmur3_32?: number;
    denormAB?: boolean;
    denormPhoneRFC3966Murmur3_32?: number;
    denormContacted?: string;
    denormLatestQuoteSentID?: string;
    denormContactedDiff?: number;
    denormEmailDomainMurmur?: number;
    denormEmailDomain?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    realm?: Realm;
    country?: Country;
    state?: State;
    emailAddress?: EmailAddress;
    phoneNumber?: PhoneNumber;
    upload?: Upload;
    image?: Image;
    salesTeam?: SalesTeam;
    quoteMessage?: QuoteMessage;
    userDetails?: UserDetails;
    contacts?: Contact[];
    quoteRequests?: QuoteRequest[];
    quoteRequestProjects?: QuoteRequestProject[];
    orders?: Order[];
    userAdminRoles?: UserAdminRole[];
    userFactories?: UserFactory[];
    userNetworks?: UserNetwork[];
    userCompanies?: UserCompany[];
    userManagingCompanies?: UserManagingCompany[];
    salesTeamUsers?: SalesTeamUser[];
    flagFlags?: FlagFlag[];
    userQuotesEmails?: UserQuotesEmail[];
    userQuotesCCs?: UserQuotesCC[];
    userQuoteImages?: UserQuoteImage[];
    userEvents?: UserEvent[];
    pageRequests?: PageRequest[];
    userAssociations?: UserAssociation[];
    shippingOptions?: ShippingOption[];
    paymentOptions?: PaymentOption[];
    rawUserDetails?: UserDetail[];
    userRoleOptionID?: number;
    userRoleOptionNotes?: string;
    userRoleOption?: UserRoleOption;
    hubSpotCompanyID?: number;
    hubSpotContactID?: number;
    hubSpotSynced?: string;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface UserDetails {
    activationKey?: string;
    iapDefaultQuotesPage?: string;
    ignoreArtistStats?: string;
    startDate?: string;
    hoursWorkedPerWeek?: string;
    textMessageCategoryOptOuts?: string[];
    emailCategoryOptOuts?: string[];
    podiumSenderUid?: string;
    emailAlias?: string;
    heardAboutUs?: HeardAboutUs;
    heardAboutUsOther?: string;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface UserDetailsMod {
    iapDefaultQuotesPage?: string;
    ignoreArtistStats?: string;
    startDate?: string;
    hoursWorkedPerWeek?: string;
    podiumSenderUid?: string;
    emailAlias?: string;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface CustomerUserUpdate {
    firstName?: string;
    lastName?: string;
    company?: string;
    email?: string;
    phone?: string;
    tz?: string;
    language?: string;
    password?: string;
    notificationPreferences?: NotificationPreferencesUpdate;
}

// go/v2/usertaxexemptionapprovals.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface UserTaxExemptionApproval {
    id?: string;
    userTaxExemptionID?: string;
    level?: number;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    createdBy?: User;
}

// go/v2/usertaxexemptionorders.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface UserTaxExemptionOrder {
    id?: string;
    userTaxExemptionID?: string;
    orderID?: string;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    createdBy?: User;
    order?: Order;
    userTaxExemption?: UserTaxExemption;
}

// go/v2/usertaxexemptionreasons.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface UserTaxExemptionReason {
    id?: UserTaxExemptionReasonID;
    name?: string;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    createdBy?: User;
}
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const UserTaxExemptionReasonID = {
    USER_TAX_EXEMPTION_REASON_ENTITY_EXEMPT: 1,
    USER_TAX_EXEMPTION_REASON_GOVERNMENT_EXEMPTION: 2,
    USER_TAX_EXEMPTION_REASON_WHOLESALE_OR_RETAIL_EXEMPTION: 3,
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type UserTaxExemptionReasonID = typeof UserTaxExemptionReasonID[keyof typeof UserTaxExemptionReasonID];

// go/v2/usertaxexemptions.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface UserTaxExemption {
    id?: string;
    userID?: string;
    userTaxExemptionReasonID?: UserTaxExemptionReasonID;
    countryID?: CountryID;
    stateID?: StateID;
    number?: string;
    label?: string;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    user?: User;
    userTaxExemptionReason?: UserTaxExemptionReason;
    userTaxExemptionOrders?: UserTaxExemptionOrder[];
    userTaxExemptionUploads?: UserTaxExemptionUpload[];
    userTaxExemptionApprovals?: UserTaxExemptionApproval[];
    country?: Country;
    state?: State;
    createdBy?: User;
}

// go/v2/usertaxexemptionuploads.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface UserTaxExemptionUpload {
    id?: string;
    userTaxExemptionID?: string;
    uploadID?: number;
    createdByUserID?: string;
    active?: boolean;
    created?: string;
    updated?: string;
    createdBy?: User;
    upload?: Upload;
}

// go/v2/workflowevents.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface WorkflowEvent {
    id?: string;
    workflowID?: string;
    nodeFlowInstanceID?: string;
    medium?: WorkflowMedium;
    emailID?: string;
    emailVersion?: number;
    emailConversationID?: string;
    emailConversationVersion?: number;
    textMessageID?: string;
    textMessageVersion?: number;
    textConversationID?: string;
    textConversationVersion?: number;
    action: WorkflowAction;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
}

// go/v2/workflows.go
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const WorkflowActionKind = {
    WORKFLOW_ACTION_CLOSE: 'close',
    WORKFLOW_ACTION_TAGS: 'tags',
    WORKFLOW_ACTION_CATEGORY: 'category',
    WORKFLOW_ACTION_FORWARD: 'forward',
    WORKFLOW_ACTION_REPLY: 'reply',
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type WorkflowActionKind = typeof WorkflowActionKind[keyof typeof WorkflowActionKind];
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const WorkflowMedium = {
    WORKFLOW_MEDIUM_EMAIL: 'email',
    WORKFLOW_MEDIUM_TEXT: 'text',
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type WorkflowMedium = typeof WorkflowMedium[keyof typeof WorkflowMedium];
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface WorkflowAction {
    kind: WorkflowActionKind;
    addTags?: string[];
    removeTags?: string[];
    categoryID?: string;
    to?: string[];
    text?: string;
}
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const WorkflowTrigger = {
    WORKFLOW_TRIGGER_EMAIL_RECEIVED: 'emailReceived',
    WORKFLOW_TRIGGER_TEXT_RECEIVED: 'textReceived',
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type WorkflowTrigger = typeof WorkflowTrigger[keyof typeof WorkflowTrigger];
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const WorkflowConditionField = {
    WORKFLOW_CONDITION_FROM: 'from',
    WORKFLOW_CONDITION_PARTICIPANT: 'participant',
    WORKFLOW_CONDITION_SUBJECT: 'subject',
    WORKFLOW_CONDITION_CONTENT: 'content',
    WORKFLOW_CONDITION_REALM: 'realm',
    WORKFLOW_CONDITION_CATEGORY: 'category',
    WORKFLOW_CONDITION_SCOPE_ID: 'scopeID',
    WORKFLOW_CONDITION_PHONE: 'phone',
    WORKFLOW_CONDITION_FROM_NUMBER: 'fromNumber',
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type WorkflowConditionField = typeof WorkflowConditionField[keyof typeof WorkflowConditionField];
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface Workflow {
    id?: string;
    companyID?: string;
    name?: string;
    medium?: WorkflowMedium;
    trigger?: WorkflowTrigger;
    conditions: string;
    actions: WorkflowAction[];
    enabled?: boolean;
    version?: number;
    latest?: boolean;
    expired?: boolean;
    rowCreatedByUserID?: string;
    rowCreated?: string;
    rowModified?: string;
    created?: string;
    createdByUserID?: string;
    realm?: Realm;
    createdBy?: User;
    nodeFlowID?: string;
    nodeFlow?: NodeFlow;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface WorkflowUpdate {
    version: number;
    companyID?: string;
    name?: string;
    conditions?: string;
    actions?: WorkflowAction[];
    enabled?: boolean;
    expired?: boolean;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface WorkflowUpdateWithID {
    id: string;
}

// go/log/log.go
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface LogEntry {
    id?: number;
    ip?: string;
    description?: string;
    meta?: string;
    level?: LogLevel;
    options?: LogOptions;
    createdByUserID?: string;
    created?: string;
    user?: LogUser;
    adminLink?: string;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface LogUser {
    id?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    upload?: LogUserUpload;
}
/**
 * @deprecated Use models from 'smg/customer-api/models' or 'smg/admin/models'
 */
export declare interface LogUserUpload {
    key?: string;
}
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const LogLevel = {
    LOG_LEVEL_INFO: 0,
    LOG_LEVEL_NOTICE: 1,
    LOG_LEVEL_WARN: 2,
    LOG_LEVEL_ERROR: 3,
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type LogLevel = typeof LogLevel[keyof typeof LogLevel];
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export const LogOptions = {
    LOG_OPTION_MARKDOWN: 1<<1,
    LOG_OPTION_HTML: 1<<3,
    LOG_OPTION_S_3: 1<<4,
    LOG_OPTION_GZIP: 1<<5,
    LOG_OPTION_CLIENT_SIDE: 1<<6,
} as const;
/** @deprecated Use enums from 'smg/customer-api/models' or 'smg/admin/models' */
export type LogOptions = typeof LogOptions[keyof typeof LogOptions];
